// const SERVER_URL = '127.0.0.1:19180/api';

export default {
    data: {
        authenticated: false
    },

    //登录
    login(context, info) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/login', info).then(function(res) {
            let err = res.body.error;
            console.log('login:', res);
            if (err === 0) {
                sessionStorage.setItem('token', 'Header:' + res.bodyText);
                sessionStorage.setItem('uid', res.data.uid);
                sessionStorage.setItem('userType', res.data.user_type);
                sessionStorage.setItem('username', res.data.username);
                let country = res.data.country;
                if (country === 'FR' || country === 'DE' || country === 'IT' || country === 'PT' || country === 'ES' || country === 'TR' || country === 'AE' || country === 'Ro' || country === 'PL') {
                    localStorage.setItem('unit', 'mg');
                } else {
                    localStorage.setItem('unit', 'mmol');
                }
                if ('admin_login' == res.data.flag) {
                    this.$router.push('CreateHCP');
                    return;
                }
                if ('clinic_login' == res.data.flag) {
                    this.$router.push('ClinicPatientList');
                    return;
                }
                if (res.data.user_type === 'D') {
                    this.$router.push('PatientList');
                    let unread = res.data.unread_message;
                    context.$store.commit('updateUnRead', unread);
                }
                if (res.data.user_type === 'P') {
                    this.$router.push('monitor');
                    let unread = res.data.connection_request;
                    context.$store.commit('updateUnRead', unread);
                }
                if (res.data.user_type === 'M') {
                    this.$router.push('carerConnection');
                    let unread = res.data.unread_message;
                    context.$store.commit('updateUnRead', unread);
                }
            } else if (52 == err) {
                this.$message.error('Your account is not approved.');
            }
            if (err === 2) {
                let tip = context.$t('userNotExist');
                context.$message.error(tip);
            }
            if (err === 9) {
                let tip = context.$t('Password incorrect');
                context.$message.error(tip);
            }
            if (err === 10) {
                let tip = context.$t('UserType incorrect');
                context.$message.error(tip);
            }
        }, function(err) {
            console.log(err + "," + err.body.message);
            context.error = err.body.message
        })
    },
    //获取头像
    getPortrait(context, uid) {
        //console.log(uid);
        context.$http.get(SERVER_URL + '/v2.0/person/' + uid + '/portrait').then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                //alert('add succeed')
            }
        })
    },

    //个人信息
    getProfile(context) {
        let that = this;
        context.$http.get(SERVER_URL + '/v2.0/person/profile').then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                let profile = res.data.profile;
                that.initProfile2(context, profile);
                context.profile = profile;
            }
        })
    },
    modifyPersonProfile(context, profile) {
        let that = this;
        let user = sessionStorage.getItem('userType');
        context.$http.post(SERVER_URL + '/v2.0/person/profile', { profile }).then(function(res) {
            let err = res.body.error;
            //console.log(res.body);
            if (err === 0) {
                let tip = context.$t('saveTip');
                context.$message({
                    type: 'success',
                    message: tip
                });
                if (user === 'P') { context.$router.push('/monitor'); }
                if (user === 'D') { context.$router.push('/PatientList'); }
                if (user === 'M') { context.$router.push('/carerConnection'); }
            } else {
                let tip = context.$t('Input error');
                context.$message.error(tip);
            }
        })
    },
    getMessages(context, uid) {
        let that = this;
        context.$http.get(SERVER_URL + '/v2.0/messages').then(function(res) {
            let err = res.body.error;
            // console.log(res)
            if (err === 0) {
                context.messages = res.data.data.map(function(e, i) {
                    if (e[1].message_type === 'RELATION_AUTH_PERMIT') {
                        e[1] = e[1].username + context.accept;
                    } else if (e[1].message_type === 'RELATION_AUTH_CANCEL') {
                        e[1] = e[1].username + context.cancel;
                    } else {
                        e[1] = e[1].username + context.reject;
                    }
                    if (context.isZh) {
                        e[2] = that.formateDate(new Date(e[2] * 1000));
                    } else {
                        let time = new Date(e[2] * 1000 + 8 * 3600000).toUTCString();
                        let sp1 = time.split(',');
                        let sp2 = sp1[1].split(' ');
                        let sp3 = sp2[4].split(':');
                        e[2] = sp2[2] + ' ' + sp2[1] + ' ' + sp2[3] + ', at ' + sp3[0] + ':' + sp3[1];
                    }
                    e[4] = '/api/v2.0/person/' + parseInt(e[4]) + '/portrait';
                    return e;
                })
                if (context.messages.length === 0) {
                    context.noMes = true;
                }
            }
        })
    },
    getUnread(context) {
        context.$http.get('api/v2.0/messages/unread').then(function(res) {
            let err = res.body.error;
            // console.log(res)
            if (err === 0) {
                let count = res.data.count;
                context.$store.commit('updateUnRead', count);
            }
        })
    },
    getUnread1(context) {
        context.$http.get('api/v2.0/relations/auth/todo').then(function(res) {
            let err = res.body.error;
            //console.log(res)
            if (err === 0) {
                let count = res.data.count;
                context.$store.commit('updateUnRead', count);
            }
        })
    },

    //患者信息
    goPatientProfile(context, uid) {
        context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function(res) {
            let err = res.body.error;
            //确定跳转到哪个页面
            if (err === 0) {
                let profile = res.data.profile;
                if (profile.created_by === 'register') {
                    this.$router.push('/patientProfile2');
                } else {
                    this.$router.push('/patientProfile');
                }
            }
        })
    },
    //患者信息
    goClinicPatientProfile(context, uid) {
        context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function(res) {
            let err = res.body.error;
            //确定跳转到哪个页面
            if (err === 0) {
                let profile = res.data.profile;
                if (profile.created_by === 'register') {
                    this.$router.push('/clinic_patientProfile2');
                } else {
                    this.$router.push('/clinic_patientProfile');
                }
            }
        })
    },
    getPatientProfile2(context, uid) {
        let that = this;
        context.$http.get(SERVER_URL + '/v2.0/patients/' + uid + '/profile').then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let profile = res.data.profile;
                if (profile.created_by === 'register') {
                    that.initProfile(context, profile);
                } else {
                    that.initProfile2(context, profile);
                }
                context.profile = profile;
                context.alias = (profile.alias) ? profile.alias : profile.realname;
            }
        })
    },
    getPatientProfile3(context, uid) {
        let that = this;
        context.$http.get(SERVER_URL + '/v2.0/monitor/' + uid + '/profile').then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let profile = res.data.profile;
                that.initProfile(context, profile);
                context.alias = (profile.alias) ? profile.alias : profile.realname;
                context.profile = profile;
            }
        })
    },
    initProfile(context, val) {
        val.username = (val.username) ? val.username : '--';
        val.realname = (val.realname) ? val.realname : '--';
        val.gender = (val.gender) ? context.$t(val.gender) : '--';
        val.height = (val.height) ? val.height + 'cm' : '--';
        val.weight = (val.weight) ? val.weight + 'kg' : '--';
        val.diabetes_type = (val.diabetes_type) ? context.$t(val.diabetes_type) : '--';
        val.address = (val.address) ? val.address : '--';
        val.zipcode = (val.zipcode) ? val.zipcode : '--';
        val.mobile = (val.mobile) ? val.mobile : '--';
        val.telephone = (val.telephone) ? val.telephone : '--';
        val.email = (val.email) ? val.email : '--';
        val.date = (val.date) ? val.date : '--';
        val.birthday = (val.birthday) ? val.birthday : '--';
        val.diabetes_diagnosis_date = (val.diabetes_diagnosis_date) ? val.diabetes_diagnosis_date : '--';
    },
    initProfile2(context, val) {
        console.log('initProfile2:', val);
        val.username = (val.username) ? val.username : ' ';
        val.realname = (val.realname) ? val.realname : '';
        val.gender = (val.gender) ? val.gender : '';
        val.height = (val.height) ? val.height : '';
        val.weight = (val.weight) ? val.weight : '';
        val.diabetes_type = (val.diabetes_type) ? val.diabetes_type : '';
        val.address = (val.address) ? val.address : '';
        val.zipcode = (val.zipcode) ? val.zipcode : '';
        val.mobile = (val.mobile) ? val.mobile : '';
        val.telephone = (val.telephone) ? val.telephone : '';
        val.email = (val.email) ? val.email : '';
        val.date = (val.date) ? val.date : '';
        val.serve_for = (val.serve_for) ? val.serve_for : '';
        val.major = (val.major) ? val.major : '';
        val.birthday = (val.birthday) ? val.birthday : '';
        context.birthdayShow = val.birthday;
        val.diabetes_diagonosis_date = (val.diabetes_diagonosis_date) ? val.diabetes_diagonosis_date : '';
        context.disDateShow = val.diabetes_diagonosis_date;
    },
    modifyPatientProfile(context, pid, profile) {
        context.$http.post(SERVER_URL + '/v2.0/patients/' + pid + '/profile', { profile }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('saveTip');
                context.$message({
                    type: 'success',
                    message: tip
                });
                if (profile.alias) {
                    sessionStorage.setItem('patientName', profile.alias);
                    this.$store.commit('updatePatientName', profile.alias);
                } else {
                    sessionStorage.setItem('patientName', profile.realname);
                    this.$store.commit('updatePatientName', profile.realname);
                }
                context.$router.push('monitor');
            }
        })
    },
    modifyPatientProfile2(context, pid, profile) {
        context.$http.post('api/v2.0/monitor/' + pid + '/settings', profile).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('saveTip');
                context.$message({
                    type: 'success',
                    message: tip
                });
                context.$router.push('/carerConnection');
            } else {
                let tip = context.$t('modifyFailed');
                context.$message.error(tip);
            }
        })
    },

    //获取用户列表
    getUserList(context, info) {
        let that = this;
        context.$http.get(SERVER_URL + '/v2.0/patients', { params: info }).then(function(data) {
            let err = data.body.error;
            //console.log(data);
            if (err === 0) {
                let isZh = (sessionStorage.getItem('language') === 'zh') ? true : false;
                let dataObj = data.body.patients;
                let users = dataObj.items.map(function(e, i) {
                    e.gender = context.$t(e.gender);
                    e.diabetes_type = context.$t(e.diabetes_type);
                    if (e.upload_time) {
                        let upload_time = new Date(e.upload_time * 1000);
                        e.upload_time = (isZh) ? that.formateDate(upload_time) : that.formatterDate1(upload_time);
                    }
                    if (e.created_by) {
                        e.created_by = context.$t(e.created_by);
                    }
                    if (e.created_by === context.$t('register') && e.alias) {
                        e.name = e.alias;
                    }
                    if (e.diabetes_diagnosis_date) {
                        e.diabetes_diagnosis_date = that.getDuration(context, e.diabetes_diagnosis_date);
                    }
                    //that.getPortrait(context,e.uid);
                    return e;
                });
                context.$store.commit('updateUsers', users);
                this.pages = (dataObj.pages !== 0) ? dataObj.pages : 1;
                this.has_next = dataObj.has_next;
                this.has_prev = dataObj.has_prev;
            }
            if (err === 12) {
                context.$router.push('/hcpLogin');
            }
        })
    },
    getDuration(context, val) {
        let now = new Date().setHours(0, 0, 0, 0) / 1000;
        let time = new Date(val).getTime() / 1000;
        let st = now - time;
        let y = parseInt(st / (3600 * 24 * 365));
        let m = parseInt(st % (3600 * 24 * 365) / (3600 * 24 * 30));
        let lang = localStorage.getItem('language');
        let year = (y > 1) ? context.$t('Years') : context.$t('Year');
        let month = (m > 1) ? context.$t('Months') : context.$t('Month');
        return (lang === 'zh' || lang === 'hk') ? y + ' 年 ' + m + ' 月' : y + ' ' + year + ' ' + m + ' ' + month;
    },
    //发验证码
    sendSeccode(context, info) {
        context.$http.post(SERVER_URL + '/v2.0/seccode/send', info).then(function(res) {
            let err = res.body.error;
            //console.log(res)
            if (err === 0) {
                //console.log(res.data);
                context.token = res.data.token;
            } else if (err === 1) {
                let tip = context.$t('userNotExist');
                context.$message.error(tip);
            } else {
                let tip = context.$t('tryAgain');
                context.$message.error(tip);
            }
        }, function(err) {
            console.log(err + "," + err.body.message);
            context.error = err.body.message
        })
    },
    //计时
    setTime(context) {
        let count = 60;
        var t = setInterval(function() {
            if (count === 0) {
                clearInterval(t);
                context.send = context.$t('Getcode');
                context.canClick = false;
                context.showTime = false;
                count = 10;
                if (context.tryAgain) {
                    context.tryAgain = false;
                }
            } else {
                context.canClick = true;
                context.showTime = true;
                context.time = count;
                context.send = 'S';
                if (context.tryAgain) {
                    context.tryAgain = true;
                }
                count--;
                // console.log(count);
            }
        }, 1000);
    },
    //注册
    register(context, info) {
        //console.log(info);
        context.$http.post(SERVER_URL + '/v2.0/regist', info).then(function(res) {
            let err = res.body.error;
            console.log(res)
            if (err === 0) {
                if ('yes' == info.test) {
                    context.tabA = false;
                    context.tabB = true;

                    if ('CN' == info.country || 'HKF' == info.country || 'AE' == info.country) {
                        context.isEU = false;
                    }
                } else {
                    let tip = context.$t('registSuccess');
                    context.$message({
                        type: 'success',
                        message: tip
                    });
                    this.$router.push('login');
                }

            } else if (err === 26) {
                let tip = context.$t('errtip3');
                context.$message.error(tip);
            } else {

                if ('yes' == info.test) {
                    let tip = context.$t('infoWrongTip');
                    context.$message.error(tip);
                } else {
                    let tip = context.$t('registFailed');
                    context.$message.error(tip);
                }

            }
        }, function(err) {
            if ('yes' == info.test) {
                let tip = context.$t('infoWrongTip');
                context.$message.error(tip);
            } else {
                let tip = context.$t('registFailed');
                context.$message.error(tip);
            }
        })
    },
    //HCP注册
    HcpRegister(context, info) {
        // console.log(info);
        context.$http.post(SERVER_URL + '/v2.0/hcp/apply', { 'info': info }).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            //if(err === 0){
            if ('yes' == info.test) { // 并非真正的申请请求， 只是测试申请的信息是否有效.
                //let data=res.body.data;
                let user_type = res.body.user_type;
                console.log('hcp apply:', err, user_type);

                if (0 == err) {
                    context.tabA = false;
                    context.tabB = true;
                    if ('CN' == info.country || 'HKF' == info.country || 'AE' == info.country) {
                        context.isEU = false;
                    } else {
                        context.isEU = true;
                    }
                    //
                } else if (3 == err) { // 用户名已存在
                    if ('D' == user_type) {
                        this.$message.error("User exist");
                    } else if ('P' == user_type || 'M' == user_type) {
                        context.tabA = false;
                        context.tabA1 = true;
                    }
                }

            } else { // 实际注册阶段

                let tip = context.$t('sentSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
                this.$router.push('/hcpLogin');
            }

            //}
        }, function(err) {
            let tip = context.$t('sentFailed');
            context.$message.error('Sent failed!');
        })
    },

    adjustBasalRecord(basalRecord, pumpStatus) {
        let AutoModeEnableNew = pumpStatus['AutoModeEnabledNew'];
        //if (!AutoModeEnableNew) {    // 非自动模式去除 9999 的记录
        if (1) {
            let newBasalRecord = basalRecord.filter(function(record) {
                    let recordId = record[0];
                    let recordType = record[2];
                    let recordIdSplit = recordId.split('-');
                    let filterFlag = false;
                    if (recordIdSplit[3] == '9999') {
                        if (recordIdSplit[1] == pumpStatus.serial && recordIdSplit[2] == pumpStatus.pumpId) {
                            if (AutoModeEnableNew) { // 正在自动模式， 这条记录有用
                                filterFlag = true;
                            } else { // 退出自动模式， 这条记录没用
                                filterFlag = false;
                            }
                        } else {
                            filterFlag = false;
                        }
                        return filterFlag;
                    }

                    // if (AutoModeEnableNew) {  // 历史进程的 9999 记录， 怎么处理
                    //   filterFlag = ('BAAMS' != recordType) && ('BAAME' != recordType) && ('BAAMTarget120' != recordType);
                    // } else {
                    //   filterFlag = (recordIdSplit[3] != '9999') && ('BAAMS' != recordType)
                    //   && ('BAAME' != recordType) && ('BAAMTarget120' != recordType);
                    // }
                    filterFlag = ('BAAMS' != recordType) && ('BAAME' != recordType) &&
                        ('BAAMTarget120' != recordType) && ('BAAMSnack' != recordType);
                    //console.log('filterFlag:', filterFlag, recordId, recordType);
                    return filterFlag;
                    // return (recordIdSplit[3] != '9999') && ('BAAMS' != recordType) && ('BAAME' != recordType);
                })
                // console.log('newBasalRecord:', newBasalRecord)
            basalRecord = newBasalRecord;
        }
        //return;
        let i = 0;
        for (; i < basalRecord.length - 1; i++) {
            var curEnd = basalRecord[i][1] + basalRecord[i][3];
            var nextStart = basalRecord[i + 1][1];
            // if (curEnd != nextStart) {   // 不能这样处理
            //   basalRecord[i][3] = nextStart - basalRecord[i][1];
            // }
            if (curEnd > nextStart) { // 不能超过下一条记录
                basalRecord[i][3] = nextStart - basalRecord[i][1];
            }
        }
        //var curTime=new Date.getTime()/1000;
        //if (basalRecord[basalRecord.length-1]) {
        //}
        let isSuspend = false;
        let inj_status = pumpStatus.status;
        if (0x40 <= inj_status && inj_status <= 0x4F) {
            isSuspend = true;
        }

        if (pumpStatus.basalDeliveriedTime && !isSuspend) {
            var size = basalRecord.length;
            // 调整最后一条记录的持续时间, 为什么要这样调整？
            // 先不要这么调整
            // if (basalRecord[size-1][1]+basalRecord[size-1][3] != pumpStatus.basalDeliveriedTime) {
            //   basalRecord[size-1][3] = pumpStatus.basalDeliveriedTime - basalRecord[size-1][1];
            // }
        }
        return basalRecord;
    },

    //Monitor
    getMonData(context, param, Pid) {
        let that = this;
        let now = new Date() / 1000;
        context.$http.get('/api/v2.1/monitor/' + Pid + '/status', { params: { param } }).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                let data = res.body.data;
                //res.body.data.chart.sensor_alarm.push([
                //  (new Date()).getTime()/1000 + 3600, 'High Glucose', 118 ])
                console.log('monitor status:', data); // 打印输出是异步非阻塞的， 后面的代码修改data里面的属性会影响到这里的打印输出
                //let temp_status={};
                //for (let p in data.sensor_status) {
                //  temp_status[p]=data.sensor_status;
                //}
                //console.log("temp_status:", temp_status);

                //  basal数据， 如果最后一条是暂停记录， 删掉这条记录， 从状态里面合成这条记录
                if (data.pump_status) {
                    if (0x40 <= data.pump_status.state && data.pump_status.state <= 0x4F) {
                        if (data.chart.basal && data.chart.basal.length > 0) {
                            let last_basal = data.chart.basal[data.chart.basal.length - 1];
                            if (last_basal[2].indexOf('SUS') == 0) {
                                data.chart.basal.splice(data.chart.basal.length - 1, 1);
                            }
                        }
                    } else {
                        if (data.chart.basal && data.chart.basal.length > 0) {
                            if (data.pump_status.AutoModeEnabledNew) {
                                // 自动模式时不处理。
                            } else {
                                // 如果最后一条记录的时间跟状态里面基础量的时间一样， 去掉这条记录， 从状态信息里面合成这条记录
                                let last_basal = data.chart.basal[data.chart.basal.length - 1];
                                console.log('last_basal:', last_basal, data.chart.basal);
                                if (last_basal[1] == data.pump_status.basalDeliveriedTime) {
                                    data.chart.basal.splice(data.chart.basal.length - 1, 1);
                                }
                            }

                            // 临时处理
                            let last_basal = data.chart.basal[data.chart.basal.length - 1];
                            let recordIdSplit = last_basal[0].split('-');
                            data.pump_status.pumpId = recordIdSplit[2];

                        }
                    }
                }
                //
                if (res.body.data.chart.transmtr) {
                    context.transmtr = that.getTransmtr(context, res.body.data.chart.transmtr);
                } else {
                    context.transmtr = [];
                }

                context.$store.commit('updateDataS', res.body.data.chart);

                if (false) { // 测试数据
                    //console.log('monitor sg:', res.body.data.chart);
                    console.log('monitor sg:', res.body.data.chart.sg);

                    let sgData = res.body.data.chart.sg;
                    let dataNum = sgData.length;
                    let start = 0;
                    let end = dataNum;
                    if (dataNum > 50) {
                        start = dataNum - 50;
                        end = 50;
                    }
                    for (let i = start; i < dataNum; i++) {
                        //sgData[i][1] -= 5;
                    }

                    for (let i = 0; i < end; i++) {
                        if (sgData[i][1] > 5) {
                            //sgData[i][1] -= 5;
                            sgData[i][1] += 18;
                            //if ()
                        }
                    }

                    //console.log('monitor sg:', res.body.data.chart.sg);
                }

                if (false) { // 测试数据
                    let pump_status = {
                        "wizardGlucose": 0,
                        "updateTime": 1583292987.951734,
                        "basalDuration": 150,
                        "serial": 1256630150,
                        "extendBolusSet": 0,
                        "extendBolusDuration": 0,
                        "basalType": 6,
                        "extendBolusDeliveried": 0,
                        "state": 32,
                        "bolusSet": 6.2,
                        "basalRate": 0.55,
                        "wizardType": 0,
                        "bolusType": 1,
                        "lastBolusType": 0,
                        "remainingTime": 4230.33433000048,
                        "bolusDeliveried": 1.2,
                        "wizardCorrSet": 0,
                        "anotherBolusType": 0,
                        "iob": 0,
                        "basalDeliveriedTime": 1583288321,
                        "wizardCarbSet": 0,
                        "wizardIob": 0,
                        "basalPercent": 90,
                        "wizardCarb": 0,
                        "bolusDeliveriedTime": 1583292938,
                        "rssi": -50,
                        "remainingDose": 120.95
                    };
                    let pump_status2 = {
                        "updateTime": 1583826009.216325,
                        "wizardGlucose": 160.1999931335449,
                        "basalDuration": 150,
                        "serial": 1256630150,
                        "extendBolusSet": 0.55,
                        "suspendRemainingTime": 0,
                        "extendBolusDuration": 30,
                        "basalType": 1,
                        "extendBolusDeliveried": 0,
                        "state": 32,
                        "basalDeliveried": 0.15,
                        "bolusSet": 0.85,
                        "basalRate": 0.9,
                        "wizardType": 3,
                        "bolusType": 3,
                        "suspendTime": 1583825463,
                        "lastBolusType": 0,
                        "remainingTime": 4310.39661141634,
                        "bolusDeliveried": 0.7000000000000001,
                        "wizardCorrSet": 0.4,
                        "anotherBolusType": 0,
                        "iob": 0,
                        "basalDeliveriedTime": 1583825463 + 3600,
                        "wizardCarbSet": 1,
                        "pumpId": 74,
                        "wizardIob": 0,
                        "basalPercent": 90,
                        "wizardCarb": 15,
                        "bolusDeliveriedTime": 1583825981,
                        "rssi": -58,
                        "remainingDose": 190.65
                    };

                    pump_status['updateTime'] = new Date().getTime() / 1000;
                    data.pump_status = pump_status2;
                }

                context.DataSG = that.getMoSG(context, res.body.data.chart.sg);
                //console.log('monitor DataSG:', context.DataSG);

                context.st = res.body.data.chart.st;
                context.et = res.body.data.chart.et;
                //context.$store.commit('updateBasal',that.getBasal(context,context.st,res.body.data.chart.basal));
                console.log('chart.basal:', data.chart.basal);
                let basalTotal = 0;
                let bolusTotal = 0;
                if (res.body.data.chart.basal.length > 0) {
                    let originBasal = res.body.data.chart.basal;
                    context.basal = that.adjustBasalRecord(originBasal, data.pump_status);
                    // context.basal=originBasal;

                    /*for (let i=0; i<originBasal.length; i++) {
                      basalTotal += originBasal[i][5];
                    }
                    let bs = that.getBasal2(res.body.data.chart.basal);
                    context.newBasal = bs[0];
                    context.stopBasal = bs[1];
                    let bs1 =that.getBasalSus4(context,context.st,res.body.data.chart.basal);
                    context.basal_suspend = bs1[0];
                    context.tempBasal= bs1[1];
                    context.basal_suspend2 =bs1[2];*/
                }
                if (res.body.data.chart.bolus.length > 0) {
                    //
                    let originBolus = res.body.data.chart.bolus;
                    context.bolus = originBolus;
                    //

                    /*
                    for (let i=0; i<originBolus.length; i++) {
                      bolusTotal += originBolus[i][4]+originBolus[i][6];
                    }

                    //
                    let bolus =  that.getBolus(context,context.st,res.body.data.chart.bolus);
                    //console.log(bolus);
                    context.DataBolus = bolus[0];
                    context.extend_bolus = (bolus[1][0])?bolus[1]:context.extend_bolus ;
                    */
                }

                //
                //
                let t1 = now - data.sensor_status.updateTime;
                context.sensorTime = (data.sensor_status.updateTime) ? that.formatterDate1(new Date()) : '--';
                data.sensor_status.updateTime = (data.sensor_status.updateTime) ? that.formatterDate1(new Date(data.sensor_status.updateTime * 1000)) : '--';
                that.getSensor(context, data.sensor_status);

                let t2 = now - data.pump_status.updateTime;
                context.pumpTime = (data.pump_status.updateTime) ? that.formatterDate1(new Date()) : '--';
                data.pump_status.updateTime = (data.pump_status.updateTime) ? that.formatterDate1(new Date(data.pump_status.updateTime * 1000)) : '--';
                data.pump_status.bolusSum = bolusTotal;
                data.pump_status.basalSum = basalTotal;
                that.getPump(context, data.pump_status);
                //
                if (1) { // 更新 basal的数据
                    console.log('context.basal:', context.basal);
                    context.$store.commit('updateBasal', that.getBasal(context, context.st, context.basal));
                    let bs = that.getBasal2(context.basal);
                    context.newBasal = bs[0];
                    context.stopBasal = bs[1];
                    context.autoModeBasal = bs[2];
                    context.autoModeCorrBolus = bs[3];
                    let bs1 = that.getBasalSus4(context, context.st, context.basal);
                    context.basal_suspend = bs1[0];
                    context.tempBasal = bs1[1];
                    context.basal_suspend2 = bs1[2];
                    // 把自动基础量算在内，更新基础量Y轴
                    // 计算Basal画图Y轴的最大值
                    let normalBasal = context.DataBasal;
                    let basalValue = normalBasal.map(function(e, i) {
                        return e[1];
                    })
                    let autoBasalValue = context.autoModeBasal.map(function(e, i) {
                            return e[2];
                        })
                        // console.log('basalValue:', basalValue, autoBasalValue);
                    let basalValueAll = basalValue.concat(autoBasalValue);
                    context.basalMax = that.getBasalYMax(basalValueAll);

                }
                //
                if (1) { // 更新bolus绘图的数据
                    let bolus = that.getBolus(context, context.st, context.bolus);
                    console.log('context.bolus:', context.bolus, bolus);
                    context.DataBolus = bolus[0];
                    context.extend_bolus = (bolus[1][0]) ? bolus[1] : context.extend_bolus;
                }

                //
                let alarm_display = data.chart.alarm_display;
                if (alarm_display === 'On') {
                    context.sensor_alarm = that.getAlarm2(context, res.body.data.chart.sensor_alarm, 0);
                    context.pump_alarm = that.getAlarm2(context, res.body.data.chart.pump_alarm, 1);
                }
                context.calib = that.getCalib2(res.body.data.chart.calibRecord);
                that.getSleepTime2(context, res.body.data.chart.st, res.body.data.chart.et, res.body.data.chart.sleeptime);


                //
                if (t1 > 3600) { // 过了一小时， 清空状态
                    context.sensorTime = '--';
                    that.clearSensor(context, data.sensor_status);
                    context.showCGMStatus = false;
                } else {
                    context.showCGMStatus = true;
                }
                if (t2 > 3600) {
                    context.pumpTime = '--';
                    that.clearPump(context, data.pump_status);
                }

                that.checkSgIcon(context);
                var sensor_serial = data.sensor_status.serial;
                console.log('sensor serial:', sensor_serial, typeof(sensor_serial));
                if (102000000 <= sensor_serial && sensor_serial <= 103999999) {

                } else {
                    //console.log(sensor_serial.toString(16).toUpperCase())
                    //data.sensor_status.serial=sensor_serial.toString(16).toUpperCase()
                    //data.sensor_status.serial = that.deviceSNFormat(sensor_serial)
                }
                context.$store.commit('updateSensor', data.sensor_status);
                context.$store.commit('updatePump', data.pump_status);
                if (context.chart1) {
                    context.chart1.dispose();
                    context.chart2.dispose();
                }
                context.drawCharts();

            }
        }, function(err) {
            console.log(err + "," + err.body.message);
        });
    },
    getAlarm2(context, val, flag) {
        let alarm = [];
        for (let i = 0; i < val.length; i++) {
            alarm[i] = new Array(3);
            alarm[i][0] = new Date(val[i][0] * 1000);
            if (flag === 1) {
                alarm[i][1] = 0.2;
            } else {
                alarm[i][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(1.2 * 18) : 1.2;
            }
            alarm[i][2] = context.$t(val[i][1]);
        }
        return alarm;
    },
    getCalib2(val) {
        let exe = [],
            j = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i].length > 0) {
                exe[j] = new Array(2);
                exe[j][0] = new Date(val[i][1] * 1000);
                exe[j][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[i][3] * 18) : val[i][3].toFixed(1);
                j++;
            }
        }
        return exe;
    },
    getMoSG(context, val) {
        let sg = [],
            time = [],
            type = [],
            SG = [],
            max = (context.isMg) ? 400 : 22.2;
        for (let i = 0; i < val.length; i++) {
            sg[i] = val[i][1];
            sg[i] = (sg[i] > 22.2) ? 22.2 : sg[i];
            if (sg[i] < 2.2 && (val[i][4] === 'C' || val[i][4] === 'CX' || (val[i][4] === 'NC' && val[i][1] > 0))) {
                sg[i] = 2.2;
            }
            sg[i] = (context.isMg) ? Math.round(sg[i] * 18) : sg[i].toFixed(1);
            if (val[i][4] === 'DE') {
                sg[i] = 0;
            }
            time[i] = val[i][0];
            type[i] = val[i][4];
        }
        max = (sg.length > 1) ? Math.max.apply(null, sg) : max;
        //context.sgMax = this.getsgMax1(max);
        for (let m = 0; m < sg.length; m++) {
            SG[m] = new Array(3);
            time[m] = new Date(time[m] * 1000);
            SG[m][0] = time[m];
            SG[m][1] = sg[m];
            SG[m][2] = type[m];
        }
        return SG;
    },
    getSensor(context, val) {
        let cgm_status = val.status;
        let originVal = {};
        for (var p in val) {
            originVal[p] = val[p];
        }
        // 13 - 充电中
        // 14 - 充电完成
        console.log('cgm_status:', cgm_status, originVal);
        if (13 == cgm_status || 14 == cgm_status) {
            delete val.sensorLifetimeTotalCount;
            delete val.glucose;
            delete val.glucoseRate;
            console.log('val:', val);
        }

        val.serial = (val.serial) ? this.deviceSNFormat(val.serial) : '--';
        let status = val.status;
        if (val.status === -1) {
            val.status = '--';
        } else {
            val.status = (val.status) ? context.status[val.status] : '--';
        }
        if (val.updateTime !== '--') {
            let sp = val.updateTime.split(' ');
            let sp1 = sp[0].split('-');
            let d = new Date().getDate();
            if (d === parseInt(sp1[0])) {
                context.updateTime1 = context.$t('Today') + ' ' + sp[1];
            } else if ((d - 1) === parseInt(sp1[0])) {
                context.updateTime1 = context.$t('Yesterday') + ' ' + sp[1];
            } else {
                sp1 = sp1[0] + '/' + sp1[1] + '/' + sp1[2];
                context.updateTime1 = sp1 + ' ' + sp[1];
            }
        } else {
            context.updateTime1 = '--';
        }

        // 13 - 充电中
        // 14 - 充电完成
        //if (13 != cgm_status && 14 != cgm_status) {  //
        if (true) {
            val.sensorLifetimeTotalCount = (val.sensorLifetimeTotalCount) ? this.getTime(val.sensorLifetimeTotalCount - val.sequence) : '--';
        }

        if (val.batteryPercent) {
            var b = val.batteryPercent;
            //console.log('b:'+b)
            if (b >= 0.8) {
                context.batteryIcon = '/static/battery/Battery_full.png'
            } else if (b >= 0.4) {
                context.batteryIcon = '/static/battery/Battery_three_quarters.png'
            } else if (b >= 0.2) {
                if ('TY012' == context.deviceType) {
                    context.batteryIcon = '/static/battery/Battery_half.png'
                } else {
                    context.batteryIcon = '/static/battery/Battery_half_2.png'
                }
            } else if (b >= 0.1) {
                context.batteryIcon = '/static/battery/Battery_quarter.png'
            } else {
                context.batteryIcon = '/static/battery/Battery_zero.png'
            }
        } else {
            context.batteryIcon = '/static/battery/Battery_nodata.png'
        }

        val.batteryPercent = (val.batteryPercent) ? (val.batteryPercent * 100).toFixed(1) + '%' : '--';
        let ratestatus = val.glucoseRate;
        if (ratestatus === 0 || ratestatus === 8) {
            context.sgIcon = '/static/SG ICON/Trend_smooth.png';
        }
        if (ratestatus === 1 || ratestatus === 2 || ratestatus === 3) {
            context.sgIcon = '/static/SG ICON/Trend_up ' + ratestatus + '.png';
        }
        if (ratestatus === 4 || ratestatus === 5 || ratestatus === 6) {
            context.sgIcon = '/static/SG ICON/Trend_down ' + (ratestatus - 3) + '.png';
        }
        if (ratestatus === 7) {
            context.sgIcon = '';
        }


        if (val.glucose) {
            if (!context.isMg) {
                val.glucose = val.glucose.toFixed(1) + 'mmol/L';
            } else {
                val.glucose = Math.round(val.glucose * 18) + 'mg/dL';
            }
        } else {
            val.glucose = '--'
        }
        // 13 - 充电中
        // 14 - 充电完成
        if (status === 1 || status === 2 || status == 6
            /* */
            ||
            13 == status || 14 == status) {
            val.glucose = '--';
            context.updateTime1 = '--';
            context.sgIcon = '';
            context.sensorTime = '--';
        }
    },
    clearSensor(context, val) {
        val.serial = '--';
        val.status = '--';
        //val.updateTime ='--';
        val.sensorLifetimeTotalCount = '--';
        val.batteryPercent = '--';
        context.updateTime1 = '--';
        context.sgIcon = '';
        val.glucose = '--'
    },
    getPumpCurrentBolus(context, pumpStatus) {
        let currentBolus = [];
        let record_id = context.uid + '-' + pumpStatus.serial; //+'-bolus-current';
        let bolusType = '';
        if (1 == pumpStatus.bolusType) {
            bolusType = 'NB';
            record_id += '-bolus-current-N';
        } else if (2 == pumpStatus.bolusType) {
            bolusType = 'EB';
            record_id += '-bolus-current-E';
        } else if (3 == pumpStatus.bolusType) {
            bolusType = 'CB';
            record_id += '-bolus-current-C';
        }
        let wizardInfo = {};
        if (0 == pumpStatus.wizardType) {
            bolusType += 'M';
        } else if (1 == pumpStatus.wizardType) {
            bolusType += 'CRW';
            wizardInfo = {
                'bg': pumpStatus.wizardGlucose / 18.0,
                'corr_bolus': pumpStatus.wizardCorrSet,
                'iob': pumpStatus.wizardIob,
            }
        } else if (2 == pumpStatus.wizardType) {
            bolusType += 'CAW';
            wizardInfo = {
                'carb': pumpStatus.wizardCarb,
                'carb_bolus': pumpStatus.wizardCarbSet,
                'iob': pumpStatus.wizardIob,
            }
        } else if (3 == pumpStatus.wizardType) {
            bolusType += 'CCW';
            wizardInfo = {
                'bg': pumpStatus.wizardGlucose / 18.0,
                'corr_bolus': pumpStatus.wizardCorrSet,
                'carb': pumpStatus.wizardCarb,
                'carb_bolus': pumpStatus.wizardCarbSet,
                'iob': pumpStatus.wizardIob,
            }
        }


        currentBolus.push(record_id);
        currentBolus.push(pumpStatus.bolusDeliveriedTime);
        currentBolus.push(bolusType);
        currentBolus.push(pumpStatus.bolusSet);
        currentBolus.push(pumpStatus.bolusDeliveried);
        currentBolus.push(pumpStatus.extendBolusSet);
        currentBolus.push(pumpStatus.extendBolusDeliveried);
        currentBolus.push(pumpStatus.extendBolusDuration);
        currentBolus.push(JSON.stringify(wizardInfo));
        currentBolus.push(0);

        console.log('currentBolus:', currentBolus);
        return currentBolus;
    },
    randomString(len) {　　
        len = len || 32;　　
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/ 　　
        var maxPos = $chars.length;　　
        var pwd = '';　　
        for (let i = 0; i < len; i++) {　　　　 pwd += $chars.charAt(Math.floor(Math.random() * maxPos));　　 }　　
        return pwd;
    },
    //endWith(s, e) {
    //  let size=s.length;
    //},
    removePumpCurrentBolus(context, pumpStatus) {
        let i = 0;
        for (; i < context.bolus.length; i++) {
            let record_id = context.bolus[i][0];
            if (record_id.indexOf('bolus-current') > 0) {
                if (record_id.indexOf('-fix-') < 0) {
                    context.bolus[i][0] = record_id + '-fix-' + this.randomString(6);

                }
                //break;
            }
        }
        console.log('removePumpCurrentBolus:', i, context.bolus.length);
        if (i < context.bolus.length) {
            //context.bolus.splice(i, 1);
            //let record_id=
        }
    },

    removePumpCurrentBasal(context, record_id_key) {
        let i = 0;
        for (; i < context.basal.length; i++) {
            let record_id = context.basal[i][0];
            if (record_id.indexOf(record_id_key) > 0) {
                if (record_id.indexOf('-fix-') < 0) {
                    context.basal[i][0] = record_id + '-fix-' + this.randomString(6);
                }
                //break;
            }
        }
        console.log('removePumpCurrentBasal:', record_id_key, i, context.basal.length);
        if (i < context.basal.length) {
            //context.basal.splice(i, 1);
        }
    },

    getPumpCurrentBasal(context, pumpStatus) {
        let currentBasal = [];

        /*let basalTypeList=[
          //'NULL',
          'BAS',
          'BAE',
          'BAH',
          'BAPA',
          'BAPB',
          //'BART',
          //'BAAT',
          //'BAPC',
          //'BAPD',
          //'BASK',
        ];*/
        let basalTypeMap = {
            0: 'BAS',
            1: 'BAE',
            2: 'BAH',
            3: 'BAPA',
            4: 'BAPB',
            27: 'BAPC',
            28: 'BAPD',
            29: 'BASK',
            30: 'BAAM'
        }
        let tempBasalTypeMap = {
            5: 'BART',
            6: 'BAAT',
        }
        let record_id = context.uid + '-' + pumpStatus.serial;
        let basalType = '';
        let tempBasalType = ''
        let basalDuration = 0;
        let curTime = new Date().getTime() / 1000;
        let basalRate = 0;
        let basalDeliveried = 0;
        let basalDeliveriedTime = pumpStatus.basalDeliveriedTime;

        if (!pumpStatus.basalDeliveriedTime) { // 没有输注时间字段， 返回 false
            return false;
        }

        //let
        console.log('basalType:', pumpStatus.state, pumpStatus.basalType);
        if (0x20 <= pumpStatus.state && pumpStatus.state < 0x2F) { // 输注状态
            //if (0<=pumpStatus.basalType && pumpStatus.basalType<= 4) {
            //  basalType=basalTypeList[pumpStatus.basalType];
            //}
            basalType = basalTypeMap[pumpStatus.basalType];
            tempBasalType = tempBasalTypeMap[pumpStatus.basalType];

            //if ('BAAM'==basalType ) {    // 自动模式不从状态里面获取当前的基础量记录
            if (pumpStatus.AutoModeEnabledNew) { // 自动模式不从状态里面获取当前的基础量记录
                return false;
            }

            //basalDuration = curTime - pumpStatus.basalDeliveriedTime;
            //basalDuration = pumpStatus.basalDuration;

            basalRate = pumpStatus.basalRate;
            //basalDeliveried = basalDuration/3600.0*pumpStatus.basalRate;
            //basalDeliveried = pumpStatus.basalDelivery;

            basalDeliveried = pumpStatus.basalDeliveried || pumpStatus.basalDelivery;


            if (basalRate > 0) {
                basalDuration = (basalDeliveried / basalRate) * 3600;
            } else {
                basalDuration = 0;
            }

            //
            if (basalType) {
                record_id += '-basal-current'; //+'-bolus-current';
                // 移除暂停基础量记录
                this.removePumpCurrentBasal(context, 'suspend-current')
                this.removePumpCurrentBasal(context, 'basal-temp-current')
            } else if (tempBasalType) {
                basalType = tempBasalType;
                record_id += '-basal-temp-current'; //+'-bolus-current';
                // 移除暂停基础量记录
                this.removePumpCurrentBasal(context, 'suspend-current')
                this.removePumpCurrentBasal(context, 'basal-current')
            }
        } else if (0x40 <= pumpStatus.state && pumpStatus.state < 0x4F) { // 暂停状态
            record_id += '-suspend-current';
            /*
              IP_STAT_LOWBG_SUSP = IP_STAT_SUSP_BASE,     //低血糖暂停输注
              IP_STAT_PREV_LOWBG_SUSP,                    //预测低血糖暂停输注
              IP_STAT_AUTO_SUSP,                          //自动暂停输注
              IP_STAT_HMAX_SUSP,                          //超出每小时最大量
              IP_STAT_DMAX_SUSP,                          //超出每天最大量
              IP_STAT_SUSPEND,
              */
            if (0x40 == pumpStatus.state) {
                basalType = 'SUSLSG';
            } else if (0x41 == pumpStatus.state) {
                basalType = 'SUSPLSG';
            } else if (0x42 == pumpStatus.state) {
                basalType = 'SUSA';
            } else if (0x43 == pumpStatus.state) {
                basalType = 'SUSHM';
            } else if (0x44 == pumpStatus.state) {
                basalType = 'SUSDM';
            } else if (0x45 == pumpStatus.state) {
                basalType = 'SUSM';
            } else {
                basalType = 'SUSM';
            }
            basalDeliveriedTime = pumpStatus.suspendTime;
            //
            if (curTime > basalDeliveriedTime) {
                basalDuration = curTime - basalDeliveriedTime;
            } else {
                basalDuration = 0;
            }
            //basalDuration = (new Date().getTime()/1000) - pumpStatus.basalDeliveriedTime;
            //basalDuration
            // 移除输注基础量记录
            this.removePumpCurrentBasal(context, 'basal-current')
            this.removePumpCurrentBasal(context, 'basal-temp-current')
                //return false;
        }

        currentBasal.push(record_id);
        currentBasal.push(basalDeliveriedTime);
        currentBasal.push(basalType);
        currentBasal.push(basalDuration);
        currentBasal.push(basalRate);
        currentBasal.push(basalDeliveried);
        currentBasal.push(0);

        console.log('curBasal:', currentBasal);
        return currentBasal;
    },

    getPump(context, val) {
        //console.log('getPump:', val);
        // 状态值小于6是未激活之前的状态
        let originVal = {};
        for (let k in val) {
            originVal[k] = val[k];
        }
        console.log('getPump:', originVal);

        if (val.state < 0x20) { // 没有正式进入激活状态
            delete val.remainingDose;
            delete val.remainingTime;
        } else if (128 == val.state) {
            delete val.remainingDose;
            delete val.remainingTime;
        }

        let ins_unit2 = 'U';
        try {
            ins_unit2 = context.$t('ins_unit2');
        } catch (e) {
            console.log("ins_unit2 error:", e);
        }
        val.serial = (val.serial) ? this.deviceSNFormat(val.serial) : '--';
        let basal_active = false;
        if (val.state < 7) {
            val.state = (val.state) ? context.state1[val.state] : '--';
        } else if (val.state < 40) { // 激活状态
            val.state = (val.state) ? context.state2[val.state - 32] : '--';
            if (30 == val.basalType || val.AutoModeEnabledNew) {
                val.state = 'Auto Mode'
            }
            basal_active = true;

            if (val.bolusType && val.bolusType > 0) {
                val.state = context.injState['Bolus']
                    //
                let currentBolusRecord = this.getPumpCurrentBolus(context, originVal);
                context.addBolusRecord(currentBolusRecord);

            } else if (6 == val.basalType) { // 相对 临时基础量
                val.state = context.injState['BART']
            }
            let currentBasalRecord = this.getPumpCurrentBasal(context, originVal);
            if (currentBasalRecord) {
                context.addBasalRecord(currentBasalRecord);
            }

        } else if (val.state < 70) { // 暂停状态
            val.state = (val.state) ? context.state3[val.state - 64] : '--';

            let currentBasalRecord = this.getPumpCurrentBasal(context, originVal);
            if (currentBasalRecord) {
                context.addBasalRecord(currentBasalRecord);
            }

        } else if (val.state < 104) {
            val.state = (val.state) ? context.state4[val.state - 96] : '--';
        } else if (val.state === 128) {
            val.state = 'Delivery stopped';
        } else {
            val.state = '--';
        }

        //
        if (!basal_active || !val.bolusType || 0 == val.bolusType) {
            this.removePumpCurrentBolus(context, originVal);
        }

        //val.basalRate =  (val.basalRate || basal_active)? val.basalRate.toFixed(2)+context.$t('basal_unit2'):'--';
        console.log('AutoModeEnableNew:', val.AutoModeEnabledNew);
        if (30 == val.basalType || val.AutoModeEnabledNew) {
            val.basalRate = 'Auto Mode';
        } else if (val.basalRate && basal_active) {
            val.basalRate = val.basalRate.toFixed(2) + context.$t('basal_unit2');
        } else {
            val.basalRate = '--';
        }

        val.remainingDose = (val.remainingDose) ? val.remainingDose.toFixed(2) + ins_unit2 : '--';
        val.iob = (val.iob) ? val.iob.toFixed(2) + ins_unit2 : '--';
        // 把新收到的基础量数据加到 basal里面
        /*if (val.basal) {
          for (var i=0; i<val.basal.length; i++) {
            //let todayBasal=context.basal.concact(val.basal);
            //var newBasalRecord = context.basal[i];
            context.addBasalRecord(val.basal[i]);
          }
        }
        if (val.bolus) {
          for (var i=0; i<val.bolus.length; i++) {
            //let todayBasal=context.basal.concact(val.basal);
            //var newBasalRecord = context.basal[i];
            context.addBolusRecord(val.bolus[i]);
          }
        }*/ // 不是在这里添加
        // 统计basal的输注量。
        val.basalSum = context.calDayBasalTotal();
        val.bolusSum = context.calDayBolusTotal();
        let autoSum = context.calDayAutoModeTotal();
        console.log('autoSum:', val.basalSum, val.bolusSum, autoSum);
        val.basalSum += autoSum[0];
        val.bolusSum += autoSum[1];
        console.log('calDayBasalTotal:', context.basal, val.basalSum);

        //
        val.bolusSum = (val.bolusSum) ? val.bolusSum.toFixed(2) + ins_unit2 : '--';
        val.basalSum = (val.basalSum) ? val.basalSum.toFixed(2) + ins_unit2 : '--';
        //let type = val.lastBolusType;
        let type = val.bolusType;
        if (0 == type) {
            type = val.lastBolusType;
        }
        if (type === 1) {
            context.lastBolus = 'N' + val.bolusDeliveried.toFixed(2) + ins_unit2 + '  ' + this.formatterDate7(context, val.bolusDeliveriedTime);
        } else if (type === 2) {
            context.lastBolus = 'E' + val.extendBolusDeliveried.toFixed(2) + ins_unit2 + '  ' + this.formatterDate7(context, val.bolusDeliveriedTime);
        } else if (type === 3) {
            context.lastBolus = 'C' + (val.extendBolusDeliveried + val.bolusDeliveried).toFixed(2) + ins_unit2 + '  ' + this.formatterDate7(context, val.bolusDeliveriedTime);
        } else {
            context.lastBolus = '--';
        }
        val.remainingTime = (val.remainingTime) ? this.getTime3(val.remainingTime) : '--';
        //

    },
    clearPump(context, val) {
        val.state = '--';
        val.serial = '--';
        val.remainingTime = '--';
        //val.updateTime ='--';
        val.remainingDose = '--';
        val.basalRate = '--';
        val.basalSum = '--';
        context.lastBolus = '--';
        val.iob = '--';
        val.bolusSum = '--'
    },
    getSleepTime2(context, st, et, Stime) {
        let time1 = new Array(2),
            time2 = new Array(2);
        time1[0] = new Array(3);
        time1[0][0] = new Date((st + Stime[0] * 60) * 1000);
        time1[0][1] = new Date(et * 1000);
        time1[0][2] = (context.sgMax) ? context.sgMax : 20;
        time1[1] = new Array(3);
        time1[1][0] = new Date(st * 1000);
        time1[1][1] = new Date((st + Stime[1] * 60) * 1000);
        time1[1][2] = time1[0][2];

        time2[0] = new Array(3);
        time2[0][0] = new Date((st + Stime[0] * 60) * 1000);
        time2[0][1] = new Date(et * 1000);
        time2[0][2] = (context.basalMax) ? context.basalMax : 5;
        time2[1] = new Array(3);
        time2[1][0] = new Date(st * 1000);
        time2[1][1] = new Date((st + Stime[1] * 60) * 1000);
        time2[1][2] = time2[0][2];

        context.sleepTime1 = time1;
        context.sleepTime2 = time2;
    },

    updateBolusChart(context) {
        let bolus_proc = this.getBolus(context, context.st, context.bolus);
        //console.log(bolus);
        context.DataBolus = bolus_proc[0];
        context.extend_bolus = (bolus_proc[1][0]) ? bolus_proc[1] : context.extend_bolus;
        //console.log('DataBolus:', context.bolus, context.DataBolus, context.extend_bolus);
        //
        //context.drawColumnChart1();
        console.log('updateBolusChart:', context.DataBolus.length, context.extend_bolus.length);
        let chartOption = context.chart2.getOption();
        chartOption.series[4].data = context.DataBolus;
        chartOption.series[5].data = context.extend_bolus;
        context.chart2.setOption(chartOption);
    },

    updateBasalChart(context) {
        let bolus_proc = this.getBolus(context, context.st, context.bolus);
        //console.log(bolus);
        context.DataBolus = bolus_proc[0];
        context.extend_bolus = (bolus_proc[1][0]) ? bolus_proc[1] : context.extend_bolus;
        //console.log('DataBolus:', context.bolus, context.DataBolus, context.extend_bolus);
        //
        //context.drawColumnChart1();
        console.log('updateBolusChart:', context.bolus, context.DataBolus, context.extend_bolus);
        //console.log('updateBolusChart:', context.DataBolus.length, context.extend_bolus.length);
        //let chartOption=context.chart2.getOption();
        //chartOption.series[4].data=context.DataBolus;
        //chartOption.series[5].data=context.extend_bolus;
        //context.chart2.setOption(chartOption);
        //

        console.log('updateBasalChart:', context.basal);
        context.$store.commit('updateBasal', this.getBasal(context, context.st, context.basal));
        let bs = this.getBasal2(context.basal);
        context.newBasal = bs[0];
        context.stopBasal = bs[1];
        context.autoModeBasal = bs[2];
        context.autoModeCorrBolus = bs[3];

        let bs1 = this.getBasalSus4(context, context.st, context.basal);
        context.basal_suspend = bs1[0];
        context.tempBasal = bs1[1];
        context.basal_suspend2 = bs1[2];
        // 更新基础量Y轴最大值

        //
        let chartOption = context.chart2.getOption();

        chartOption.series[4].data = context.DataBolus;
        chartOption.series[5].data = context.extend_bolus;

        chartOption.series[0].data = context.DataBasal;
        chartOption.series[1].data = context.basal_suspend;
        chartOption.series[2].data = context.tempBasal;
        chartOption.series[3].data = context.basal_suspend2;
        chartOption.series[6].data = context.newBasal;
        chartOption.series[7].data = context.stopBasal;
        context.chart2.setOption(chartOption);
    },

    getMonData1(context, info) {
        let that = this;
        let flag = parseInt(sessionStorage.getItem('monitor'));
        let uid = parseInt(context.uid);
        let now = new Date() / 1000;
        if (flag === 1) {
            //console.log(new Date());
            context.$http.post('api/v2.0/monitor/data', info, {
                _timeout: 118000,
                onTimeout: (request) => { console.log('超时') },
                before(request) {
                    if (this.previousRequest) { this.previousRequest.abort(); }
                    this.previousRequest = request;
                }
            }).then(function(res) {
                //  console.log(res);
                let err = res.body.error;
                if (err === 0) {
                    let data = res.body.data[uid];
                    console.log('monitor:', data);

                    // 测试数据
                    if (false) {
                        data.pump = {
                            "updateTime": 1583826009.216325,
                            "wizardGlucose": 160.1999931335449,
                            "basalDuration": 150,
                            "serial": 1256630150,
                            "extendBolusSet": 0.55,
                            "suspendRemainingTime": 0,
                            "extendBolusDuration": 30,
                            "basalType": 1,
                            "extendBolusDeliveried": 0.30000000001,
                            "state": 32,
                            "basalDeliveried": 0.15,
                            "bolusSet": 0.85,
                            "basalRate": 0.9,
                            "wizardType": 3,
                            "bolusType": 3,
                            "suspendTime": 1583825463,
                            "lastBolusType": 0,
                            "remainingTime": 4310.39661141634,
                            "bolusDeliveried": 0.7000000000000001,
                            "wizardCorrSet": 0.4,
                            "anotherBolusType": 0,
                            "iob": 0,
                            "basalDeliveriedTime": 1583825463,
                            "wizardCarbSet": 1,
                            "pumpId": 74,
                            "wizardIob": 0,
                            "basalPercent": 90,
                            "wizardCarb": 15,
                            "bolusDeliveriedTime": 1583825981 + 3600,
                            "rssi": -58,
                            "remainingDose": 190.65
                        };
                    }

                    if (data.sg) {
                        let newSG = that.updateSg(context, data.sg);
                        for (let i = 0; i < newSG.length; i++) {
                            context.DataSG.push(newSG[i]);
                        }
                    }
                    if (data.sg && context.chart1) {
                        let option = context.chart1.getOption();
                        option.series[0].data = context.DataSG;
                        context.chart1.setOption(option);
                    }
                    if (data.sensor) {
                        let t1 = now - data.sensor.update_time;
                        context.sensorTime = (data.sensor.update_time) ? that.formatterDate1(new Date()) : '--';
                        data.sensor.updateTime = (data.sensor.update_time) ? that.formatterDate1(new Date(data.sensor.update_time * 1000)) : '--'; //注意时间字段不一致

                        var sensor_serial = data.sensor.serial;
                        //console.log(sensor_serial+','+typeof(sensor_serial));
                        if (102000000 <= sensor_serial && sensor_serial <= 103999999) {
                            //
                        } else {
                            //console.log(sensor_serial.toString(16).toUpperCase())
                            //data.sensor.serial=sensor_serial.toString(16).toUpperCase()
                            //data.sensor.serial = that.deviceSNFormat(sensor_serial);
                        }

                        that.getSensor(context, data.sensor);
                        if (t1 > 3600) { // 超过1小时不显示
                            context.sensorTime = '--';
                            that.clearSensor(context, data.sensor);
                            context.showCGMStatus = false;
                        } else {
                            context.showCGMStatus = true;
                        }
                        that.checkSgIcon(context);
                        context.$store.commit('updateSensor', data.sensor);
                    }
                    let basalChartUpdate = false;
                    let bolusChartUpdate = false;
                    if (data.pump) {
                        let originStatus = {};
                        for (var k in data.pump) {
                            originStatus[k] = data.pump[k];
                        }
                        context.pumpTime = (data.pump.update_time) ? that.formatterDate1(new Date()) : '--';
                        data.pump.update_time = (data.pump.update_time) ? that.formatterDate1(new Date(data.pump.update_time * 1000)) : '--';
                        //console.log('data.pump:', data);
                        that.getPump(context, data.pump);
                        let t2 = now - data.pump.update_time;
                        if (t2 > 3600) {
                            context.pumpTime = '--';
                            that.clearPump(context, data.pump);
                        }
                        context.$store.commit('updatePump', data.pump);

                        // 有正在打的大剂量的时候， 需要刷新图表
                        if (data.pump && data.pump.bolusType > 0) {
                            //that.updateBolusChart(context);
                            bolusChartUpdate = true;
                        }
                        // 更新基础量
                        //if (data.pump && 0x10<=data.pump.s)
                        if ((0x20 <= originStatus.state && originStatus.state <= 0x2F) || // 激活输注状态
                            (0x40 <= originStatus.state && originStatus.state <= 0x4F) // 输注暂停状态
                        ) {
                            //that.updateBasalChart(context);
                            basalChartUpdate = true;
                        }
                    }

                    //console.log('data.bolus:', data.bolus);
                    if (data.bolus && false) {
                        console.log('data.bolus.1:', data.bolus, context.bolus.length);
                        let needRefresh = false;
                        for (let i = 0; i < data.bolus.length; i++) {
                            let newBolusRecord = data.bolus[i];
                            //console.log('data.bolus newBolusRecord:', newBolusRecord);
                            var flag = context.addBolusRecord(newBolusRecord);
                            needRefresh = needRefresh || flag;
                        }

                        //
                        if (needRefresh) {
                            console.log('data.bolus.2:', context.bolus.length);
                            context.calDayBolusTotal();

                            /*
                            let bolus_proc =  that.getBolus(context,context.st, context.bolus);
                            //console.log(bolus);
                            context.DataBolus = bolus_proc[0];
                            context.extend_bolus = (bolus_proc[1][0])?bolus_proc[1]:context.extend_bolus ;
                            //console.log('DataBolus:', context.bolus.length, context.DataBolus, context.extend_bolus);
                            //
                            //context.drawColumnChart1();
                            let chartOption=context.chart2.getOption();
                            chartOption.series[4].data=context.DataBolus;
                            chartOption.series[5].data=context.extend_bolus;
                            context.chart2.setOption(chartOption);*/
                            context.basal = that.adjustBasalRecord(context.basal, data.pump);
                            //that.updateBolusChart(context);
                            bolusChartUpdate = true;
                        }
                    }

                    // 有一段时间， 是从状态里面合成记录， 现在自动模式会上传当前基础量记录 9999
                    if (data.basal && true) {
                        console.log('data.basal.1:', data.basal, context.basal.length);
                        let needRefresh = false;
                        for (let i = 0; i < data.basal.length; i++) {
                            let newBasalRecord = data.basal[i];
                            //console.log('data.bolus newBolusRecord:', newBolusRecord);
                            var flag = context.addBasalRecord(newBasalRecord);
                            needRefresh = needRefresh || flag;
                        }

                        if (needRefresh) {
                            //if (true) {
                            console.log('data.basal.2:', context.basal.length);
                            context.calDayBasalTotal();
                            //context.basal=that.adjustBasalRecord(context.basal, data.pump);   // data.pummp可能是空的
                            //that.updateBasalChart(context);
                            basalChartUpdate = true;
                        }
                    }
                    var chartUpdateTime = new Date().getTime() / 1000;
                    console.log('basalChartUpdate:', basalChartUpdate, bolusChartUpdate);
                    if (basalChartUpdate || bolusChartUpdate) {
                        if (chartUpdateTime - context.basalChartUpdateTime > 1) {
                            context.basalChartUpdateTime = chartUpdateTime;
                            that.updateBasalChart(context)
                        }
                    }
                    /*
                    if (bolusChartUpdate) {
                      if (chartUpdateTime-context.bolusChartUpdateTime>3) {
                        context.bolusChartUpdateTime = chartUpdateTime;
                        that.updateBolusChart(context)
                      }
                    }*/

                    info.eventNo = res.body.eventNo;
                    that.getMonData1(context, info);
                } else {
                    that.getMonData1(context, info);
                }
            }, function(err) {
                //  console.log(2);
                if (context.$route.path === '/monitor') {
                    context.timeout1 = setTimeout(that._getMonData1(context, info), 5000);
                } else {
                    context.timeout1 = '';
                }
                //that.getMonData1(context,info);
            })
        }
    },
    updateSg(context, val) {
        let SG = [];
        for (let m = 0; m < val.length; m++) {
            SG[m] = new Array(3);
            SG[m][0] = new Date(val[m][1] * 1000);
            SG[m][1] = (context.isMg) ? Math.round(val[m][3] * 18) : val[m][3].toFixed(1);
            SG[m][2] = val[m][4];
        }
        return SG;
    },
    checkSgIcon(context) {
        let obj = document.getElementById('sgIcon');

        if (!context.sgIcon) {
            obj.style.display = 'none';
            console.log('checkSgIcon.1:', context.sgIcon);
        } else {
            obj.style.display = 'auto';
        }
    },

    // data map
    getDataMap(context, uid, cb) {
        //let that = this;
        context.updateXhr = context.$http.get(SERVER_URL + '/v2.0/chart/' + uid + '/datamap').then(function(res) {
            //console.log('getDataMap:');
            //console.log(res);
            //
            cb(res.data)
        }, function(err) {
            console.log(err + "," + err.body.message);
            context.error = err.body.message
        })

    },

    // daily Summary
    getDs(context, uid, param, i) {
        let that = this;
        context.updateXhr = context.$http.get(SERVER_URL + '/v2.1/chart/' + uid + '/data/ds', { params: { param } }).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                console.log('ds.data:', res.body.data);
                let data_source = res.body.data.data_source;
                if (data_source) {
                    sessionStorage.setItem('data_source', data_source);
                }
                context.$store.commit('updateDataS', res.body.data);
                context.timeSection = res.body.data.time_section[0];
                let st = context.timeSection[0]; /*重要参数*/
                //context.first_request=false;
                if (false) { // 测试数据
                    console.log('ds sg:', res.body.data.sensor_glucose);
                    let sgData = res.body.data.sensor_glucose[0];
                    //let sgData=res.body.data.chart.sg;
                    let dataNum = sgData.length;
                    let start = 0;
                    let end = dataNum;
                    if (dataNum > 50) {
                        start = dataNum - 50;
                        end = 50;
                    }
                    for (let i = start; i < dataNum; i++) {
                        //sgData[i][1] -= 5;
                    }

                    for (let i = 0; i < end; i++) {
                        if (sgData[i][1] > 5) {
                            //sgData[i][1] -= 5;
                            sgData[i][1] += 18;
                            //if ()
                        }
                    }

                }

                let SG = that.getSG(context, res.body.data);
                context.$store.commit('updateDataSG', SG[0]);
                // context.sgMax = SG[1];
                if (res.body.data.transmtr) {
                    context.transmtr = that.getTransmtr(context, res.body.data.transmtr[0]);
                } else {
                    context.transmtr = [];
                }

                let alarm_display = res.body.data.alarm_display;
                if (alarm_display === 'On') {
                    context.sensor_alarm = that.getAlarm(context, res.body.data.sensor_alarm, 0);
                    context.pump_alarm = that.getAlarm(context, res.body.data.pump_alarm, 1);
                }

                context.calib = that.getCalib(res.body.data.calibRecord);
                let bg1 = that.getBg1(res.body.data.bg);
                context.bg = bg1[0];
                let bgMax = bg1[1];
                context.sgMax = (context.sgMax > bgMax) ? context.sgMax : bgMax;

                context.$store.commit('updateBasal', that.getBasal(context, st, res.body.data.basal[0]));
                // 处理激活记录和终止记录
                let bs = that.getBasal2(res.body.data.basal[0]);
                context.newBasal = bs[0];
                context.stopBasal = bs[1];
                context.autoModeBasal = bs[2];
                context.autoModeCorrBolus = bs[3];
                // 计算Basal画图Y轴的最大值
                let normalBasal = context.DataBasal;
                let basalValue = normalBasal.map(function(e, i) {
                    return e[1];
                })
                let autoBasalValue = context.autoModeBasal.map(function(e, i) {
                        return e[2];
                    })
                    // console.log('basalValue:', basalValue, autoBasalValue);
                let basalValueAll = basalValue.concat(autoBasalValue);
                context.basalMax = that.getBasalYMax(basalValueAll);

                //
                let bs1 = that.getBasalSus4(context, st, res.body.data.basal[0]);
                context.basal_suspend = bs1[0];
                context.tempBasal = bs1[1];
                context.basal_suspend2 = bs1[2];
                // console.log(bs1[0],bs1[2],res.body.data.basal[0])
                // 自动模式统计
                that.getDailySummaryAutoModeStatistics(context, res.body.data, i);

                let bolus = that.getBolus(context, st, res.body.data.bolus[0]);
                //console.log('bolus:'+bolus);
                context.$store.commit('updateBolus', bolus[0]);
                context.extend_bolus = (bolus[1][0]) ? bolus[1] : context.extend_bolus;
                console.log('extend_bolus:' + context.extend_bolus);

                context.bolusMax = bolus[2];

                let Carb = that.getCarb(res.body.data.carb_event);
                context.carb = Carb[0];
                context.carbMax = Carb[1];

                let exe = that.getExercise(context, res.body.data.exercise_event);
                context.exercise = (exe) ? exe : context.exercise;

                // 自动模式的进餐记录
                let autoMeal = that.getAutoMeal(context, res.body.data.auto_mode_event[0], context.carbMax);
                context.autoBreakfast = autoMeal[0];
                context.autoLunch = autoMeal[1];
                context.autoDinner = autoMeal[2];
                context.autoSnack = autoMeal[3];
                context.autoExercise = autoMeal[4];

                let sleep = that.getSleepTime(context, res.body.data.sleeptime, context.timeSection);
                context.sleepTime1 = sleep[0];
                context.sleepTime2 = sleep[1];
                context.sleepTime3 = sleep[2];

                if (context.chart1_2) {
                    context.chartsDispose();
                }

                context.drawCharts(i);
                // 报告数据
                if (context.getStatistics) {
                    context.getStatistics(res.data.report_data)
                } else if (context.getStatisticsQuick) {
                    context.getStatisticsQuick(res.data.report_data, i);
                }
            }
        }, function(err) {
            console.log(err + "," + err.body.message);
            context.error = err.body.message
        })

    },
    getSG(context, val) {
        //console.log(val);
        let sg = [],
            time = [],
            type = [],
            SG = [],
            max = (context.isMg) ? 400 : 22.2;
        for (let i = 0; i < val.sensor_glucose.length; i++) {
            for (let j = 0; j < val.sensor_glucose[i].length; j++) {
                sg[j] = val.sensor_glucose[i][j][1].toFixed(1);
                sg[j] = (sg[j] > 22.2) ? 22.2 : sg[j];
                if (sg[j] < 2.2 && (val.sensor_glucose[i][j][4] === 'C' || val.sensor_glucose[i][j][4] === 'CX')) {
                    sg[j] = 2.2;
                }
                sg[j] = (context.isMg) ? Math.round(sg[j] * 18) : sg[j];
                if (val.sensor_glucose[i][j][4] === 'DE') {
                    sg[j] = 0;
                }
                time[j] = val.sensor_glucose[i][j][0];
                type[j] = val.sensor_glucose[i][j][4];
            }
        }
        max = (sg.length > 1) ? Math.max.apply(null, sg) : max;
        max = this.getsgMax1(max);
        for (let m = 0; m < sg.length; m++) {
            SG[m] = new Array(3);
            time[m] = new Date(time[m] * 1000);
            SG[m][0] = time[m];
            SG[m][1] = sg[m];
            SG[m][2] = type[m];
        }
        // console.log(SG);
        return [SG, max];
    },
    getBasal(context, st, val) {
        let basal = [],
            j = 0,
            m1 = [],
            max = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i][2] === 'BAS' ||
                val[i][2] === 'BAE' ||
                val[i][2] === 'BAH' ||
                val[i][2] === 'BAPB' ||
                val[i][2] === 'BAPA' ||
                val[i][2] === 'BAPC' ||
                val[i][2] === 'BAPD' ||
                val[i][2] === 'BASK'
            ) {
                if (val[i][3] !== 0) {
                    basal[j] = new Array(2);
                    basal[j][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                    basal[j][1] = (val[i][4]) ? val[i][4].toFixed(2) : 0;
                    j++;
                    basal[j] = new Array(2);
                    basal[j][0] = ((st + 86400) <= (val[i][1] + val[i][3])) ? new Date((st + 86400) * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                    basal[j][1] = (val[i][4]) ? val[i][4].toFixed(2) : 0;
                    //判断是否连续
                    if (i < val.length - 1) {
                        let nextBasalType = val[i + 1][2];
                        if (val[i + 1][2] !== 'BAS' &&
                            val[i + 1][2] !== 'BAE' &&
                            val[i + 1][2] !== 'BAH' &&
                            nextBasalType != 'BAPB' &&
                            nextBasalType != 'BAPA' &&
                            nextBasalType != 'BAPC' &&
                            nextBasalType != 'BAPD' &&
                            nextBasalType != 'BASK'
                        ) {
                            j++;
                            basal[j] = new Array(2);
                            basal[j][0] = ((st + 86400) <= (val[i][1] + val[i][3])) ? new Date((st + 86400) * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                            basal[j][1] = null;
                        }
                    }
                    j++;
                }
            }
            m1.push(val[i][4]);
            //m1.push(val[i][6]);
        }
        max = (m1.length > 1) ? Math.max.apply(null, m1) : 3; // 用apply调用方式， 可以使用数组作为参数
        if (max < 1) { max = 1; } else if (max < 2) { max = 2; } else if (max < 5) { max = 5; } else if (max < 10) { max = 10; } else if (max < 15) { max = 15; } else if (max < 20) { max = 20; } else if (max < 25) { max = 25; }
        context.basalMax = max;
        //console.log(basal);
        return basal;
    },
    getBasalYMax(val) {
        let m1 = val;
        let max = (m1.length > 1) ? Math.max.apply(null, m1) : 3; // 用apply调用方式， 可以使用数组作为参数
        if (max < 1) { max = 1; } else if (max < 2) { max = 2; } else if (max < 5) { max = 5; } else if (max < 10) { max = 10; } else if (max < 15) { max = 15; } else if (max < 20) { max = 20; } else if (max < 25) { max = 25; }
        // context.basalMax = max;
        // //console.log(basal);
        return max;
    },
    getBasal2(val) {
        let newBasal = [],
            stopBasal = [];
        let autoModeBasal = [];
        let autoModeCorrBolus = [];
        let j = 0,
            k = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i][2] === 'NEW') {
                newBasal[j] = new Array(2);
                newBasal[j][0] = new Date(val[i][1] * 1000);
                newBasal[j][1] = 0.2;
                j++;
            }
            if (val[i][2] === 'ENDM' || val[i][2] === 'ENDEM' || val[i][2] === 'ENDPE' || val[i][2] === 'ENDEP' || val[i][2] === 'ENDPB' || val[i][2] === 'ENDCE' || val[i][2] === 'ENDPBE' || val[i][2] === 'ENDD' || val[i][2] === 'ENDPE2') {
                stopBasal[j] = new Array(2);
                stopBasal[j][0] = new Date(val[i][1] * 1000);
                stopBasal[j][1] = 0.1;
                j++;
            }
            // 处理自动模式基础量
            let basal_type = val[i][2];
            if (basal_type == 'BAAM') {
                let microBolus = val[i][7];
                let microBolusJson = [];
                try {
                    microBolus = JSON.parse(microBolus);
                    //console.log('microBolus:', microBolus);
                    microBolusJson = microBolus['autoModeJSON']
                } catch (e) {
                    console.log('microBolus error:', e);
                }
                //console.log('microBolusJson:', microBolusJson);
                if (microBolusJson.length > 0) {
                    // for (let m = 0; m < (microBolusJson.length-1) / 5 + 1; m++) {
                    //  let basal_record=[];
                    //  let startTime = new Date(val[i][1] * 1000 + m * 30 * 60 * 1000);  // 30 分钟一个记录
                    //   let endTime = new Date(val[i][1] * 1000 + (m+1) * 30 * 60 * 1000);
                    //   let totalInject=0;
                    //   if ((m+1)*5 > microBolusJson.length) {
                    //     endTime = new Date(val[i][1] * 1000 + (microBolusJson.length - m*5) * 6 * 60 * 1000);  // 6分钟一个记录
                    //      let subRecords=
                    //   } else {
                    //
                    //   }
                    //
                    // }
                    let index = 0;
                    while (index < microBolusJson.length) {
                        let subRecord = microBolusJson.slice(index, index + 5);
                        let startTime = new Date(val[i][1] * 1000 + index * 6 * 60 * 1000);
                        let endTime = new Date(val[i][1] * 1000 + (index + subRecord.length) * 6 * 60 * 1000);
                        let totalInject = 0;
                        let totalCorrBolus = 0;
                        subRecord.map(function(e, i) {
                            totalInject += e['auto_basal_delivery'];
                            totalCorrBolus += e['auto_corr_delivery'];
                            totalCorrBolus += e['auto_food_delivery'];
                        })
                        let basalRate = totalInject * 0.05 / (subRecord.length * 6.0 / 60); // 基础量速率单位  U/H

                        let basal_record = [
                            startTime,
                            endTime,
                            basalRate
                        ]

                        if (basalRate > 0) {
                            autoModeBasal.push(basal_record);
                        }

                        if (totalCorrBolus > 0) {
                            autoModeCorrBolus.push([
                                new Date((startTime.getTime() + endTime.getTime()) / 2),
                                totalCorrBolus * 0.05
                            ])
                        }

                        index += 5;
                    }
                }

            }
            //console.log('autoModeCorrBolus:', autoModeCorrBolus);

        }
        return [newBasal, stopBasal, autoModeBasal, autoModeCorrBolus];
    },

    getDailySummaryAutoModeStatistics(context, data, index) {
        let basal = data.basal[0];
        let sg = data.sensor_glucose[0];
        let autoModeTime = 0;
        let autoModeTimeSection = [];
        let autoModeExits = 0;
        let autoModeStat = {};

        for (let i = 0; i < basal.length; i++) {
            let basalRecord = basal[i];
            let basalType = basalRecord[2];
            if ('BAAM' == basalType) {
                autoModeTime += basalRecord[3];

                if (autoModeTimeSection.length > 0) {
                    let lastRecord = autoModeTimeSection[autoModeTimeSection.length - 1];

                    if (basalRecord[1] > lastRecord[1]) {
                        autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]])
                    } else if (basalRecord[1] == lastRecord[1]) {
                        lastRecord[1] = basalRecord[1] + basalRecord[3];
                    }
                } else {
                    autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]])
                }

            } else if ('BAAME' == basalType) {
                autoModeExits += 1;
            }
        }
        context.autoModeExits = autoModeExits;
        autoModeStat.autoModeExits = autoModeExits;
        //
        console.log('autoModeTimeSection:', autoModeTimeSection, sg.length, sg[0]);
        let autoModeSG = [];
        let autoModeSGInTarget = [];
        let autoModeSGAboveTarget = [];
        let autoModeSGBelowTarget = [];

        let autoModeSGTargetHigh = 180 / 18.0;
        let autoModeSGTargetLow = 70 / 18.0;

        for (let i = 0; i < sg.length; i++) {
            let sgRecord = sg[i];
            let sgState = sgRecord[4];
            let sgValue = sgRecord[1];
            let sgTime = sgRecord[0];
            if ('CX' == sgState || 'C' == sgState || 'NC' == sgState) {
                if (sgValue > 0.000001) {
                    let sgInAutoMode = false;
                    for (let s = 0; s < autoModeTimeSection.length; s++) {
                        if (sgTime >= autoModeTimeSection[s][0] && sgTime <= autoModeTimeSection[s][1]) {
                            sgInAutoMode = true;
                            break;
                        }
                    }
                    //console.log('sgInAutoMode:', sgValue, sgInAutoMode);
                    if (sgInAutoMode) {
                        autoModeSG.push(sgValue);
                        if (sgValue >= autoModeSGTargetHigh) {
                            autoModeSGAboveTarget.push(sgValue);
                        } else if (sgValue < autoModeSGTargetLow) {
                            autoModeSGBelowTarget.push(sgValue);
                        } else {
                            autoModeSGInTarget.push(sgValue);
                        }
                    } else {
                        // notAutoModeSG.push(sgValue);
                    }
                }
            }
        }

        let statResult = this.getAvgSD(autoModeSG);
        console.log('Auto mode SG statResult (ds):', statResult);
        if (statResult.num) {
            context.autoModeSGAvgSD = this.getGlucoseValText2(context.isMg, statResult.avg) + ' ± ' + this.getGlucoseSDValText(context.isMg, statResult.sd);
            let highPercent = parseInt(((autoModeSGAboveTarget.length * 100.0) / autoModeSG.length).toFixed());
            let lowPercent = parseInt(((autoModeSGBelowTarget.length * 100.0) / autoModeSG.length).toFixed());
            let inRangePercent = 100 - highPercent - lowPercent;
            context.autoModeSGInTargetRange = inRangePercent + '%';
            context.autoModeSGAboveRange = highPercent + '%';
            context.autoModeSGBelowRange = lowPercent + '%';
            //
            autoModeStat.autoModeSGAvgSD = context.autoModeSGAvgSD;
            autoModeStat.autoModeSGInTargetRange = inRangePercent + '%';
            autoModeStat.autoModeSGAboveRange = highPercent + '%';
            autoModeStat.autoModeSGBelowRange = lowPercent + '%';
        } else {
            autoModeStat.autoModeSGAvgSD = '--';
            autoModeStat.autoModeSGInTargetRange = '--';
            autoModeStat.autoModeSGAboveRange = '--';
            autoModeStat.autoModeSGBelowRange = '--';
        }

        //
        console.log('autoModeSG:', autoModeSG.length, autoModeSGInTarget.length, autoModeSGAboveTarget.length, autoModeSGBelowTarget.length);


        context.timeInAutoMode = parseInt((autoModeTime * 100.0 / (3600 * 24)).toFixed()) + '%'
        autoModeStat.timeInAutoMode = parseInt((autoModeTime * 100.0 / (3600 * 24)).toFixed()) + '%';
        context.autoModeStat[index] = autoModeStat;
        //console.log('autoModeStat:', autoModeStat, index);
    },
    getBolus(context, st, val) {
        //console.log('getBolus:', val);
        let bolus = [],
            extend_bolus = [],
            m1 = [],
            max = 10,
            j = 0,
            k = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i][2] === 'EBCCW' || val[i][2] === 'EBM' || val[i][2] === 'EBCAW') {
                var partion_factor = val[i][5] ? 1.0 * val[i][6] / val[i][5] : 0;

                extend_bolus[j] = new Array(8);
                extend_bolus[j][0] = (st < val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                extend_bolus[j][1] = ((st + 86400) > (val[i][1] + val[i][7] * 60)) ? new Date((val[i][1] + val[i][7] * 60 * partion_factor) * 1000) : new Date((st + 86400) * 1000);
                extend_bolus[j][2] = val[i][6];
                extend_bolus[j][3] = Math.round(val[i][5] ? val[i][7] * 1.0 * val[i][6] / val[i][5] : 0);
                extend_bolus[j][4] = context.$t('E');
                extend_bolus[j][5] = val[i][8]; // 向导信息
                extend_bolus[j][6] = val[i][5]; // 扩展设置量
                extend_bolus[j][7] = (val[i][5] == 0) ? 0 : Math.floor((val[i][6] / val[i][5]) * val[i][7]); // 扩展实际的输注时间, 按输注量比例计算出来的

                //console.log('extend_bolus:'+extend_bolus[j]);
                j++;
            } else if (val[i][2] === 'CBCCW' || val[i][2] === 'CBM' || val[i][2] === 'CBCAW') {
                extend_bolus[j] = new Array(8);
                extend_bolus[j][0] = (st < val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                extend_bolus[j][1] = ((st + 86400) > (val[i][1] + val[i][7] * 60)) ? new Date((val[i][1] + val[i][7] * 60) * 1000) : new Date((st + 86400) * 1000);
                extend_bolus[j][2] = val[i][6]; // 扩展输注量
                extend_bolus[j][3] = val[i][7]; // 扩展持续时间
                extend_bolus[j][4] = context.$t('CE');
                extend_bolus[j][5] = val[i][8]; // 向导信息
                extend_bolus[j][6] = val[i][5]; // 扩展设置量
                extend_bolus[j][7] = (val[i][5] == 0) ? 0 : Math.floor((val[i][6] / val[i][5]) * val[i][7]); // 扩展实际的输注时间, 按输注量比例计算出来的

                j++;
                bolus[k] = new Array(3);
                bolus[k][0] = new Date(val[i][1] * 1000);
                bolus[k][1] = val[i][4];
                bolus[k][2] = context.$t('CN1');
                k++;
            } else {
                bolus[k] = new Array(4);
                bolus[k][0] = new Date(val[i][1] * 1000);
                bolus[k][1] = val[i][4];
                bolus[k][2] = context.$t('N');
                bolus[k][3] = val[i][8];

                k++;
            }
            m1.push(val[i][4]);
            m1.push(val[i][6]);
        }
        max = Math.max.apply(null, m1);
        if (max < 5) { max = 5; } else if (max < 10) { max = 10; } else if (max < 15) { max = 15; } else if (max < 20) { max = 20; } else if (max < 25) { max = 25; }
        //console.log(extend_bolus);
        return [bolus, extend_bolus, max];
    },
    getExercise(context, val) {
        let exe = [],
            type = ['Light', 'Medium', 'Heavy'],
            j = 0,
            Num = [20, 60, 100];
        for (let i = 0; i < val[0].length; i++) {
            exe[j] = new Array(5);
            exe[j][0] = new Date(val[0][i][0] * 1000);
            exe[j][1] = new Date((val[0][i][0] + val[0][i][1] * 60) * 1000);
            exe[j][2] = Num[val[0][i][2]] * (context.carbMax / 100);
            exe[j][3] = val[0][i][1];
            exe[j][4] = type[val[0][i][2]];
            j++;
        }
        return exe;
    },
    getAutoMeal(context, autoMeal, carbMax) {
        let autoBreakfast = autoMeal[0];
        let autoLunch = autoMeal[1];
        let autoDinner = autoMeal[2];
        let autoSnack = autoMeal[3];
        let autoExercise = autoMeal[4];
        //console.log('autoSnack:', autoSnack, context.carb);
        if (1) { // for test
            if (autoSnack.length) {
                autoSnack[0][1] = 50;
            }
        }

        autoBreakfast = autoBreakfast.map(function(e, i) {
            return [
                new Date(e[0] * 1000),
                carbMax + 2
            ]
        })
        autoLunch = autoLunch.map(function(e, i) {
            return [
                new Date(e[0] * 1000),
                carbMax + 2
            ]
        })
        autoDinner = autoDinner.map(function(e, i) {
            return [
                new Date(e[0] * 1000),
                carbMax + 2
            ]
        })
        autoSnack = autoSnack.map(function(e, i) {
            return [
                new Date(e[0] * 1000),
                carbMax + 2
            ]
        })
        autoExercise = autoExercise.map(function(e, i) {
            return [
                new Date(e[0] * 1000),
                carbMax + 2
            ]
        })

        return [
            autoBreakfast,
            autoLunch,
            autoDinner,
            autoSnack,
            autoExercise,
        ]

    },
    getCalib(val) {
        let exe = [];
        for (let i = 0; i < val[0].length; i++) {
            exe[i] = new Array(2);
            exe[i][0] = new Date(val[0][i][1] * 1000);
            exe[i][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[0][i][3] * 18) : val[0][i][3].toFixed(1);
        }
        return exe;
    },
    getBg1(val) {
        let bg = [],
            max1 = [],
            max = 0;
        for (let i = 0; i < val[0].length; i++) {
            bg[i] = new Array(2);
            bg[i][0] = new Date(val[0][i][0] * 1000);
            bg[i][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[0][i][1] * 18) : val[0][i][1].toFixed(1);
            max1[i] = bg[i][1];
        }
        max = (max1.length > 1) ? Math.max.apply(null, max1) : 0;
        max = this.getsgMax1(max);
        return [bg, max];
    },
    getCarb(val) {
        let carb = [],
            max = [],
            j = 0;
        for (let i = 0; i < val[0].length; i++) {
            if (val[0][i][1] !== 0) {
                carb[j] = new Array(2);
                carb[j][0] = new Date(val[0][i][0] * 1000);
                carb[j][1] = val[0][i][1];
                max[j] = val[0][i][1];
                j++;
            }
        }
        let max1 = Math.max.apply(null, max);
        if (max1 < 100) { max1 = 100; } else if (max1 < 200) { max1 = 200; } else if (max1 < 300) { max1 = 300; } else { max1 = 500; }
        return [carb, max1];
    },
    getAlarm(context, val, flag) {
        let alarm = [];
        for (let i = 0; i < val[0].length; i++) {
            alarm[i] = new Array(3);
            alarm[i][0] = new Date(val[0][i][0] * 1000);
            if (flag === 1) {
                alarm[i][1] = 0.2;
            } else {
                alarm[i][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(1.2 * 18) : 1.2;
            }
            alarm[i][2] = context.$t(val[0][i][1]);
        }
        // console.log(alarm);
        return alarm;
    },
    getsgMax1(max) {
        if (localStorage.getItem('unit') === 'mg') {
            if (max < 200) { max = 200; } else if (max < 300) { max = 300; } else if (max < 400) { max = 400; }
        } else {
            if (max < 15) { max = 15; } else if (max < 20) { max = 20; } else if (max < 25) { max = 25; }
        }
        return max;
    },
    getSleepTime(context, Stime, Dtime) {
        let time1 = new Array(2),
            time2 = new Array(2),
            time3 = new Array(2);
        time1[0] = new Array(3);
        time1[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
        time1[0][1] = new Date(Dtime[1] * 1000);
        time1[0][2] = (context.sgMax) ? context.sgMax : 20;
        time1[1] = new Array(3);
        time1[1][0] = new Date(Dtime[0] * 1000);
        time1[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
        time1[1][2] = time1[0][2];

        time2[0] = new Array(3);
        time2[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
        time2[0][1] = new Date(Dtime[1] * 1000);
        time2[0][2] = (context.basalMax) ? context.basalMax : 5;
        time2[1] = new Array(3);
        time2[1][0] = new Date(Dtime[0] * 1000);
        time2[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
        time2[1][2] = time2[0][2];

        time3[0] = new Array(3);
        time3[0][0] = new Date((Dtime[0] + Stime[0] * 60) * 1000);
        time3[0][1] = new Date(Dtime[1] * 1000);
        time3[0][2] = context.carbMax;
        time3[1] = new Array(3);
        time3[1][0] = new Date(Dtime[0] * 1000);
        time3[1][1] = new Date((Dtime[0] + Stime[1] * 60) * 1000);
        time3[1][2] = context.carbMax;

        return [time1, time2, time3];
    },
    getTransmtr(context, val) {
        // console.log(val);
        let trans = [],
            j = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i].length > 0) {
                trans[j] = new Array(2);
                trans[j][0] = new Date(val[i][1] * 1000);
                trans[j][1] = 0.2;
                j++;
            }
        }
        return trans;
    },

    parseDeviceSN(context, basal_data) {
        let pump_sn = {}
        let transmitter_sn = {}
        basal_data.map(function(e, i) {
                let record_id = e[0];
                pump_sn[record_id.split('-')[1]] = 1;
            })
            //console.log('pump_sn:', pump_sn);
        let pump_sn_arr = [];
        for (var p in pump_sn) {
            pump_sn_arr.push(p)
        }
        //
        /*
        sg_data.map(function(e,i){
          let record_id=e[0];
          transmitter_sn[record_id.split('-')[1]]=1;
        })
        //console.log('pump_sn:', pump_sn);
        transmitter_sn_arr=[];
        for (var p in transmitter_sn) {
          transmitter_sn_arr.push(p)
        }*/
        //
        console.log('pump_sn_arr:', pump_sn_arr);
        if (pump_sn_arr.length > 0) {
            context.pump_device = 'MD-JN ' + this.deviceSNFormat(pump_sn_arr[0]);
        } else {
            context.pump_device = '--'
        }
        console.log('pump_device:', context.pump_device);
    },

    // day by day
    getDd(context, uid, param) {
        let that = this;
        context.$http.get('/api/v2.1/chart/' + uid + '/data/dd', { params: { param } }).then(function(res) {
            let err = res.body.error;
            console.log('getDd.1:', res.body.data);
            if (err === 0) {
                if (context.sgChart1 || context.chartColumn11) {
                    context.chartsDispose2();
                    this.sg = [];
                    this.basal = [];
                }
                // 计算 devices
                if (1) {
                    let basal_data = [];

                    //let sg_data=[];
                    for (var i in res.body.data.basal) {
                        //console.log('basal_all.item:', item);
                        basal_data = basal_data.concat(res.body.data.basal[i]);
                    }
                    //for (var i in res.body.data.sg) {
                    //  //console.log('basal_all.item:', item);
                    //  sg_data = sg_data.concat(res.body.data.sg[i]);
                    //}
                    //console.log('sg_data:', sg_data);
                    //console.log('basal_all:', basal_all.length);
                    that.parseDeviceSN(context, basal_data);
                }

                context.$store.commit('updateDataD', res.body.data);
                if (false) { // 测试数据
                    //console.log("dd.sg:", res.body.data.sg);
                    let dayNum = res.body.data.sg.length;
                    let sgData = res.body.data.sg[dayNum - 1];
                    let dataNum = sgData.length;
                    let start = 0;
                    let end = dataNum;
                    if (dataNum > 50) {
                        start = dataNum - 50;
                        end = 50;
                    }
                    for (let i = start; i < dataNum; i++) {
                        //sgData[i][1] -= 5;
                    }

                    for (let i = 0; i < end; i++) {
                        if (sgData[i][1] > 5) {
                            //sgData[i][1] -= 5;
                            sgData[i][1] += 18;
                            //if ()
                        }
                    }
                }
                context.sg = that.getDdSG(res.body.data.sg);
                context.calib = that.getCalib3(res.body.data.calib);
                context.bg = that.getBg3(res.body.data.bg);
                context.timeSection = res.body.data.time_sec;
                that.getBasal3(context, res.body.data.basal);
                that.getBasalSus3(context, res.body.data.basal);
                let mealTime = that.getMealTime(res.body.data.meal_time, res.body.data.time_sec);
                //console.log(res.body.data.meal_time,res.body.data.time_se);
                context.mealTime1 = mealTime[0];
                context.mealTime2 = mealTime[1];
                context.mealTime3 = mealTime[2];
                if (res.data.data.transmtr) {
                    that.getTransmtr2(context, res.data.data.transmtr);
                }
                that.getBolus3(context, res.body.data.bolus);
                //if (context.gets)
                sessionStorage.setItem('dd_report_data', JSON.stringify(res.body.report_data))
                if (context.getDdReportInfo) {
                    context.getDdReportInfo(res.body.report_data);
                }
                context.carb = res.body.data.carb;
                // 自动模式进餐事件
                context.autoBreakfast = res.body.data.auto_mode_event[0];
                context.autoLunch = res.body.data.auto_mode_event[1];
                context.autoDinner = res.body.data.auto_mode_event[2];
                context.autoSnack = res.body.data.auto_mode_event[3];

                context.drawCharts2();

                // console.log('画图：'+(new Date()-t1)+'ms');
                // console.log('总时间：'+(new Date()-t2)+'ms');
            }
        }, function(err) {
            console.log(err + "," + err.body.message);
            context.error = err.body.message
        });
    },
    getDdSG(val) {
        let SG = new Array(7);
        for (let i = 0; i < val.length; i++) {
            SG[i] = [];
            for (let j = 0; j < val[i].length; j++) {
                SG[i][j] = new Array(2);
                SG[i][j][0] = new Date(val[i][j][0] * 1000);
                SG[i][j][1] = (val[i][j][1] > 22.2) ? 22.2 : val[i][j][1].toFixed(1);
                if (SG[i][j][1] < 2.2 && (val[i][j][4] === 'C' || val[i][j][4] === 'CX')) {
                    SG[i][j][1] = 2.2;
                }
                SG[i][j][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(SG[i][j][1] * 18) : SG[i][j][1];
                if (val[i][j][4] === 'DE') {
                    SG[i][j][1] = 0;
                }
                SG[i][j][2] = val[i][j][4];
            }
        }
        return SG;
    },
    getBasal3(context, val) {
        let basal = new Array(7);
        for (let i = 0; i < val.length; i++) {
            let st = context.timeSection[i][0];
            basal[i] = [];
            let j = 0;
            for (let k = 0; k < val[i].length; k++) {
                if (val[i][k][2] === 'BAS' ||
                    val[i][k][2] === 'BAE' ||
                    val[i][k][2] === 'BAH' ||
                    val[i][k][2] === 'BAPB' ||
                    val[i][k][2] === 'BAPA' ||
                    val[i][k][2] === 'BAPC' ||
                    val[i][k][2] === 'BAPD' ||
                    val[i][k][2] === 'BASK'
                ) {
                    basal[i][j] = new Array(2);
                    basal[i][j][0] = (st <= val[i][k][1]) ? new Date(val[i][k][1] * 1000) : new Date(st * 1000);
                    basal[i][j][1] = (val[i][k][4]) ? val[i][k][4].toFixed(2) : 0;
                    j++;
                    basal[i][j] = new Array(2);
                    basal[i][j][0] = ((st + 86400) <= (val[i][k][1] + val[i][k][3])) ? new Date((st + 86400) * 1000) : new Date((val[i][k][1] + val[i][k][3]) * 1000);
                    basal[i][j][1] = (val[i][k][4]) ? val[i][k][4].toFixed(2) : 0;
                    //判断是否连续
                    if (k < val[i].length - 1) {
                        let nextBasalType = val[i][k + 1][2];
                        if (val[i][k + 1][2] !== 'BAS' &&
                            val[i][k + 1][2] !== 'BAE' &&
                            val[i][k + 1][2] !== 'BAH' &&
                            nextBasalType != 'BAPA' &&
                            nextBasalType != 'BAPB' &&
                            nextBasalType != 'BAPC' &&
                            nextBasalType != 'BAPD' &&
                            nextBasalType != 'BASK'
                        ) {
                            j++;
                            basal[i][j] = new Array(2);
                            basal[i][j][0] = ((st + 86400) <= (val[i][k][1] + val[i][k][3])) ? new Date((st + 86400) * 1000) : new Date((val[i][k][1] + val[i][k][3]) * 1000);
                            basal[i][j][1] = null;
                        }
                    }
                    j++;
                }
            }
        }
        //console.log(basal);
        context.basal = basal;

        // 处理自动模式基础量
        let autoModeBasalList = [];
        let autoModeCorrBolusList = [];

        for (let i = 0; i < val.length; i++) {
            let st = context.timeSection[i][0];
            let autoModeBasal = [];
            let autoModeCorrBolus = [];
            for (let k = 0; k < val[i].length; k++) {
                let basalType = val[i][k][2];
                if ('BAAM' == basalType) {
                    //console.log('autoModeBasal.2:', val[i][k])
                    let microBolus = val[i][k][7];

                    let microBolusJson = [];
                    try {
                        microBolus = JSON.parse(microBolus);
                        //console.log('microBolus:', microBolus);
                        microBolusJson = microBolus['autoModeJSON']
                    } catch (e) {
                        console.log('microBolus error:', e);
                    }
                    //console.log('microBolusJson:', microBolusJson);
                    if (microBolusJson.length > 0) {

                        let index = 0;
                        while (index < microBolusJson.length) {
                            let subRecord = microBolusJson.slice(index, index + 5);
                            let startTime = new Date(val[i][k][1] * 1000 + index * 6 * 60 * 1000);
                            let endTime = new Date(val[i][k][1] * 1000 + (index + subRecord.length) * 6 * 60 * 1000);
                            let totalInject = 0;
                            let totalCorrBolus = 0;
                            subRecord.map(function(e, i) {
                                totalInject += e['auto_basal_delivery'];
                                totalCorrBolus += e['auto_corr_delivery'];
                                totalCorrBolus += e['auto_food_delivery'];
                            })
                            let basalRate = totalInject * 0.05 / (subRecord.length * 6.0 / 60); // 基础量速率单位  U/H

                            let basal_record = [
                                startTime,
                                endTime,
                                basalRate
                            ]
                            autoModeBasal.push(basal_record);

                            if (totalCorrBolus > 0) {
                                autoModeCorrBolus.push([
                                    new Date((startTime.getTime() + endTime.getTime()) / 2),
                                    totalCorrBolus * 0.05
                                ])
                            }

                            index += 5;
                        }
                    }
                }
            }
            //console.log('autoModeBasal.3:', i, autoModeBasal, autoModeCorrBolus);
            autoModeBasalList.push(autoModeBasal);
            autoModeCorrBolusList.push(autoModeCorrBolus)
        }
        context.autoModeBasal = autoModeBasalList;
        context.autoModeCorrBolus = autoModeCorrBolusList;

    },
    getBasalSus3(context, val) {
        let basal = new Array(7);
        let NewBasal = new Array(7);
        let stopBasal = new Array(7);
        let manualStop = new Array(7);
        let tempBasal = new Array(7);
        for (let i = 0; i < val.length; i++) {
            let data = this.getBasalSus4(context, context.timeSection[i][0], val[i]);
            basal[i] = data[0];
            tempBasal[i] = data[1];
            manualStop[i] = data[2];
            let data1 = this.getBasal2(val[i]);
            NewBasal[i] = data1[0];
            stopBasal[i] = data1[1];
        }
        context.basal_suspend = basal;
        context.manualStop = manualStop;
        context.tempBasal = tempBasal;
        context.NewBasal = NewBasal;
        context.stopBasal = stopBasal;
        //console.log( NewBasal,stopBasal)
    },
    getBasalSus4(context, st, val) {
        /*let TextFunc = function (s) {
          return s;
        };

        if (context) {
          TextFunc=context.$t;
        } else {
          console.log('getBasalSus4: context is null');
        }*/
        let TextFunc = context.$t;

        let basal = [],
            tempBasal = [],
            basa2 = [];
        let j = 0,
            k = 0,
            p = 0,
            et = st + 86400;
        for (let i = 0; i < val.length; i++) {
            if (val[i][2] === 'SUSHM' || val[i][2] === 'SUSDM' || val[i][2] === 'SUSLSG' || val[i][2] === 'SUSPLSG' || val[i][2] === 'SUSA') {
                basal[j] = [];
                basal[j][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                basal[j][1] = (val[i - 1]) ? val[i - 1][4] : 0;
                basal[j][2] = context.$t(val[i][2]);
                j++;
                basal[j] = [];
                basal[j][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                basal[j][1] = 0;
                basal[j][2] = context.$t(val[i][2]);
                j++;
                basal[j] = [];
                basal[j][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                basal[j][1] = 0;
                basal[j][2] = context.$t(val[i][2]);
                j++;
                basal[j] = [];
                basal[j][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                basal[j][1] = (val[i + 1]) ? val[i + 1][4] : 0;
                basal[j][2] = context.$t(val[i][2]);
                //判断是否连续
                if (i < val.length - 1) {
                    if (val[i + 1][2] !== 'SUSHM' && val[i + 1][2] !== 'SUSDM' && val[i + 1][2] !== 'SUSLSG' && val[i + 1][2] !== 'SUSPLSG' && val[i + 1][2] !== 'SUSA') {
                        j++;
                        basal[j] = new Array(2);
                        basal[j][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                        basal[j][1] = null;
                        basal[j][2] = context.$t(val[i][2]);
                    }
                }
                j++
            }
            if (val[i][2] === 'BART' || val[i][2] === 'BAAT') {
                //临时基础量总是与暂停相连，因此前后都得判断
                tempBasal[k] = new Array(2);
                tempBasal[k][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                if (val[i - 1]) {
                    if (val[i - 1][2] !== 'SUSM' && val[i - 1][2] !== 'SUSEB') {
                        tempBasal[k][1] = val[i - 1][4];
                    } else {
                        if (val[i - 2]) { tempBasal[k][1] = val[i - 2][4]; } else { tempBasal[k][1] = val[i][4]; }
                    }
                }
                k++;
                tempBasal[k] = new Array(2);
                tempBasal[k][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                tempBasal[k][1] = val[i][4];
                k++;
                tempBasal[k] = new Array(2);
                tempBasal[k][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                tempBasal[k][1] = val[i][4];
                k++;
                tempBasal[k] = new Array(2);
                tempBasal[k][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                if (val[i + 1]) {
                    if (val[i + 1][2] !== 'SUSM' && val[i + 1][2] !== 'SUSEB' && val[i + 1][2] !== 'SUSHM' && val[i + 1][2] !== 'SUSDM' && val[i + 1][2] !== 'SUSLSG' && val[i + 1][2] !== 'SUSPLSG' && val[i + 1][2] !== 'SUSA') {
                        tempBasal[k][1] = val[i + 1][4];
                    } else {
                        if (val[i + 2]) { tempBasal[k][1] = val[i + 2][4]; } else { tempBasal[k][1] = val[i][4]; }
                    }
                }
                //判断是否连续
                if (i < val.length - 1) {
                    if (val[i + 1][2] !== 'BART' && val[i + 1][2] !== 'BAAT') {
                        k++;
                        tempBasal[k] = new Array(2);
                        tempBasal[k][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                        tempBasal[k][1] = null;
                    }
                }
                k++
            }
            if (val[i][2] === 'SUSM' || val[i][2] === 'SUSEB') {
                basa2[p] = new Array(2);
                basa2[p][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                //当出现连续两个暂停时，第一个点要取相邻正常基础量的值
                if (val[i - 1]) {
                    if (val[i - 1][2] === 'BAS' || val[i - 1][2] === 'BAE' || val[i - 1][2] === 'BAH') {
                        basa2[p][1] = val[i - 1][4];
                    } else {
                        if (val[i - 2]) {
                            basa2[p][1] = val[i - 2][4];
                        } else {
                            basa2[p][1] = val[i][4];
                        }
                    }
                }
                p++;
                basa2[p] = new Array(2);
                basa2[p][0] = (st <= val[i][1]) ? new Date(val[i][1] * 1000) : new Date(st * 1000);
                basa2[p][1] = 0;
                p++;
                basa2[p] = new Array(2);
                basa2[p][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                basa2[p][1] = 0;
                p++;
                basa2[p] = new Array(2);
                basa2[p][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                basa2[p][1] = (val[i + 1]) ? val[i + 1][4] : 0;
                //判断是否连续
                if (i < val.length - 1) {
                    if (val[i + 1][2] !== 'SUSM' && val[i + 1][2] !== 'SUEB') {
                        p++;
                        basa2[p] = new Array(2);
                        basa2[p][0] = (et <= (val[i][1] + val[i][3])) ? new Date(et * 1000) : new Date((val[i][1] + val[i][3]) * 1000);
                        basa2[p][1] = null;
                    }
                }
                p++;
            }
        }
        //

        // console.log(basal);
        return [basal, tempBasal, basa2];
    },
    getBolus3(context, val) {
        // console.log(val);
        let bolus = new Array(7);
        let extend_bolus = new Array(7);
        let max = new Array();
        for (let i = 0; i < val.length; i++) {
            let info = this.getBolus(context, context.timeSection[i][0], val[i]);
            bolus[i] = info[0];
            extend_bolus[i] = info[1];
            max[i] = info[2];
        }
        context.bolus = bolus;
        context.extend_bolus = extend_bolus;
        context.bolusMax = (max.length > 0) ? Math.max.apply(null, max) : 5;
    },
    getCalib3(val) {
        //console.log(val);
        let calib = new Array(7);
        for (let i = 0; i < val.length; i++) {
            calib[i] = [];
            for (let j = 0; j < val[i].length; j++) {
                calib[i][j] = new Array(2);
                calib[i][j][0] = new Date(val[i][j][1] * 1000);
                calib[i][j][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[i][j][3] * 18) : val[i][j][3].toFixed(1);
            }
        }
        return calib;
    },
    getBg3(val) {
        let bg = new Array(7);
        for (let i = 0; i < val.length; i++) {
            bg[i] = [];
            for (let j = 0; j < val[i].length; j++) {
                bg[i][j] = new Array(2);
                bg[i][j][0] = new Date(val[i][j][0] * 1000);
                bg[i][j][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[i][j][1] * 18) : val[i][j][1].toFixed(1);
            }
        }
        return bg;
    },
    getMealTime(Mtime, Dtime) {
        let timeb = [],
            timel = [],
            times = [],
            num = (localStorage.getItem('unit') === 'mg') ? 400 : 25;
        for (let i = 0; i < Dtime.length; i++) {
            timeb[i] = new Array(3);
            timeb[i][0] = new Date((Dtime[i][0] + Mtime[0][0] * 60) * 1000);
            timeb[i][1] = new Date((Dtime[i][0] + Mtime[0][1] * 60) * 1000);
            timeb[i][2] = num;

            timel[i] = new Array(3);
            timel[i][0] = new Date((Dtime[i][0] + Mtime[1][0] * 60) * 1000);
            timel[i][1] = new Date((Dtime[i][0] + Mtime[1][1] * 60) * 1000);
            timel[i][2] = num;

            times[i] = new Array(3);
            times[i][0] = new Date((Dtime[i][0] + Mtime[2][0] * 60) * 1000);
            times[i][1] = new Date((Dtime[i][0] + Mtime[2][1] * 60) * 1000);
            times[i][2] = num;

        }
        return [timeb, timel, times];
    },
    getTransmtr2(context, val) {
        //console.log('getTransmtr2:'+val);
        let trans = [];
        for (let i = 0; i < val.length; i++) {
            trans[i] = this.getTransmtr(context, val[i]);
        }
        context.trans = trans;
    },

    /*图表tooltip自定义*/
    formatterTip(params, context, flag) {
        //if (!context)   // 可能导致 tip显示不出来, 不加， 有可能导致崩溃.
        //  return '';
        // console.log('formatterTip:', params);
        //console.log('basal_unit:', context.$t('basal_unit2'));

        //
        let data_source = sessionStorage.getItem('data_source');

        // 这个有问题
        let basal_unit = 'U/H';
        let ins_unit2 = 'U';
        if (true) {
            try {
                let basal_unit = context.$t('basal_unit2');
                let ins_unit2 = context.$t('ins_unit2');
            } catch (e) {

            }
        }
        //let basal_unit = 'U/H';
        //let ins_unit2 = 'U';

        let that = this;
        let tipArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            tip = '',
            timeDetail = '';
        params.map(function(e, i) {

            if (e.value[0] !== 10) {
                let index = e.seriesIndex;
                let name = e.seriesName;
                let value = e.value[1];
                let date = e.value[0];
                let time = that.formatterDate5(date);
                let day = that.formatterDate4(date.getTime() / 1000);
                timeDetail = day + '  ' + time[0] + ':' + time[1] + '<br>';


                if ((index === 0 || index === 2)) { // basal
                    value = Math.round(value * 100) / 100;
                    let icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[index] = icon + name + ' :  ' + value + basal_unit;
                    if (!value) {
                        tipArray[index] = 0; /*通过判断是否连续来确定新数据是哪种类型*/
                    }
                }
                if (index === 1 && value) { // auto suspend
                    let icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[1] = icon + e.value[2];
                }
                if (index === 3 && value) {
                    let icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[3] = icon + name;
                }
                if (index === 4 && value) { // normal bolus
                    //console.log('normal bolus:', e.value)
                    let icon = " <div style='background: #182f82;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[4] = icon + name + ' :  ' + e.value[2] + ', ' + value.toFixed(2) + ins_unit2;
                    //tipArray[4] += '<br/>123'
                    try {
                        let wizzard_info = e.value[3];
                        wizzard_info = JSON.parse(wizzard_info);
                        let wizzard_carb = wizzard_info['carb'];
                        let wizzard_bg = wizzard_info['bg'];
                        let wizzard_iob = wizzard_info['iob'];
                        let adjustmentType = wizzard_info['adjustmentType'];
                        //
                        let iobName = 'Active insulin:';
                        if (wizzard_bg) {
                            if (context.isMg) {
                                wizzard_bg = round(wizzard_bg * 18) + ' mg/dL'
                            } else {
                                wizzard_bg = wizzard_bg.toFixed(1) + ' mmol/L'
                            }
                        }
                        if (adjustmentType) {
                            iobName = 'Adjustment:'
                        } else {

                            if (wizzard_iob > 100) {
                                iobName = 'Adjustment:'
                                if (wizzard_iob > 500) {
                                    let val = (Math.round(wizzard_iob / 0.05) & 0x3fff)
                                    if (val > 0x1fff) {
                                        wizzard_iob = (val - 0x4000) * 0.05
                                    } else if (val >= 0) {
                                        wizzard_iob = (val) * 0.05
                                    }

                                } else {
                                    let val = (Math.round(wizzard_iob / 0.01) & 0x3fff);
                                    if (val > 0x1fff) {
                                        wizzard_iob = (val - 0x4000) * 0.01
                                    } else if (val >= 0) {
                                        wizzard_iob = (val) * 0.01;
                                    }

                                }
                            }
                        }


                        if (wizzard_carb && wizzard_bg) {
                            tipArray[4] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + wizzard_carb + ' g, BG:' + wizzard_bg +
                                '<br/>&nbsp;&nbsp;&nbsp;' + iobName + wizzard_iob.toFixed(2) + ' U';
                        } else if (wizzard_carb) {
                            tipArray[4] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + wizzard_carb + ' g' +
                                '<br/>&nbsp;&nbsp;&nbsp;' + iobName + wizzard_iob.toFixed(2) + ' U';
                        } else if (wizzard_bg) {
                            tipArray[4] += '<br/>&nbsp;&nbsp;&nbsp;' + 'BG:' + wizzard_bg +
                                '<br/>&nbsp;&nbsp;&nbsp;' + iobName + wizzard_iob.toFixed(2) + ' U';
                        }
                    } catch (e) {}
                }
                if (index === 5 && value) { // extend bolus
                    //console.log('extend bolus:', e.value)
                    let icon = " <div style='background: #f9b4ff;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[5] = icon + name + ' :  ' + e.value[4] + ', ' + e.value[2].toFixed(2) + ins_unit2 + '/' + e.value[7] + 'min';
                    try {
                        let wizzard_info = e.value[5];
                        wizzard_info = JSON.parse(wizzard_info);
                        let wizzard_carb = wizzard_info['carb'];
                        let wizzard_bg = wizzard_info['bg'];
                        let wizzard_iob = wizzard_info['iob'];
                        if (wizzard_bg) {
                            if (context.isMg) {
                                wizzard_bg = Math.round(wizzard_bg * 18) + ' mg/dL'
                            } else {
                                wizzard_bg = (wizzard_bg).toFixed(1) + ' mmol/L'
                            }
                        }
                        if (wizzard_carb && wizzard_bg) {
                            tipArray[5] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + wizzard_carb + ' g, BG:' + wizzard_bg +
                                '<br/>&nbsp;&nbsp;&nbsp;Active insulin:' + wizzard_iob.toFixed(2) + ' U';
                        } else if (wizzard_carb) {
                            tipArray[5] += '<br/>&nbsp;&nbsp;&nbsp;' + 'Carb:' + wizzard_carb + ' g' +
                                '<br/>&nbsp;&nbsp;&nbsp;Active insulin:' + wizzard_iob.toFixed(2) + ' U';
                        } else if (wizzard_bg) {
                            tipArray[5] += '<br/>&nbsp;&nbsp;&nbsp;' + 'BG:' + wizzard_bg +
                                '<br/>&nbsp;&nbsp;&nbsp;Active insulin:' + wizzard_iob.toFixed(2) + ' U';
                        }
                    } catch (e) {
                        console.log('extend bolus tip:', e);
                    }
                }
                if (index === 6 && value) {
                    let icon = " <div style='background:yellowgreen;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[6] = icon + name;
                }
                if (index === 7 && value) {
                    let icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[7] = icon + name;
                }
                if (index === 8 && value) {
                    if ('chart2' == flag) {
                        // tipArray[8] = 'abs'
                        value = Math.round(e.value[2] * 100) / 100;
                        tipArray[8] = name + ':' + value + basal_unit;
                    } else {
                        let icon = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
                        tipArray[8] = icon + name + ' :  ' + e.value[2];
                    }
                }
                if (index === 9 && value) {
                    if ('chart2' == flag) {
                        tipArray[9] = name + ':' + value.toFixed(2) + ins_unit2; // auto corr bolus
                    }
                }
                if (index === 10 && value) {
                    if ('chart1' == flag || 'monitor' == flag) {
                        value = Math.round(e.value[2] * 100) / 100;
                        tipArray[10] = name + ':' + value + basal_unit;
                    }
                }
                if (index === 11 && value) {
                    if ('chart1' == flag || 'monitor' == flag) { // auto mode corr bolus
                        tipArray[11] = name + ':' + value.toFixed(2) + ins_unit2;
                    }
                }
            }
        });
        tip = tip + timeDetail;
        tipArray.map(function(e, i) {
            if (e) {
                tip = tip + e + '<br>';
            }
        });
        //console.log('tip:', tip);
        return tip;
    },
    formatterTip1(params, context, flag) {
        //console.log('formatterTip1:', flag);
        //console.log(params);
        let that = this;
        let tipArray = [0, 0, 0, 0, 0],
            tip = '',
            timeDetail = '',
            unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
        let icon = " <div style='background: #2cd200;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon1 = " <div style='background: #e6be00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon2 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon3 = " <div style='background: #a4a4a4;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon4 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        params.map(function(e, i) {
            if (e.value[0] !== 10) {
                let index = e.seriesIndex;
                let name = e.seriesName;
                let value = e.value[1];
                let date = e.value[0];
                let time = that.formatterDate5(date);
                let day = that.formatterDate3(date.getTime() / 1000);
                timeDetail = day + '  ' + time[0] + ':' + time[1] + '<br>';
                if (index === 0) {
                    let type = e.value[2],
                        tip0 = '';
                    if (value > 0 && (type!='DE')) {
                        let value1 = '',
                            ico = icon;

                        let isHighLow = true;

                        try {
                            //console.log('monitor sg tip:', value, typeof(value));
                            let sg_val = parseFloat(value);
                            if (context.isMg) {
                                if (sg_val >= 400) {
                                    value = 'High';
                                } else if (sg_val <= 40) {
                                    value = 'Low';
                                } else {
                                    isHighLow = false;
                                }
                            } else {
                                if (sg_val >= 22.2) {
                                    value = 'High';
                                } else if (sg_val <= 2.2) {
                                    value = 'Low';
                                } else {
                                    isHighLow = false;
                                }
                            }
                            //console.log('monitor sg tip:', value, isHighLow);
                        } catch (e) {
                            console.log('sg tip:', e)
                        }

                        if (type === 'CX' || type === 'NC') {
                            // let hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:45px;top: 45px;position: absolute">';
                            // let hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:70px;top: 45px;position: absolute">';
                            // let hr3 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:140px;top: 45px;position: absolute">';
                            // value1 = (context.isEn)?value+hr1:value+hr2;
                            // if(context.isFr){
                            //   value1 = value+hr3;
                            // }
                            // value1 = '<div style="text-decoration: underline">'+value+'</div>';
                            value1 = '<span style="border-bottom: 1px solid #fff;display: inline-block">' + value + '</span>';
                        } else {
                            value1 = value;
                        }
                        if (context.isMg) {
                            ico = (value > context.DataS.blos_high * 18) ? icon1 : ico;
                            ico = (value < context.DataS.blos_low * 18) ? icon2 : ico;
                        } else {
                            ico = (value > context.DataS.blos_high) ? icon1 : ico;
                            ico = (value < context.DataS.blos_low) ? icon2 : ico;
                        }
                        if(value=='High'){
                            ico=icon1
                          }else if(value=='Low'){
                            ico=icon2
                          }
                        if (isHighLow) {
                            tip0 = ico + context.$t(name) + ' : ' + value1;
                        } else {
                            tip0 = ico + context.$t(name) + ' : ' + value1 + unit;
                        }

                        /*
                        if (context.isMg){
                          if (value1>=400){
                            tip0=ico+context.$t(name)+' : '+'High';
                          } else if (value1<=40) {
                            tip0=ico+context.$t(name)+' : '+'Low';
                          } else {
                            tip0 = ico+context.$t(name)+' : '+value1+unit;
                          }
                        } else {
                          if (value1>=22.2){
                            tip0=ico+context.$t(name)+' : '+'High';
                          } else if (value1<=2.2) {
                            tip0=ico+context.$t(name)+' : '+'Low';
                          } else {
                            tip0 = ico+context.$t(name)+' : '+value1+unit;
                          }
                        }
                        */

                    } else {
                        let ico = icon4,
                            text = '';
                        if (type === 'NC') { text = context.$t('Not Calibrated'); }
                        if (type === 'DE') { text = context.$t('noReadings'); }
                        if (type === 'CE0' || type === 'CE1') { text = context.$t('Calibration Error'); }
                        if (type === 'H') {
                            ico = icon3;
                            text = context.$t('warm');
                        }
                        tip0 = ico + text;
                    }
                    tipArray[0] = tip0;
                }
                if (index === 1) {
                    let icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[1] = icon5 + context.$t('calib') + ' : ' + value + unit;
                }

                if ('ds' == flag) {
                    if (index === 2) {
                        let icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                        tipArray[2] = icon5 + context.$t('BG') + ' : ' + value + unit;
                    }
                    if (index === 3) {
                        let icon5 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                        tipArray[3] = icon5 + context.$t('newSen');
                    }
                    if (index === 4) {
                        let icon5 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
                        tipArray[4] = icon5 + context.$t('alert') + ' : ' + e.value[2];
                    }
                } else if ('rt' == flag) {
                    if (index === 2) {
                        let icon5 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
                        tipArray[2] = icon5 + context.$t('alert') + ' : ' + e.value[2];
                    }
                    if (index === 3) {
                        let icon5 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                        tipArray[3] = icon5 + context.$t('newSen');
                    }
                }

            }

        });
        tip = tip + timeDetail;
        tipArray.map(function(e, i) {
            if (e) {
                tip = tip + e + '<br>';
            }
        });
        //console.log('tip1:', tip);
        return tip;
    },
    formatterTip2(params, context) {
        //console.log(params);
        let that = this;
        let tipArray = [0, 0, 0, 0],
            tip = '',
            timeDetail = '',
            unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
        let icon = " <div style='background: #2cd200;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon1 = " <div style='background: #e6be00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon2 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon3 = " <div style='background: #a4a4a4;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon4 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        params.map(function(e, i) {
            if (e.value[0] !== 10) {
                let index = e.seriesIndex;
                let name = e.seriesName;
                let value = e.value[1];
                let date = e.value[0];
                let time = that.formatterDate5(date);
                let day = that.formatterDate4(date.getTime() / 1000);
                timeDetail = day + '  ' + time[0] + ':' + time[1] + '<br>';
                //专门对应DayByDay,index排序不一样
                if (index === 3) {
                    let type = e.value[2],
                        tip0 = '';
                    if (value > 0) {
                        let value1 = '',
                            ico = icon;

                        // 显示 High， Low
                        let isHighLow = true;

                        try {
                            //console.log('monitor sg tip:', value, typeof(value));
                            let sg_val = parseFloat(value);
                            if (context.isMg) {
                                if (sg_val >= 400) {
                                    value = 'High';
                                } else if (sg_val <= 40) {
                                    value = 'Low';
                                } else {
                                    isHighLow = false;
                                }
                            } else {
                                if (sg_val >= 22.2) {
                                    value = 'High';
                                } else if (sg_val <= 2.2) {
                                    value = 'Low';
                                } else {
                                    isHighLow = false;
                                }
                            }
                            //console.log('monitor sg tip:', value, isHighLow);
                        } catch (e) {
                            console.log('sg tip:', e)
                        }

                        //
                        if (type === 'CX' || type === 'NC') {
                            let hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:45px;top: 45px;position: absolute">';
                            let hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:70px;top: 45px;position: absolute">';
                            let hr3 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:140px;top: 45px;position: absolute">';
                            value1 = (context.isEn) ? value + hr1 : value + hr2;
                            if (context.isFr) {
                                value1 = value + hr3;
                            }
                        } else {
                            value1 = value;
                        }
                        if (context.isMg) {
                            ico = (value > context.DataD.target_high * 18) ? icon1 : ico;
                            ico = (value < context.DataD.target_low * 18) ? icon2 : ico;
                        } else {
                            ico = (value > context.DataD.target_high) ? icon1 : ico;
                            ico = (value < context.DataD.target_low) ? icon2 : ico;
                        }

                        if (isHighLow) {
                            tip0 = ico + context.$t(name) + ' : ' + value1;
                        } else {
                            tip0 = ico + context.$t(name) + ' : ' + value1 + unit;
                        }

                    } else {
                        let ico = icon4,
                            text = '';
                        if (type === 'NC') { text = context.$t('Not Calibrated'); }
                        if (type === 'DE') { text = context.$t('noReadings'); }
                        if (type === 'CE0' || type === 'CE1') { text = context.$t('Calibration Error'); }
                        if (type === 'H') {
                            ico = icon3;
                            text = context.$t('warm');
                        }
                        tip0 = ico + text;
                    }
                    tipArray[0] = tip0;
                }
                if (index === 0) {
                    let icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[1] = icon5 + context.$t('calib') + ' : ' + value + unit;
                }
                if (index === 1) {
                    let icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[2] = icon5 + context.$t('BG') + ' : ' + value + unit;
                }
                if (index === 2) {
                    let icon5 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                    tipArray[3] = icon5 + context.$t('newSen');
                }
            }
        });
        tip = tip + timeDetail;
        tipArray.map(function(e, i) {
            if (e) {
                tip = tip + e + '<br>';
            }
        });
        return tip;
    },
    formatterTip3(params, context) {
        // console.log(params);
        let that = this;
        let tipArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            tip = '',
            timeDetail = '',
            unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
        let icon0 = " <div style='background: #3ce8dc;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon1 = " <div style='background: #2842d2;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon2 = " <div style='background: #79bd39;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon3 = " <div style='background: #dce573;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon4 = " <div style='background: #e61795;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon5 = " <div style='background: #c9711e;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon6 = " <div style='background: #a922d9;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        let icon7 = " <div style='background: #464646;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        params.map(function(e, i) {
            let index = e.seriesIndex;
            let value = e.value[1];
            let date = e.value[0];
            let time = that.formatterDate5(date);
            let t1 = '';
            timeDetail = context.$t('SG') + ' ' + time[0] + ':' + time[1] + '<br>';
            if (index < 8) {
                let type = e.value[2],
                    tip0 = '',
                    ico = icon0;
                if (index < 7) {
                    let t2 = context.legendDate[index].split('-');
                    t1 = t2[0] + '/' + t2[1];
                } else {
                    t1 = context.$t('Avg');
                }
                ico = (index === 1) ? icon1 : ico;
                ico = (index === 2) ? icon2 : ico;
                ico = (index === 3) ? icon3 : ico;
                ico = (index === 4) ? icon4 : ico;
                ico = (index === 5) ? icon5 : ico;
                ico = (index === 6) ? icon6 : ico;
                ico = (index === 7) ? icon7 : ico;
                if (value > 0) {
                    let value1 = '';

                    //  显示 High Low
                    let isHighLow = true;

                    try {
                        //console.log('monitor sg tip:', value, typeof(value));
                        let sg_val = parseFloat(value);
                        if (context.isMg) {
                            if (sg_val >= 400) {
                                value = 'High';
                            } else if (sg_val <= 40) {
                                value = 'Low';
                            } else {
                                isHighLow = false;
                            }
                        } else {
                            if (sg_val >= 22.2) {
                                value = 'High';
                            } else if (sg_val <= 2.2) {
                                value = 'Low';
                            } else {
                                isHighLow = false;
                            }
                        }
                        //console.log('monitor sg tip:', value, isHighLow);
                    } catch (e) {
                        console.log('sg tip:', e)
                    }

                    if (type === 'CX' || type === 'NC') {
                        let top1 = 45 * (index + 1) + 'px';
                        let hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:65px;;position: absolute;top:"' + top1 + '>';
                        let hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:90px;;position: absolute;top:"' + top1 + '>';
                        value1 = (context.isEn) ? value + hr1 : value + hr1;
                    } else {
                        value1 = value;
                    }
                    if (isHighLow) {
                        tip0 = ico + t1 + ' : ' + value1;
                    } else {
                        tip0 = ico + t1 + ' : ' + value1 + unit;
                    }
                } else {
                    let text = '';
                    if (type === 'NC') { text = context.$t('Not Calibrated'); }
                    if (type === 'DE') { text = context.$t('noReadings'); }
                    if (type === 'CE0' || type === 'CE1') { text = context.$t('Calibration Error'); }
                    if (type === 'H') { text = context.$t('warm'); }
                    tip0 = ico + t1 + ' : ' + text;
                }
                tipArray[index] = tip0;
            }
            if (index === 8) {
                let icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                tipArray[8] = icon8 + context.$t('calib') + ' : ' + value + unit;
            }
            if (index === 9) {
                let icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                tipArray[9] = icon8 + context.$t('BG') + ' : ' + value + unit;
            }
        });
        tip = tip + timeDetail;
        tipArray.map(function(e, i) {
            if (e) {
                tip = tip + e + '<br>';
            }
        });
        return tip;
    },

    //sensorOverlay
    getOl(context, uid, param) {
        let that = this;
        let t1 = new Date();
        context.$http.get('/api/v2.1/chart/' + uid + '/data/ol', { params: { param } }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                //console.log('overlay data:', res.body.data);
                //console.log(res);
                if (context.chart3_1) {
                    context.chart3_1.dispose();
                    context.chart3_1 = null;
                    context.DataSG = [];
                }
                context.$store.commit('updateDataS', res.body.data);
                //
                if (false) { // 测试数据
                    let dayNum = res.body.data.sg.length;
                    let sgData = res.body.data.sg[dayNum - 1];
                    //console.log("ol.sg:", sgData);
                    let dataNum = sgData.length;
                    let start = 0;
                    let end = dataNum;
                    if (dataNum > 50) {
                        start = dataNum - 50;
                        end = 50;
                    }
                    for (let i = start; i < dataNum; i++) {
                        //sgData[i][1] -= 5;
                    }

                    for (let i = 0; i < end; i++) {
                        if (sgData[i][1] > 5) {
                            //sgData[i][1] -= 5;
                            sgData[i][1] += 18;
                            //if ()
                        }
                    }

                }
                context.DataSG = that.getSG2(context, res.body.data);
                context.calib = that.getCalib5(context, res.body.data.calib);
                context.bg = that.getBg5(context, res.body.data.bg);
                let t2 = new Date();
                //
                //console.log('DataSG:', context.DataSG, context.startTime, context.avg);
                context.drawChart3_1();
                /*let option =context.chart3_1.getOption();
        //context.DataSG.map(function (e,i) {
         //option.series[i].data = e;
       // });
       // context.chart3_1.setOption(option);*/
                context.checkLegend();
                // console.log('总时间：'+ (new Date()-t1)+'ms');

                // 处理报告数据
                if (context.getOlReportInfo) {
                    context.getOlReportInfo(res.body.report_data)
                }
            }
        }, function(err) {
            let tip = context.$t('tryAgain');
            context.$message.error(tip);
        });
    },
    getSG2(context, val) {
        let time = [],
            SG = [],
            k = 0,
            kday = [],
            flag = 0,
            f1 = 0,
            p = 0,
            isEn = (localStorage.getItem('unit') === 'mg');
        let length = val.sg.length;
        //找到第一天
        for (let i = 0; i < length; i++) {
            if (val.sg[i].length > 0 && flag === 0) {
                f1 = i;
                flag = 1;
                break;
            }
        }
        for (let i = 0; i < length; i++) {
            if (val.sg[i].length > 0) {
                //计算相隔多少天
                if (false) {
                    let t0 = this.formatterDate3(val.sg[f1][0][0]).split('-');
                    let t1 = this.formatterDate3(val.sg[i][0][0]).split('-');
                    let m = parseInt(t0[1]);
                    if (m === 1 || m === 3 || m === 5 || m === 7 || m === 8 || m === 10 || m === 12) {
                        k = (parseInt(t1[1]) - m) * 31 + parseInt(t1[2]) - parseInt(t0[2]);
                    } else if (m === 2) { // 四年一遇的 bug
                        k = (parseInt(t1[1]) - m) * 28 + parseInt(t1[2]) - parseInt(t0[2]);
                    } else {
                        k = (parseInt(t1[1]) - m) * 30 + parseInt(t1[2]) - parseInt(t0[2]);
                    }
                } else {
                    //k=i-f1;
                    let t0 = val.sg[f1][0][0];
                    let t1 = val.sg[i][0][0];
                    let d0 = new Date(t0 * 1000);
                    let d1 = new Date(t1 * 1000);
                    d0 = new Date(d0.getFullYear(), d0.getMonth(), d0.getDate());
                    d1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
                    t0 = d0.getTime() / 1000;
                    t1 = d1.getTime() / 1000;
                    k = (t1 - t0) / 86400;
                    //while (t0+k*86400<) {
                    //}
                }

                kday.push(k);
                SG[p] = new Array(720);
                let length1 = val.sg[i].length;
                for (let j = 0; j < length1; j++) {
                    time[j] = new Date((val.sg[i][j][0] - k * 3600 * 24) * 1000);
                    SG[p][j] = new Array(3);
                    SG[p][j][0] = time[j];
                    SG[p][j][1] = (val.sg[i][j][1] > 22.2) ? 22.2 : val.sg[i][j][1].toFixed(1);
                    if (SG[p][j][1] < 2.2 && (val.sg[i][j][4] === 'C' || val.sg[i][j][4] === 'CX')) {
                        SG[p][j][1] = 2.2;
                    }
                    SG[p][j][1] = (isEn) ? Math.round(SG[p][j][1] * 18) : parseFloat(SG[p][j][1]);
                    if (val.sg[i][j][4] === 'DE') {
                        SG[p][j][1] = 0;
                    }
                    SG[p][j][2] = val.sg[i][j][4];
                }
                p++;
            }
        }
        let st = 0;
        if (val.sg[f1].length > 1) {
            st = this.formatterDate3(val.sg[f1][0][0]) + ' 00:00:00';
            st = Date.parse(st.replace(/-/g, "/"));
        } else {
            st = val.time_sec[0][0] * 1000;
        }
        context.startTime = st;
        context.Kday = kday;

        if (length > 1) {
            context.getAverage(SG);
        }
        return SG;
    },
    getCalib5(context, val) {
        let startDate = this.formatterDate9(context.startTime / 1000);
        let calib = [];
        let p = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i].length > 0) {
                for (let j = 0; j < val[i].length; j++) {
                    //获取时分秒
                    let nt = this.formatterDate10(val[i][j][1]);
                    calib[p] = new Array(3);
                    calib[p][0] = new Date(startDate[0], startDate[1], startDate[2], nt[0], nt[1], nt[2]);
                    calib[p][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[i][j][3] * 18) : val[i][j][3].toFixed(1);
                    calib[p][2] = this.formatterDate2(val[i][j][1]);
                    p++;
                }
            }
        }
        //console.log(calib)
        return calib;
    },
    getBg5(context, val) {
        //获取具体哪一天
        let startDate = this.formatterDate9(context.startTime / 1000);
        let bg = [];
        let p = 0;
        for (let i = 0; i < val.length; i++) {
            if (val[i].length > 0) {
                for (let j = 0; j < val[i].length; j++) {
                    bg[p] = new Array(3);
                    //获取时分秒
                    let nt = this.formatterDate10(val[i][j][0]);
                    bg[p][0] = new Date(startDate[0], startDate[1], startDate[2], nt[0], nt[1], nt[2]);
                    bg[p][1] = (localStorage.getItem('unit') === 'mg') ? Math.round(val[i][j][1] * 18) : val[i][j][1].toFixed(1);
                    bg[p][2] = this.formatterDate2(val[i][j][0]);
                    p++;
                }
            }
        }
        //console.log(bg)
        return bg;
    },

    //Trend Analysis
    getTa(context, uid, param) {
        let that = this;
        context.$http.get('/api/v2.1/chart/' + uid + '/data/ta', { params: { param } }).then(function(res) {
            let err = res.body.error;
            // console.log(res);
            if (err === 0) {
                // console.log(res.data);
                context.$store.commit('updateDataS', res.body.data);
                let ba0 = that.getTaData1(res.body.data.glucose_analysis);
                context.TaData1 = ba0[0];
                context.bgMax = ba0[1];
                let ba = that.getTaData2(res.body.data.inject_summary);
                context.TaData2 = ba[0];
                context.basalMax = ba[1];
                context.TaData3 = that.getTaData3(res.body.data.glucose_analysis);
                if (context.chart4_1) {
                    context.chartsDispose();
                }
                context.drwCharts();
                //
                if (context.getTaReportInfo) {
                    context.getTaReportInfo(res.body.report_data)
                }
            }
        }, function(err) {
            console.log(err + "," + err.body.message);
            this.error = err.body.message
        });
    },
    getTaData1(val) {
        let length = val.length,
            max = [];
        let TaData1 = [];
        let bg = new Array(3);
        bg[0] = new Array(length);
        bg[1] = new Array(length);
        bg[2] = new Array(length);
        let sg = new Array(3);
        sg[0] = new Array(length);
        sg[1] = new Array(length);
        sg[2] = new Array(length);
        for (let i = 0; i < length; i++) {
            bg[0][i] = val[i].bgdist[0];
            bg[1][i] = val[i].bgdist[1];
            bg[2][i] = val[i].bgdist[2];
            sg[0][i] = (val[i].sgdist[0] * 100).toFixed(1);
            sg[1][i] = (val[i].sgdist[1] * 100).toFixed(1);
            sg[2][i] = (val[i].sgdist[2] * 100).toFixed(1);
        }
        TaData1[0] = bg;
        TaData1[1] = sg;
        max[0] = (bg[0].length > 1) ? Math.max.apply(null, bg[0]) : 5;
        max[1] = (bg[1].length > 1) ? Math.max.apply(null, bg[1]) : 5;
        max[2] = (bg[2].length > 1) ? Math.max.apply(null, bg[2]) : 5;
        let max1 = Math.max.apply(null, max);
        if (max1 < 10) { max1 = 10; } else if (max1 < 20) { max1 = 20; } else if (max1 < 30) { max1 = 30; } else if (max1 < 40) { max1 = 40; }
        return [TaData1, max1];
    },
    getTaData2(val) {
        let length = val.length,
            max = 25,
            max2 = 0,
            max1 = 0;
        let data2 = new Array(2);
        data2[0] = new Array(length);
        data2[1] = new Array(length);
        for (let i = 0; i < length; i++) {
            data2[0][i] = val[i][1];
            data2[1][i] = val[i][2];
        }
        max1 = (data2[0].length > 1) ? Math.max.apply(null, data2[0]) : 25;
        max2 = (data2[1].length > 1) ? Math.max.apply(null, data2[1]) : 25;
        max = (max1 > max2) ? max1 : max2;

        if (max < 20) { max = 20; } else if (max < 30) { max = 30; } else if (max < 40) { max = 40; } else if (max < 50) { max = 50; } else if (max < 100) { max = 100; } else if (max < 150) { max = 150; } else if (max < 200) { max = 200; } else { max = 250; }
        return [data2, max];
    },
    getTaData3(val) {
        let length = val.length,
            j = 0,
            k = 0,
            data3 = [],
            flag = (localStorage.getItem('unit') === 'mg');
        data3[0] = new Array(length);
        data3[1] = new Array(length);
        for (let i = 0; i < length; i++) {
            if (val[i].sgbs.length > 0) {
                data3[0][i] = (flag) ? Math.round(val[i].sgbs[0] * 18) : val[i].sgbs[0].toFixed(1);
                data3[1][i] = new Array(5);
                data3[1][i][0] = (flag) ? Math.round(val[i].sgbs[4] * 18) : val[i].sgbs[4].toFixed(1);
                data3[1][i][1] = (flag) ? Math.round(val[i].sgbs[2] * 18) : val[i].sgbs[2].toFixed(1);
                data3[1][i][2] = (flag) ? Math.round(val[i].sgbs[1] * 18) : val[i].sgbs[1].toFixed(1);
                data3[1][i][3] = (flag) ? Math.round(val[i].sgbs[3] * 18) : val[i].sgbs[3].toFixed(1);
                data3[1][i][4] = (flag) ? Math.round(val[i].sgbs[5] * 18) : val[i].sgbs[5].toFixed(1);
            } else {
                data3[0][i] = null;
                data3[1][i] = new Array(5);
            }
        }
        // console.log(data3[1]);
        return data3;
    },

    //LogBook
    /*
    getLgb(context,uid,param){
      let that = this;
      context.$http.get('/api/v2.0/chart/'+uid+'/data/lgb',{params:{param}}).then(function (res) {
        let err =res.body.error;
        if(err === 0){
          let mt = res.data.data.meal_time.map(function (e,i) {
            e[0] =Math.round(e[0]/60);
            e[1] = Math.round(e[1]/60);
            return e;
          });
          console.log( res.data.data)
          context.bgAvg = res.data.data.bg_stat;
          context.carb = res.data.data.carb_stat;
          context.ins = res.data.data.ins_stat;
          context.ins.map(function (e,i) {
              e.percent = (e.percent)?e.percent.toFixed(1):0;
          });
          let tz =parseInt(sessionStorage.getItem('tz'));
          context.whichDate = res.data.data.datelist;
          context.whichDate = res.data.data.datelist.map(function (e,i) {
            let t =e.split('-');
            let t1 = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime();
            let time = new Date(t1+tz*3600000).toUTCString();
            let sp1 = time.split(',');
            let sp2 = sp1[1].split(' ');
             e = sp2[2]+' '+sp2[1]+', '+sp2[3]+' '+sp1[0];
            return e;
          });
          let bg = that.getBg(res.data.data.bg);
          let carbs =  that.getBg(res.data.data.carb);
          that.getNoMeal(context,mt,carbs);
          let ins = that.getIns(context,res.data.data.ins);
          context.initTable();
          context.makecarb(carbs);
          context.makebg(bg);
          context.makeins(ins);
          context.makeOth(context.autoStop,0);
          context.makeOth(context.manualStop,1);
          context.makeOth(context.stop,2);
          context.makeOth(context.Newer,3);
          context.makeNoMeal();
        }
      },function(err){
        this.error = err.body.message
      });
    }, */
    getBg(val) {
        let bg = [];
        for (let i = 0; i < val.length; i++) {
            bg[i] = [];
            let k = 0;
            for (let j = 0; j < val[i].length; j++) {
                if (val[i][j].disp !== '') {
                    bg[i][k] = new Array(3);
                    bg[i][k][0] = j;
                    bg[i][k][1] = val[i][j].disp;
                    bg[i][k][2] = val[i][j].color;
                    k++;
                }
            }
        }
        return bg;
    },
    getIns(context, val) {
        //console.log(val);
        let bg = [],
            autoStop = [],
            manualStop = [],
            stop = [],
            Newer = [];
        for (let i = 0; i < val.length; i++) {
            bg[i] = [];
            autoStop[i] = [];
            manualStop[i] = [];
            stop[i] = [];
            Newer[i] = [];
            let k = 0,
                p = 0,
                q = 0,
                o = 0,
                s = 0;
            for (let j = 0; j < val[i].length; j++) {
                if (val[i][j].disp !== 0) {
                    bg[i][k] = new Array(2);
                    bg[i][k][0] = j;
                    bg[i][k][1] = val[i][j].disp;
                    k++;
                }
                if (val[i][j].basal) {
                    for (let w = 0; w < val[i][j].basal.length; w++) {
                        let va = val[i][j].basal[w];
                        if (va[2] === 'SUSHM' || va[2] === 'SUSDM' || va[2] === 'SUSLSG' || va[2] === 'SUSPLSG' || va[2] === 'SUSA') {
                            autoStop[i][p] = j;
                            p++;
                        }
                        if (va[2] === 'SUSM' || va[2] === 'SUSEB') {
                            manualStop[i][q] = j;
                            q++;
                        }
                        if (va[2] === 'ENDM' || va[2] === 'ENDEM' || va[2] === 'ENDPE' || va[2] === 'ENDEP' || va[2] === 'ENDPB' || va[2] === 'ENDCE' || va[2] === 'ENDPBE') {
                            stop[i][o] = j;
                            o++;
                        }
                        if (va[2] === 'NEW') {
                            Newer[i][s] = j;
                            s++;
                        }
                    }
                }
            }
        }
        context.autoStop = autoStop;
        context.manualStop = manualStop;
        context.stop = stop;
        context.Newer = Newer;
        return bg;
    },
    getNoMeal(context, mt, val) {
        let noMeal = [];
        for (let i = 0; i < val.length; i++) {
            noMeal[i] = [0, 0, 0];
            if (val[i].length !== 0) {
                for (let j = 0; j < val[i].length; j++) {
                    for (let k = 0; k < 3; k++) {
                        if (val[i][j][0] >= mt[k][0] && val[i][j][0] <= mt[k][1]) {
                            noMeal[i][k] = 1;
                        }
                    }
                }
            }
        }
        context.mt = mt;
        context.noMeal = noMeal;
    },

    getLgb1(context, uid, param) {
        let that = this;
        context.$http.get('/api/v2.1/chart/' + uid + '/data/lgb', { params: { param } }).then(function(res) {
            let err = res.body.error;
            //console.log('getLgb1.p0:'+err)
            if (err === 0) {
                //console.log('getLgb1.0:')
                context.initTable();
                let data = res.data.data;
                console.log("logbook:", data);
                // 计算 pump_device
                if (1) {
                    let basal_data = [];

                    //let sg_data=[];
                    for (var i in res.body.data.basal) {
                        //console.log('basal_all.item:', item);
                        basal_data = basal_data.concat(res.body.data.basal[i]);
                    }
                    console.log('basal_data:', basal_data);
                    that.parseDeviceSN(context, basal_data);
                }

                let mt1 = [];
                let mt = data.meal_time.map(function(e, i) {
                    /*准确定位三餐标签*/
                    mt1[i] = [];
                    mt1[i][0] = (e[0] / 60).toFixed(1);
                    mt1[i][1] = (e[1] / 60).toFixed(1);
                    e[0] = Math.round(e[0] / 60);
                    e[1] = Math.round(e[1] / 60);
                    return e;
                });
                //console.log('getLgb1.1:')
                context.mt1 = mt1;
                that.getLbg(context, data.bg_event, data.calib, data.bolus, data.target_high, data.target_low);
                let carb = that.getLcarb(context, data.carb_event, data.bolus);
                that.getLnoMeal(context, mt, carb);
                that.getLexer(context, data.exr_event);
                that.getLother(context, data.other_event);
                // 处理自动模式进餐事件
                that.getAutoModeEvent(context, data.auto_mode_event, data.basal);
                let autoModeInject = that.getAutoModeInject(context, data.basal);
                //console.log('getLgb1.2:')
                let bolusTotal = that.getLbolus(context, data.bolus, data.ins_event);
                let basalTotal = that.getLbasal(context, data.basal);
                console.log('getLgb1:', basalTotal, bolusTotal);
                for (let i = 0; i < basalTotal.length; i++) {
                    basalTotal[i] += autoModeInject[i][0];
                    bolusTotal[i] += autoModeInject[i][1];

                    let total = basalTotal[i] + bolusTotal[i];
                    let percent = (bolusTotal[i] / total) * 100;
                    if (total !== 0) {
                        context.ins[i].total = parseFloat(total).toFixed(2); //+ins_unit2;
                        context.ins[i].percent = parseFloat(percent).toFixed(1);
                    }
                }
                //console.log('getLgb1.3:')
                that.getLbolus2(context, data.ins_event);
                if (context.getLgbReportInfo) {
                    context.getLgbReportInfo(res.data.report_data);
                    //sessionStorage.setItem('lgb_report_data', JSON.stringify(report_data));
                }
                //console.log('getLgb1.4:')
                //console.log(data);
            }
        }, function(err) {
            this.error = err.body.message
        });
    },
    getLbg(context, val, val2, val3, high, low) {
        let length = val.length,
            bg = [],
            bgNew = [];
        let middle = (high + low) / 2;
        high = (context.isMg) ? parseInt(high * 18) : parseFloat(high.toFixed(1));
        low = (context.isMg) ? parseInt(low * 18) : parseFloat(low.toFixed(1));
        middle = (context.isMg) ? parseInt(middle * 18) : parseFloat(middle.toFixed(1));
        for (let i = 0; i < length; i++) {
            let length1 = val[i].length,
                length2 = val2[i].length,
                length3 = val3[i].length,
                sum = 0,
                num = 0,
                m = 0,
                st = context.ts[i][0];
            bg[i] = [];
            bgNew[i] = new Array(24);
            if (length1 !== 0) {
                val[i].map(function(e, j) {
                    let k = parseInt((e[0] - st) / 3600);
                    if (k >= 0) {
                        bg[i][m] = [];
                        bg[i][m][0] = k;
                        bg[i][m][1] = e[1];
                        m++;
                    }
                });
            }
            if (length2 !== 0) {
                val2[i].map(function(e, j) {
                    let k = parseInt((e[0] - st) / 3600);
                    if (k >= 0) {
                        bg[i][m] = [];
                        bg[i][m][0] = k;
                        bg[i][m][1] = e[1];
                        m++;
                    }
                });
            }
            if (length3 !== 0) {
                val3[i].map(function(e, j) {
                    if (e[8].bg) {
                        let k = parseInt((e[1] - st) / 3600);
                        if (k >= 0) {
                            bg[i][m] = [];
                            bg[i][m][0] = k;
                            bg[i][m][1] = e[8].bg;
                            m++;
                        }
                    }
                });
            }
            //合并同一个小时内的数据
            for (let p = 0; p < 24; p++) {
                bgNew[i][p] = [];
            }
            bg[i].map(function(e) {
                e[1] = (context.isMg) ? parseInt(e[1] * 18) : parseFloat(e[1].toFixed(1));
                bgNew[i][e[0]].push(e[1]);
                sum += e[1];
                num++;
            });
            //找出要显示的数据
            bgNew[i] = this.getShowBg(bgNew[i], high, low, middle);
            if (sum > 0) {
                context.bgAvg[i].avg = (context.isMg) ? parseInt(sum / num) + 'mg/dL' : parseFloat(sum / num).toFixed(1) + 'mmol/L';
            } else {
                context.bgAvg[i].avg = (context.isMg) ? '--mg/dL' : '--mmol/L';
            }
        }
        //console.log( context.bgAvg)
        context.makebg1(bgNew, high, low);
    },
    getShowBg(bgNew, high, low, middle) {
        for (let q = 0; q < 24; q++) {
            let leng = bgNew[q].length;
            if (leng > 1) {
                let v1 = [],
                    v2 = [],
                    v3 = [];
                bgNew[q].map(function(e, i) {
                    if (e < low) { v1.push(e); } else if (e > high) { v2.push(e); } else { v3.push(e); }
                });
                if (v1.length > 0) {
                    let min = Math.min.apply(null, v1);
                    bgNew[q] = [];
                    bgNew[q][0] = min;
                    bgNew[q][1] = 2;
                    continue;
                } else if (v2.length > 0) {
                    let max = Math.max.apply(null, v2);
                    bgNew[q] = [];
                    bgNew[q][0] = max;
                    bgNew[q][1] = 2;
                    continue;
                } else if (v3.length > 0) {
                    let diff = [],
                        k = 0;
                    v3.map(function(e, i) {
                        diff[i] = Math.abs(e - middle);
                    });
                    k = diff.indexOf(Math.max.apply(null, diff));
                    bgNew[q] = [];
                    bgNew[q][0] = v3[k];
                    bgNew[q][1] = 2;
                }
            }
        }
        return bgNew;
    },
    getLcarb(context, val, val2) {
        let length = val.length,
            carb = [],
            newCarb = [];
        for (let i = 0; i < length; i++) {
            let length1 = val[i].length,
                length2 = val2[i].length,
                m = 0;
            let st = context.ts[i][0],
                sum = 0;
            carb[i] = [];
            newCarb[i] = [];
            if (length1 !== 0) {
                val[i].map(function(e, j) {
                    sum += e[1];
                    let k = parseInt((e[0] - st) / 3600);
                    if (k >= 0) {
                        carb[i][m] = [];
                        carb[i][m][0] = k;
                        carb[i][m][1] = e[1];
                        m++;
                    }
                });
            }
            if (length2 !== 0) {
                val2[i].map(function(e, j) {
                    if (e[8].carb) {
                        let k = parseInt((e[1] - st) / 3600);
                        if (k >= 0) {
                            carb[i][m] = [];
                            carb[i][m][0] = k;
                            carb[i][m][1] = e[8].carb;
                            sum += e[8].carb;
                            m++;
                        }
                    }
                });
            }
            context.carb[i].total = (sum) ? parseInt(sum) + 'g' : '--g';
            for (let p = 0; p < 24; p++) {
                newCarb[i][p] = 0;
            }
            carb[i].map(function(e) {
                if (e[0] < 24) {
                    newCarb[i][e[0]] = newCarb[i][e[0]] + e[1];
                }
            });
        }
        //console.log(carb,newCarb);
        if (carb.length > 0) {
            context.makecarb(newCarb);
        }
        return carb;
    },
    getLnoMeal(context, mt, val) {
        let noMeal = [];
        for (let i = 0; i < val.length; i++) {
            noMeal[i] = [0, 0, 0];
            let leng = val[i].length;
            if (leng > 0) {
                for (let j = 0; j < leng; j++) {
                    for (let k = 0; k < 3; k++) {
                        if (val[i][j][0] >= mt[k][0] && val[i][j][0] <= mt[k][1]) {
                            noMeal[i][k] = 1;
                        }
                    }
                }
            }
        }
        context.mt = mt;
        context.noMeal = noMeal;
        context.makeNoMeal();
    },
    getLbasal(context, val) {
        let autoStop = [],
            manualStop = [],
            stop = [],
            Newer = [],
            basalTotal = [],
            noPump = [],
            tempBasal = [];
        console.log('getLbasal:', val);
        for (let i = 0; i < val.length; i++) {
            autoStop[i] = [];
            manualStop[i] = [];
            stop[i] = [];
            Newer[i] = [];
            basalTotal[i] = [];
            noPump[i] = 0;
            tempBasal[i] = [];
            let p = 0,
                q = 0,
                o = 0,
                s = 0,
                sum = 0,
                t = 0;
            let st = context.ts[i][0],
                et = context.ts[i][1];
            for (let j = 0; j < val[i].length; j++) {
                let va = val[i][j];
                if (va[2] === 'SUSHM' || va[2] === 'SUSDM' || va[2] === 'SUSLSG' || va[2] === 'SUSPLSG' || va[2] === 'SUSA') {
                    let k1 = 0,
                        k2 = 0;
                    if (va[1] < st) {
                        k1 = 0;
                        k2 = parseInt((va[1] + va[3] - st) / 3600);
                    } else if ((va[1] + va[3]) > et) {
                        k1 = parseInt((va[1] - st) / 3600);
                        k2 = 23;
                    } else {
                        k1 = parseInt((va[1] - st) / 3600);
                        k2 = parseInt(((va[1] + va[3]) - st) / 3600);
                    }
                    for (let k = k1; k < k2 + 1; k++) {
                        autoStop[i][p] = k;
                        p++;
                    }
                } else if (va[2] === 'SUSM' || va[2] === 'SUSEB') {
                    let k1 = 0,
                        k2 = 0;
                    if (va[1] < st) {
                        k1 = 0;
                        k2 = parseInt((va[1] + va[3] - st) / 3600);
                    } else if ((va[1] + va[3]) > et) {
                        k1 = parseInt((va[1] - st) / 3600);
                        k2 = 23;
                    } else {
                        k1 = parseInt((va[1] - st) / 3600);
                        k2 = parseInt(((va[1] + va[3]) - st) / 3600);
                    }
                    for (let k = k1; k < k2 + 1; k++) {
                        manualStop[i][q] = k;
                        q++;
                    }
                } else if (va[2] === 'BART' || va[2] === 'BAAT') {
                    let k1 = 0,
                        k2 = 0;
                    //console.log('basal.va:', va);
                    if (va[1] < st) {
                        k1 = 0;
                        k2 = parseInt((va[1] + va[3] - st) / 3600);
                    } else if ((va[1] + va[3]) > et) {
                        k1 = parseInt((va[1] - st) / 3600);
                        k2 = 23;
                    } else {
                        k1 = parseInt((va[1] - st) / 3600);
                        k2 = parseInt(((va[1] + va[3]) - st) / 3600);
                    }
                    for (let k = k1; k < k2 + 1; k++) {
                        tempBasal[i][t] = k;
                        t++;
                    }
                } else if (va[2] === 'ENDM' || va[2] === 'ENDEM' || va[2] === 'ENDPE' || va[2] === 'ENDEP' || va[2] === 'ENDPB' || va[2] === 'ENDCE' || va[2] === 'ENDPBE' || va[2] === 'ENDD' || va[2] === 'ENDPE2') {
                    let k = parseInt((va[1] - st) / 3600);
                    if (k >= 0) {
                        stop[i][o] = k;
                        o++;
                    }
                } else if (va[2] === 'NEW') {
                    let k = parseInt((va[1] - st) / 3600);
                    if (k >= 0) {
                        Newer[i][s] = k;
                        s++;
                    }
                }
                //
                {
                    if (va[1] < st) {
                        let value = (va[1] + va[3] - st) / va[3] * parseFloat(va[5]);
                        sum = sum + value;
                    } else if ((va[1] + va[3]) > (st + 86400)) {
                        let value = ((st + 86400) - va[1]) / va[3] * parseFloat(va[5]);
                        sum = sum + value;
                    } else {
                        sum = sum + va[5];
                        //console.log('getLbasal.8:', i, j, sum, va[5]);
                    }
                }

            }
            basalTotal[i] = sum;
            if (val[i].length === 0) {
                noPump[i] = 1;
            }
        }
        //console.log('manualStop:', manualStop);
        console.log('tempBasal:', tempBasal);
        // console.log(noPump);
        context.makeNoPump(noPump);
        context.makeOth1(this.getLnewBasal(autoStop), 0);
        context.makeOth1(this.getLnewBasal(manualStop), 1);
        context.makeOth1(this.getLnewBasal(stop), 2);
        context.makeOth1(this.getLnewBasal(Newer), 3);
        context.makeOth1(this.getLnewBasal(tempBasal), 6);
        return basalTotal;
    },
    getLnewBasal(val) {
        let length = val.length,
            newBasal = [];
        for (let i = 0; i < length; i++) {
            newBasal[i] = new Array(24);
            for (let p = 0; p < 24; p++) {
                newBasal[i][p] = 0;
            }
            if (val[i].length > 0) {
                val[i].map(function(e) {
                    if (e < 24) {
                        newBasal[i][e] = 1;
                    }
                })
            }
        }
        return newBasal;
    },

    /*
     * val: bolus
     */
    getLbolus(context, val, val2) {
        //console.log(val);
        console.log('getLbolus.1:', val);
        let bolus = [],
            newBolus = [],
            bolusTotal = [];
        let bolusMarkFlag = []; // 大剂量是否带框
        let bolusNoMark = [];
        for (let i = 0; i < val.length; i++) {
            let length1 = val[i].length,
                st = context.ts[i][0],
                length2 = val2[i].length,
                sum = 0;
            bolus[i] = [];
            newBolus[i] = new Array(24);
            bolusTotal[i] = [];
            if (length1 > 0) {
                val[i].map(function(e, j) {
                    let k = parseInt((e[1] - st) / 3600);
                    if (k >= 0) {
                        bolus[i][j] = [];
                        bolus[i][j][0] = k;
                        if (e[2] === 'EBCCW' || e[2] === 'EBM' || e[2] === 'EBCAW') {
                            bolus[i][j][1] = e[6];
                        } else if (e[2] === 'CBCCW' || e[2] === 'CBM' || e[2] === 'CBCAW') {
                            bolus[i][j][1] = e[4] + e[6];
                        } else {
                            bolus[i][j][1] = e[4];
                        }
                        //
                        bolus[i][j][2] = true;
                        // 只有纯食物大剂量， 未修正的， 不要加框
                        if (e[2] === 'EBCAW' || e[2] === 'CBCAW' || e[2] === 'NBCAW') {
                            console.log('getLbolus.5:', e);
                            //let wizzard_info=e[8];
                            //let wizzard_info=JSON.parse(e[8]);
                            let wizzard_info = e[8];
                            let carb_bolus = wizzard_info['carb_bolus'];
                            let iob = wizzard_info['iob'];
                            //let iob=wizzard_info['iob'];
                            let set_total = 0;
                            if (e[3]) {
                                set_total += e[3];
                            }
                            if (e[5]) {
                                set_total += e[5];
                            }
                            console.log('set_total:', set_total, carb_bolus, iob)
                            if (set_total == carb_bolus) {
                                bolus[i][j][2] = false;
                            }
                        }
                        //
                        sum += bolus[i][j][1];
                    }
                })
            }
            bolusMarkFlag[i] = new Array(24);
            bolusNoMark[i] = new Array(24);
            for (let p = 0; p < 24; p++) {
                newBolus[i][p] = 0;
                bolusMarkFlag[i][p] = false;
                bolusNoMark[i][p] = 0;
            }
            // e[0]: 第几个小时， e[1]: 胰岛素的量。 e[2]: 是否带框
            bolus[i].map(function(e) {
                let hour = e[0];
                bolusMarkFlag[i][hour] = bolusMarkFlag[i][hour] || e[2];
                newBolus[i][e[0]] = newBolus[i][e[0]] + parseFloat(e[1]);
                bolusNoMark[i][hour] = newBolus[i][hour];
            });
            //
            bolusMarkFlag[i].map(function(e, h) {
                if (e) {
                    //bolusNoMark[i][h]=0;
                } else {
                    //newBolus[i][h]=0;
                }
            })

            //
            if (length2 > 0) {
                val2[i].map(function(e) {
                    sum += e[1];
                });
            }
            bolusTotal[i] = sum;
        }
        //
        console.log('getLbolus.9:', bolus);
        console.log('bolusMarkFlag.9:', bolusMarkFlag);
        console.log('newBolus:', newBolus);
        context.makeBolus(newBolus, bolusMarkFlag);
        return bolusTotal;
    },
    // 事件中的大剂量。
    getLbolus2(context, val) {
        let length = val.length,
            bolus2 = [];
        for (let i = 0; i < length; i++) {
            let length1 = val[i].length,
                st = context.ts[i][0];
            bolus2[i] = [];
            if (length1 !== 0) {
                val[i].map(function(e, j) {
                    let k = parseInt((e[0] - st) / 3600);
                    if (k >= 0) {
                        bolus2[i][j] = [];
                        bolus2[i][j][0] = k;
                        bolus2[i][j][1] = e[1];
                    }
                });
            }
        }
        context.makeBolus2(bolus2);
        //context.makeBolus(bolus2);
    },
    getLexer(context, val) {
        //console.log(val);
        let exe = [];
        for (let i = 0; i < val.length; i++) {
            exe[i] = [];
            let st = context.ts[i][0],
                et = context.ts[i][1],
                length = val[i].length,
                p = 0;
            if (length > 0) {
                for (let j = 0; j < length; j++) {
                    let k1 = 0,
                        k2 = 0;
                    let va = val[i][j];
                    if (va[0] < st) {
                        k1 = 0;
                        k2 = parseInt(va[1] / 60);
                    } else if ((va[0] + va[1] * 60) > et) {
                        k1 = parseInt((va[0] - st) / 3600);
                        k2 = 23;
                    } else {
                        k1 = parseInt((va[0] - st) / 3600);
                        k2 = parseInt(((va[0] + va[1] * 60) - st) / 3600);
                    }
                    for (let k = k1; k < k2 + 1; k++) {
                        exe[i][p] = k;
                        p++;
                    }
                }
            }
        }
        //console.log('logbook exe:', exe);
        context.makeOth1(this.getLnewBasal(exe), 4);
        // console.log(exe)
    },
    getLother(context, val) {
        let oth = [];
        for (let i = 0; i < val.length; i++) {
            oth[i] = [];
            let st = context.ts[i][0],
                length = val[i].length,
                p = 0;
            if (length > 0) {
                let k = 0;
                for (let j = 0; j < length; j++) {
                    k = parseInt((val[i][j][0] - st) / 3600);
                    oth[i][p] = k;
                    p++;
                }
            }
        }
        context.makeOth1(this.getLnewBasal(oth), 5);
    },

    getAutoModeInject(context, basal_data) {
        let injectResult = [];
        for (let d = 0; d < basal_data.length; d++) {
            let autoBasalTotal = 0;
            let autoBolusTotal = 0;
            for (let i = 0; i < basal_data[d].length; i++) {
                let basalRecord = basal_data[d][i];
                let basalType = basalRecord[2];
                if ('BAAM' == basalType) {
                    let autoModeData = basalRecord[7];
                    try {
                        autoModeData = JSON.parse(autoModeData);
                        let autoModeJson = autoModeData['autoModeJSON'];
                        autoModeJson.map(function(e, i) {
                            autoBasalTotal += e['auto_basal_delivery'] * 0.05;
                            autoBolusTotal += (e['auto_food_delivery'] + e['auto_corr_delivery']) * 0.05;
                        })
                    } catch (e) {

                    }
                }
            }
            injectResult.push([autoBasalTotal, autoBolusTotal])
        }
        console.log('injectResult:', injectResult);
        return injectResult;
    },

    getAutoModeEvent(context, auto_mode_event, basal_record) {

        // 分别是 早餐， 午餐， 晚餐， 零食， 运动
        for (let m = 0; m < 5; m++) {

            let autoMeal = auto_mode_event[m];
            let autoMealFlag = [];

            //let day=autoSnack.length;
            //let mealCount = 4;
            for (let i = 0; i < autoMeal.length; i++) {
                let tmp = [];
                for (let j = 0; j < 24; j++) {
                    tmp.push(0);
                }

                let st = context.ts[i][0]
                for (let j = 0; j < autoMeal[i].length; j++) {
                    let hour = parseInt((autoMeal[i][j][0] - st) / 3600); // 小时数
                    //console.log('hour:', autoMeal[i][j], st, hour);
                    tmp[hour] = 1;
                }

                autoMealFlag.push(tmp);
            }
            console.log('autoMealFlag:', autoMealFlag);
            context.makeOth1(autoMealFlag, 7 + m);
        }

        // 计算自动模式进入和退出事件
        let autoModeStartFlag = [];
        let autoModeExitFlag = [];
        for (let i = 0; i < basal_record.length; i++) {
            let startFlag = [];
            let exitFlag = [];
            for (let j = 0; j < 24; j++) {
                startFlag.push(0);
                exitFlag.push(0);
            }

            let st = context.ts[i][0]
            for (let j = 0; j < basal_record[i].length; j++) {
                let basalType = basal_record[i][j][2];
                let hour = parseInt((basal_record[i][j][1] - st) / 3600);

                if ('BAAMS' == basalType) {
                    startFlag[hour] = 1;
                } else if ('BAAME' == basalType) {
                    exitFlag[hour] = 1;
                }

            }

            autoModeStartFlag.push(startFlag);
            autoModeExitFlag.push(exitFlag);
        }
        context.makeOth1(autoModeStartFlag, 12);
        context.makeOth1(autoModeExitFlag, 13);


    },

    //Device Setting
    getPdm1(context, uid, param) {
        let that = this;

        function addPreZero(pdm_sn_hex, num) {
            let pre = '';
            for (let i = 0; i < num; i++) {
                pre += '0';
            }
            return pre + pdm_sn_hex;
        }

        context.$http.get(SERVER_URL + '/v2.0/pdm/' + uid + '/settings', { params: param }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let data = res.data.settings;
                console.log('device settings.1:', JSON.stringify(data.items));
                context.PDM = data.items.map(function(e, i) {
                    e[1] = new Date(e[1] * 1000);
                    e[1] = that.formatterDate1(e[1]);

                    //
                    if (false) { // 这一段不用了, 用函数
                        let pdm_sn = parseInt(e[2]);
                        console.log('pdm_sn:', pdm_sn);
                        if ((100000000 <= pdm_sn && pdm_sn <= 101999999) ||
                            (109000000 <= pdm_sn && pdm_sn <= 109999999) ||
                            (112000000 <= pdm_sn && pdm_sn <= 112999999)) {
                            //console.log('pdm_sn.1:');
                        } else {
                            let pdm_sn_hex = pdm_sn.toString(16); //.toUpperCase()
                            let lackZeroDigit = 8 - pdm_sn_hex.length;

                            pdm_sn_hex = addPreZero(pdm_sn_hex, lackZeroDigit);
                            //console.log('pdm_sn.2:', pdm_sn, pdm_sn_hex);
                            e[2] = pdm_sn_hex.toUpperCase();
                        }
                    }
                    //
                    e[2] = that.deviceSNFormat(e[2]);

                    return e;
                });
                context.pages = data.pages;
                context.has_next = data.has_next;
                context.has_prev = data.has_prev;
                if (context.PDM.length > 0 && context.first) {
                    context.index = '0';
                    context.selectId = context.PDM[0][0];
                    context.tempSelectId = context.selectId;
                    //context.index=context.PDM.length-1;
                    context.apply();
                    context.first = false;
                }
            }
        }, function(err) {
            alert(err + "," + err.body.message);
        })
    },
    getPdmSG(context, val, flag) {
        console.log('getPdmSG:', val, flag);
        let time = [],
            sg = [],
            SG = [],
            max = 0;
        let sta = val[0][0].split(":")[0] * 3600 + val[0][0].split(":")[1] * 60 + new Date().setHours(0, 0, 0, 0) / 1000;
        let k = 0;
        for (let i = 0; i < val.length; i++) {
            let et = 0;
            if (i < val.length - 1) {
                et = val[i + 1][0].split(':');
            } else {
                et = [24, 0];
            }
            let st = val[i][0].split(':');
            let h = et[0] - st[0],
                m = et[1] - st[1];
            let s = h * 3600 + m * 60;
            for (let j = 0; j < parseInt(s / 120); j++) {
                sta = sta + 120;
                time[k] = sta;
                sg[k] = val[i][1];
                k++;
            }
        }
        max = (sg.length > 0) ? Math.max.apply(null, sg) : 3;
        if (max < 2) { max = 2; } else if (max < 4) { max = 4; } else if (max < 10) { max = 10; }
        if (context.sgMax < max) {
            context.sgMax = max;
        }
        for (let m = 0; m < sg.length; m++) {
            SG[m] = new Array(2);
            SG[m][1] = sg[m].toFixed(2);
            time[m] = new Date(time[m] * 1000);
            SG[m][0] = time[m];
        }
        return SG;
    },
    getRatio(context, val, flag) {
        // console.log(val);
        let length = val.length;
        let Ratio = new Array(length),
            sumCol = 0;
        for (let i = 0; i < length - 1; i++) {
            let st = val[i][0].split(':');
            let et = val[i + 1][0].split(':');
            let h = et[0] - st[0],
                m = et[1] - st[1];
            let col = h * 2 + m / 30;
            sumCol = sumCol + col;
            Ratio[i] = new Array(2);
            Ratio[i][0] = col;
            Ratio[i][1] = val[i][1];
        }
        Ratio[length - 1] = new Array(2);
        Ratio[length - 1][0] = 48 - sumCol;
        Ratio[length - 1][1] = val[length - 1][1];
        return Ratio;
    },
    getMaxBolus(val) {
        let length = val.length,
            j = 0;
        let Ratio = [],
            sumCol = 0;
        if (length === 0) {
            Ratio[0] = 0;
        }
        if (length === 1) {
            let st = val[0][0].split(':');
            let et = val[0][1].split(':');
            let h = et[0] - st[0],
                m = et[1] - st[1];
            let col = h * 2 + m / 30;
            let staCol = st[0] * 2 + st[1] / 30;
            sumCol = sumCol + col + staCol;
            /*Ratio[0] = staCol;
            Ratio[1]= col;
            Ratio[2] = 48-sumCol;*/
            Ratio[0] = [];
            Ratio[0][1] = col;
            Ratio[0][0] = st[0] * 2 + st[1] / 30;
        } else {
            for (let i = 0; i < length; i++) {
                if (i > 0 && i < length - 1 && val[i][0] === val[i + 1][0] && val[i][1] === val[i + 1][1]) { continue; }
                let st = val[i][0].split(':');
                let et = val[i][1].split(':');
                let h = et[0] - st[0],
                    m = et[1] - st[1];
                let col = h * 2 + m / 30;
                sumCol = sumCol + col;
                Ratio[j] = [];
                Ratio[j][1] = col;
                Ratio[j][0] = st[0] * 2 + st[1] / 30;
                j++;
            }
            ///不需要Ratio[j] = 48-sumCol;
        }
        return Ratio;
    },
    getGlucoseLimit(context, val) {
        let length = val.length;
        let Ratio = new Array(length),
            sumCol = 0;
        for (let i = 0; i < length - 1; i++) {
            let st = val[i][0].split(':');
            let et = val[i + 1][0].split(':');
            let h = et[0] - st[0],
                m = et[1] - st[1];
            let col = h * 2 + m / 30;
            sumCol = sumCol + col;
            Ratio[i] = new Array(3);
            Ratio[i][0] = col;
            Ratio[i][1] = val[i][1];
            Ratio[i][2] = val[i][2];
        }
        Ratio[length - 1] = new Array(3);
        Ratio[length - 1][0] = 48 - sumCol;
        Ratio[length - 1][1] = val[length - 1][1];
        Ratio[length - 1][2] = val[length - 1][2];
        return Ratio;
    },

    // dashboard
    getDashboard(context, uid, param) {
        let that = this;
        context.$http.post('/api/v2.1/data/' + uid, param).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                let data = res.data.data;
                console.log('dashboard.data:', data);
                if (data.devices) {
                    context.devices = data.devices;
                }

                if (data.sg) {
                    context.sg = data.sg;
                    that.getDashboardSg(context, data.sg);
                    that.getDashboardSgStat(context, data);
                }
                //if (data.calib){
                that.getDashboardBG(context, data)
                    //}
                that.getDashboardMiscInfo(context, data)

                let bolus_stat_result = {};
                if (data.bolus) {
                    //that.getSegmentBolus(context,data.bolus,data.event);
                    bolus_stat_result = that.getDashboardInsulinStat(context, data)
                }
                let ins_use_duration_day = bolus_stat_result['use_duration_day'];
                let ins_use_duration_day_pre = bolus_stat_result['use_duration_day_pre'];
                console.log('ins_use_duration_day:', ins_use_duration_day);

                // that.getDashboardCarbStat(context, data, ins_use_duration_day_pre);
                // that.getDashboardExerciseStat(context, data, ins_use_duration_day_pre);
                that.getDashboardCarbStat(context, data, ins_use_duration_day);
                that.getDashboardExerciseStat(context, data, ins_use_duration_day);

                //
                if (data.device_setting) {
                    // 2019.8.30, 下面这个函数应该是已经不用了，是老的segment analysis的图表。
                    //that.getSegmentBasal(context,data.device_setting.basal_pattern.seg);
                }
                if (data.device_setting) {
                    let t = that.formatterDate1(new Date(data.device_setting.update_time * 1000));
                    context.update_time = t + ', ' + data.device_setting.pdm_sn;
                    //console.log( context.update_time)
                }
                context.target_high = (context.isMg) ? parseInt(data.target_high * 18) : data.target_high.toFixed(1);
                context.target_low = (context.isMg) ? parseInt(data.target_low * 18) : data.target_low.toFixed(1);
                if (this.chart1_2) {
                    this.chartsDispose();
                }
                this.drawCharts();
            }
        }, function(err) {
            this.error = err.body.message
        });
    },
    getAvgSD(data) {
        if (!(data instanceof Array) || data.length == 0) {
            return { 'sd': 0, 'avg': 0, 'num': 0 }
        }
        let size = data.length;
        let total = 0;
        let avg = 0;
        //let diff=[];
        let diffTotal = 0;
        data.map(function(e, i) {
            total += e;
        })
        avg = total / size;
        data.map(function(e, i) {
            diffTotal += Math.pow((e - avg), 2);
        })
        let sd = Math.sqrt(diffTotal / size);
        return {
            'sd': sd,
            'avg': avg,
            'num': size,
        }
    },
    getInsulinVal(ins) {
        let num = Math.round(ins / 0.05);
        return (0.05 * num).toFixed(2);
    },
    getInsulinValText(ins) {
        if (ins < 0.00001)
            return '0';

        //let txt=ins.toFixed(2);
        let txt = Math.round(ins * 100) / 100;
        txt = txt.toFixed(2);
        return txt;
    },

    getGlucoseValText(isMg, mmol_val) {
        //isMg=true;
        let txt = isMg ? Math.round(mmol_val * 18) + ' mg/dL' : parseFloat(mmol_val.toFixed(1)) + ' mmol/L';
        return txt;
    },

    getGlucoseValText2(isMg, mmol_val) {
        let txt = isMg ? Math.round(mmol_val * 18) + '' : parseFloat(mmol_val.toFixed(1)) + '';
        return txt;
    },
    getGlucoseSDValText(isMg, mmol_val) {
        //isMg=true;
        let txt = isMg ? (mmol_val * 18).toFixed(1) + '' : parseFloat(mmol_val.toFixed(2)) + '';
        return txt;
    },

    getNumText(num, use_days) {
        if (num * 1.0 / use_days < 0.00001) {
            return 0 + '';
        }

        if (num % use_days) {
            return (num * 1.0 / use_days).toFixed(1);
        } else {
            return Math.round((num * 1.0 / use_days));
        }
    },

    getNumText3(num, use_days, digit) {
        if (num % use_days) {
            return (num * 1.0 / use_days).toFixed(digit);
        } else {
            return Math.round((num * 1.0 / use_days));
        }
    },

    getMinuteText(minutes, use_days, digit) {
        //minutes = 400;  // for test, test case
        let avg_minute = Math.round(minutes / use_days);
        if (avg_minute < 60) {
            return {
                'minute': avg_minute,
                'hour': 0
            };
        } else {
            let h = Math.floor(avg_minute / 60);
            let m = avg_minute % 60;
            return {
                'minute': m,
                'hour': h
            };
        }
    },

    getNumText2(num, use_days) {
        //if (num % use_days) {
        //  return (num*1.0/use_days).toFixed(1);
        //} else {
        return Math.round((num * 1.0 / use_days));
        //}
    },

    getDashboardMiscInfo(context, data) {
        context.highLevelText = this.getGlucoseValText(context.isMg, data.target_high)
        context.lowLevelText = this.getGlucoseValText(context.isMg, data.target_low)
    },

    getDashboardBG(context, data) {
        //context.bgAvg='5.6 mmol/L';
        //
        let bg_day_data = [];
        let bg_data = [];
        let calib = data.calib;
        let bolus = data.bolus;
        let event = data.event;
        let use_days = 0;
        let calib_day_data = [];
        let calib_use_days = 0;
        let calib_data = [];
        //let glucose_unit=context.glucose_unit;

        //let basal=data.basal;
        console.log('getDashboardBG.1:', event, context.isMg);

        //
        if (calib) {
            calib.map(function(d, n) {
                bg_day_data.push([])
                calib_day_data.push([])
            })
            console.log('bg_day_data.1:', bg_day_data, use_days);
            calib.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        bg_day_data[n].push(e[1])
                        bg_data.push(e[1])
                            //
                        calib_day_data[n].push(e[1])
                        calib_data.push(e[1])
                    })
                }
            })
        } else {
            return
        }

        if (bolus) {
            bolus.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        //console.log(e)
                        if (e[8] && e[8].length > 0) {
                            let w = JSON.parse(e[8])
                            if (w.bg) {
                                bg_day_data[n].push(w.bg)
                                bg_data.push(w.bg)
                            }
                        }
                    })
                }
            })
        }

        // 统计evetn 里的bg
        // todo
        if (event) {
            event.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        if ('BG' == e[2]) {
                            let content = e[3];
                            if (content.value) {
                                let bg_value = content.value;
                                //if (context.isMg){
                                //
                                //} else {
                                bg_value = bg_value / 18.0;
                                //}
                                bg_day_data[n].push(bg_value);
                                bg_data.push(bg_value);
                            }
                        }
                    })
                }
            })
        }

        // bg 的使用天数
        bg_day_data.map(function(d, n) {
            if (d.length > 0) {
                use_days += 1;
            }
        });

        // calib的使用天数
        calib_day_data.map(function(d, n) {
            if (d.length > 0) {
                calib_use_days += 1;
            }
        });


        console.log('bg_day_data:', bg_day_data, use_days);
        console.log('calib_day_data:', calib_day_data, calib_use_days);
        console.log('bg_data:', bg_data);
        let result = this.getAvgSD(bg_data);
        result.use_days = use_days
        console.log('result:', result);
        if (result.num && result.use_days) {
            context.bgAvg = this.getGlucoseValText2(context.isMg, result.avg);
            context.bgSD = this.getGlucoseSDValText(context.isMg, result.sd);
            context.bgPerDay = this.getNumText(result.num, result.use_days);
            context.bgNum = result.num;

            context.calibPerDay = this.getNumText(calib_data.length, calib_use_days);

        } else {
            console.log('reset to default');
            context.bgAvg = '--';
            context.bgSD = '--';
            context.bgPerDay = '--';
            context.bgNum = '--';
            context.calibPerDay = '--';
        }

    },
    truncateBasal(basal, ts) {
        //let new_bolus=[];
        basal.map(function(d, n) {
            let size = d.length;
            if (size > 0) {
                let first = d[0];
                let last = d[size - 1];

                //console.log("truncateBasal:", first, last, ts[n]);
                let t = first[1];
                let duration = first[3];
                let inject = first[5];
                if (t < ts[n][0]) {
                    first[1] = ts[n][0];
                    first[3] = duration - (ts[n][0] - t);
                    first[5] = inject * 1.0 * first[3] / duration;
                }

                t = last[1];
                duration = last[3];
                inject = last[5];


                if ((t + duration) > ts[n][1]) {
                    //first[0]=ts[n][0];
                    last[3] = (ts[n][1] - t);
                    last[5] = inject * 1.0 * first[3] / duration;
                }

                //console.log('truncateBasal:', n, first, last, ts[n])

            }
        })
        return basal;
    },
    getDashboardCarbStat(context, data, ins_use_duration_day) {
        let carb_day_data = [];
        let carb_data = [];
        let carb_total = 0;
        let use_days = 0;
        let event = data.event;
        let bolus = data.bolus;
        //let carb_use_days=0;

        //console.log('getDashboardCarbStat:', data)
        console.log('getDashboardCarbStat.1:', event);
        event.map(function(e, i) {
                carb_day_data.push([])
                    //carb_total.pu
            })
            //
        if (event) {
            event.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        if ('CARB' == e[2]) {
                            let content = e[3];
                            if (content.value) {
                                carb_day_data[n].push(content.value)
                                carb_data.push(content.value)
                            }
                        }
                    })
                }
            })
        } else {
            return;
        }
        // bolus carb
        //console.log('bolus carb:', bolus);
        if (bolus) {
            bolus.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        let recordId = e[0];
                        let recordIdSplit = recordId.split('-')
                        let recordSeq = recordIdSplit[3];
                        try {
                            if (recordSeq >= 8888) {
                                return;
                            }
                        } catch (e) {

                        }
                        //console.log(e)
                        if (e[8] && e[8].length > 0) {
                            let w = JSON.parse(e[8])
                            if (w.carb) {
                                carb_day_data[n].push(w.carb)
                                carb_data.push(w.carb)
                            }
                        }
                    })
                }
            })
        }
        //

        /*carb_day_data.map(function(d,n){
          if (d.length>0){
            use_days += 1;
          } else if (ins_use_duration_day[n]>23.5*60){
            use_days += 1;
          }
        });*/

        // 另一种计算方式2
        carb_data = [];
        ins_use_duration_day.map(function(ins_day_use, n) {
            if (ins_day_use > 23.5 * 3600) {
                use_days += 1;
                //carb_day_data[]
                carb_data = carb_data.concat(carb_day_data[n])
            } else {}
        })


        carb_data.map(function(d, n) {
            carb_total += d;
        });

        console.log('carb_use_day:', ins_use_duration_day, use_days, carb_total, carb_day_data, carb_data);
        if (carb_data.length) {
            let result = this.getAvgSD(carb_data);
            if (result.num) {
                //carb_use_days=
                context.carbSD = result.sd.toFixed(1);
                //context.bgPerDay=this.getNumText(result.num, result.use_days);
                context.carbNum = result.num;
                context.carbAvg = this.getNumText3(carb_total, use_days, 1);
            }
        }

    },

    getDashboardExerciseStat(context, data, ins_use_duration_day) {
        //console.log('getDashboardExerciseStat:', data);
        let exercise_day_data = [];
        let exercise_data = [];
        let exercise_total = 0;
        let use_days = 0;
        let event = data.event;
        //let bolus=data.bolus;
        //let carb_use_days=0;

        //console.log('getDashboardCarbStat:', data)
        //console.log('getDashboardExerciseStat.1:', event);
        event.map(function(e, i) {
                exercise_day_data.push([])
                    //carb_total.pu
            })
            //
        if (event) {
            event.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        if ('EXR' == e[2] || 'AutoExercise' == e[2]) {
                            let content = e[3];
                            if (content.value) {
                                exercise_day_data[n].push(content.value)
                                exercise_data.push(content.value)
                            } else if (content.duration) {
                                exercise_day_data[n].push(content.duration)
                                exercise_data.push(content.duration)
                            }
                        }
                    })
                }
            })
        } else {
            return;
        }
        //
        //console.log('getDashboardExerciseStat.2:', exercise_day_data, exercise_data);

        /*
        exercise_day_data.map(function(d,n){
          if (d.length>0){
            use_days += 1;
          } else if (ins_use_duration_day[n]>23.5*60){
            use_days += 1;
          }
        });*/
        exercise_data = []
        ins_use_duration_day.map(function(ins_day_use, n) {
            if (ins_day_use > 0) {
                use_days += 1;
                exercise_data = exercise_data.concat(exercise_day_data[n])
            }
        })

        //
        //let use_days=0;
        //use_days=0;

        exercise_data.map(function(d, n) {
            exercise_total += d;
        });

        console.log('exercise_use_day:', use_days, exercise_day_data, exercise_data, ins_use_duration_day);
        if (exercise_data.length) {
            let result = this.getAvgSD(exercise_data);
            if (result.num) {
                //carb_use_days=
                context.exerSD = result.sd.toFixed(1);
                //context.bgPerDay=this.getNumText(result.num, result.use_days);
                context.exerNum = result.num;
                let exerAvgRes = this.getMinuteText(exercise_total, use_days, 1);
                context.exerAvg = exerAvgRes['minute']
                context.exerAvgHour = exerAvgRes['hour']
            }
        }

    },

    getDashboardInsulinStat(context, data) {
        let basal = this.truncateBasal(data.basal, context.ts)
        let ins_unit2 = context.$t('ins_unit2')
        console.log('basal:', basal)
        let insulin_data = [];
        let insulinUsage = [];
        let use_days = 0;
        let use_duration_day = [];
        let use_duration_day_pre = [];
        let use_duration = 0;
        let basal_total = 0;
        let auto_basal_total = 0;
        let auto_bolus_total = 0;
        let bolus_total = 0;
        let basalUsage = [];
        let bolusUsage = [];
        // let totoalUseTime=0;
        let usePatchInfo = {};
        let usePatchNum = 0;

        let inject_total = 0;
        let bolus_num = 0;
        let suspend_duration = 0;
        let manual_bolus = 0;
        let manual_bolus_num = 0;
        let manual_normal_bolus = 0;
        let manual_normal_bolus_num = 0;
        let manual_extend_bolus = 0;
        let manual_extend_bolus_num = 0;
        let manual_combo_bolus = 0;
        let manual_combo_bolus_num = 0;
        let wizzard_bolus = 0;
        let wizzard_bolus_num = 0;
        let food_wizzard_bolus = 0;
        let food_wizzard_bolus_num = 0;
        let corr_wizzard_bolus = 0;
        let corr_wizzard_bolus_num = 0;
        let wizzard_override_add = 0;
        let wizzard_override_add_num = 0;
        let wizzard_override_sub = 0;
        let wizzard_override_sub_num = 0;

        function getBolusWizzardSuggest(wizzard, fromPDM) {
            let iob = wizzard.iob;
            let carb_bolus = 0;
            let bg_bolus = 0;

            // 以前的字段写反了。
            if (false) {
                carb_bolus = wizzard.carb_bolus;
                bg_bolus = wizzard.bg_bolus;
            } else {
                carb_bolus = wizzard.bg_bolus;
                bg_bolus = wizzard.carb_bolus;
            }
            if (bg_bolus > 400) {
                bg_bolus = -(655.36 - bg_bolus);
            }

            console.log('bs_bolus:', bg_bolus, carb_bolus);

            if (bg_bolus > 0) {
                if (bg_bolus < iob) {
                    return carb_bolus;
                } else {
                    return (carb_bolus + bg_bolus - iob);
                }
            } else if (bg_bolus < 0) {
                return carb_bolus + bg_bolus;
            } else {
                return carb_bolus;
            }

            return (carb_bolus + bg_bolus - iob);
        }

        data.basal.map(function(d, n) {
                insulinUsage.push(0)
                insulin_data.push([])
                basalUsage.push(0)
                bolusUsage.push(0)
                use_duration_day.push(0)
                use_duration_day_pre.push(0)
            })
            // 先根据泵的使用时间，去掉使用时间不够的日期的数据
        data.basal.map(function(d, n) {
            if (d.length) {
                d.map(function(e, i) {
                    use_duration_day_pre[n] += e[3];
                })
            }
        })
        console.log('use_duration_day_pre:', use_duration_day_pre);

        // 统计储药贴平均使用寿命，需要用到全部数据
        // for (let i=0; i<use_duration_day_pre.length; i++) {
        //   if (use_duration_day_pre[i]>=23.5*86400/24.0) {
        //     // pass 符合使用时间
        //   } else {
        //     data.basal[i]=[];
        //     data.bolus[i]=[];
        //   }
        // }

        //
        data.basal.map(function(d, n) {
            if (d.length) {
                use_days += 1;
                d.map(function(e, i) {
                    let recordId = e[0];
                    let basalType = e[2];
                    let recordIdPart = recordId.split('-');
                    if ('9999' == recordIdPart[3] || '65535' == recordIdPart[3]) {
                        return;
                    }
                    if ('BAAM' == basalType) {
                        let autoModeData = e[7];
                        try {
                            if (autoModeData) {
                                autoModeData = JSON.parse(autoModeData);
                                let microBolusJson = autoModeData['autoModeJSON'];
                                let cur_auto_basal_total = 0;
                                let cur_auto_bolus_total = 0;

                                microBolusJson.map(function(e, i) {
                                        cur_auto_basal_total += e['auto_basal_delivery'];
                                        cur_auto_bolus_total += e['auto_food_delivery'] + e['auto_corr_delivery'];
                                    })
                                    //
                                insulin_data[n].push(cur_auto_basal_total * 0.05 + cur_auto_bolus_total * 0.05)
                                insulinUsage[n] += cur_auto_basal_total * 0.05 + cur_auto_bolus_total * 0.05;
                                auto_basal_total += cur_auto_basal_total * 0.05;
                                auto_bolus_total += cur_auto_bolus_total * 0.05;
                                basalUsage[n] += cur_auto_basal_total * 0.05;
                                bolusUsage[n] += cur_auto_bolus_total * 0.05;

                            }
                        } catch (e) {
                            console.log('auto mode json error:', e)
                        }


                    } else {
                        insulin_data[n].push(e[5])
                        insulinUsage[n] += e[5];
                        basal_total += e[5];
                        basalUsage[n] += e[5]
                    }
                    let patchId = recordIdPart[1] + '-' + recordIdPart[2];
                    if (usePatchInfo[patchId]) {

                    } else {
                        usePatchInfo[patchId] = 1
                        usePatchNum += 1
                    }
                    //
                    use_duration_day[n] += e[3]
                    use_duration += e[3];
                    //
                    if (0 == e[2].indexOf('SUS')) {
                        suspend_duration += e[3];
                    }

                })
            }
        })
        data.bolus.map(function(d, n) {
                if (d.length) {
                    d.map(function(e, i) {
                        let recordId = e[0];
                        let recordIdSplit = recordId.split('-')
                        if (recordIdSplit[3] >= 8888) {
                            return;
                        }
                        //
                        insulin_data[n].push(e[4] + e[6])
                        insulinUsage[n] += e[4] + e[6];
                        bolus_total += e[4] + e[6];
                        bolusUsage[n] += e[4] + e[6];
                        //
                        bolus_num += 1;
                        // Manual bolus
                        let bolusType = e[2];
                        let bolusInject = e[4] + e[6];
                        let bolusSet = e[3] + e[5];
                        let wizzard = e[8];

                        if (bolusType.indexOf('M') >= 0) {
                            manual_bolus += bolusInject;
                            manual_bolus_num += 1;
                            if (0 == bolusType.indexOf('NB')) {
                                manual_normal_bolus += bolusInject;
                                manual_normal_bolus_num += 1;
                            } else if (0 == bolusType.indexOf('EB')) {
                                manual_extend_bolus += bolusInject;
                                manual_extend_bolus_num += 1;
                            } else if (0 == bolusType.indexOf('CB')) {
                                manual_combo_bolus += bolusInject;
                                manual_combo_bolus_num += 1;
                            }
                        }
                        // wizzard bolus
                        if (bolusType.indexOf('W') >= 0) {
                            wizzard_bolus += bolusInject;
                            wizzard_bolus_num += 1;
                            //
                            if (bolusType.indexOf('CCW') >= 0 || bolusType.indexOf('CAW') >= 0) {
                                food_wizzard_bolus += bolusInject;
                                food_wizzard_bolus_num += 1;
                            } else if (bolusType.indexOf('CRW') >= 0) {
                                corr_wizzard_bolus += bolusInject;
                                corr_wizzard_bolus_num += 1;
                            }
                            //
                            if (wizzard && wizzard.length > 0) {
                                wizzard = JSON.parse(wizzard)
                                let suggest_bolus = getBolusWizzardSuggest(wizzard);
                                if (bolusSet > suggest_bolus) {
                                    wizzard_override_add += (bolusSet - suggest_bolus);
                                    wizzard_override_add_num += 1;
                                } else if (bolusSet < suggest_bolus) {
                                    wizzard_override_sub += (suggest_bolus - bolusSet);
                                    wizzard_override_sub_num += 1;
                                }

                            }
                        }

                    })
                }
            })
            // event的统计
        if (data.event) {
            data.event.map(function(d, n) {
                if (d.length > 0) {
                    d.map(function(e, i) {
                        if ('INS' == e[2]) {
                            let content = e[3];
                            if (content.value) {
                                //let bg_value=content.value;
                                insulin_data[n].push(content.value);
                                //bg_data.push(bg_value);
                            }
                        }
                    })
                }
            })
        }

        let insulinUsage2 = [];

        //console.log('use_duration:', use_duration, context.ts)
        console.log('use_duration_day:', use_duration_day)
        if (use_duration > (context.ts.length * 86400)) {
            //use_duration=
        }

        //
        basal_total = 0;
        bolus_total = 0;


        // 去掉 使用时间小于 23.5 小时的天
        console.log('insulinUsage:', insulin_data, use_duration_day, use_days);
        //let new_use_days=0;
        insulin_data.map(function(d, n) {
            //if (d.length>0){   // 不再根据是否有数据来确定， 而是根据使用时间是否超过23.5小时。
            if (use_duration_day[n] > 23.5 * 86400 / 24.0) {
                let dayTotal = 0;
                d.map(function(e, i) {
                    dayTotal += e;
                })
                insulinUsage2.push(dayTotal);
                // 基础量和大剂量统计
                basal_total += basalUsage[n];
                bolus_total += bolusUsage[n];
            }
        })
        use_days = insulinUsage2.length;
        basal_total = Math.round(basal_total * 1000000) / 1000000;
        console.log('insulinUsage2:', insulinUsage2, basal_total, (basal_total / 2).toFixed(2))
        console.log('patchAvgLife:', use_duration, usePatchNum);
        //let result=this.getAvgSD(insulinUsage);
        let result = this.getAvgSD(insulinUsage2);
        result.use_days = use_days;
        console.log('insulinUsage:', result)
        if (result.num && result.use_days) {
            context.insAvg = this.getInsulinValText(result.avg)
            context.insSD = this.getInsulinValText(result.sd)
                //context.insNum=(use_duration/86400.0).toFixed(2);
            context.insNum = use_days.toFixed(1);
            context.patchAvgLife = ((use_duration / 86400.0) / usePatchNum).toFixed(2);
            context.avgBolusNum = this.getNumText3(bolus_num, result.use_days, 1)

            //
            // basal_total += auto_basal_total;
            // bolus_total += auto_bolus_total;

            inject_total = basal_total + bolus_total;
            if (inject_total) {
                let basalPercent = (basal_total * 100 / inject_total).toFixed(1);
                context.basalPercent = this.getInsulinValText(basal_total / use_days) + 'U/' + basalPercent + ' %';
                context.bolusPercent = this.getInsulinValText(bolus_total / use_days) + 'U/' + (100 - basalPercent).toFixed(1) + ' %';
            }
            context.insPieData = [
                { value: Math.round((bolus_total / use_days) * 100) / 100, name: 'Bolus' },
                { value: Math.round((basal_total / use_days) * 100) / 100, name: 'Basal' },
            ]

            if (bolus_total + basal_total) {
                context.chart6NoData = false;
                context.chart7NoData = false;
            } else {
                context.chart6NoData = true;
                context.chart7NoData = true;
            }
            console.log('chart6NoData:', context.chart6NoData);

            //
            let avgSuspendTime = suspend_duration / result.use_days;
            if (avgSuspendTime < 3600) {
                context.avgSuspendTime = (Math.round((avgSuspendTime % 3600) / 60)) + ' min';
            } else {
                context.avgSuspendTime = Math.floor(avgSuspendTime / 3600) + ' h ' + (Math.round((avgSuspendTime % 3600) / 60)) + ' min';
            }


            // manual bolus
            context.avgManualBolus = this.getInsulinValText(manual_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_bolus_num, use_days)
            context.avgManualNormalBolus = this.getInsulinValText(manual_normal_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_normal_bolus_num, use_days)
            context.avgManualExtendBolus = this.getInsulinValText(manual_extend_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_extend_bolus_num, use_days)
            context.avgManualComboBolus = this.getInsulinValText(manual_combo_bolus / use_days) + ins_unit2 + '/' + this.getNumText(manual_combo_bolus_num, use_days)

            // wizzard bolus
            context.avgWizzardBolus = this.getInsulinValText(wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_bolus_num, use_days, 1)
            context.avgFoodWizzardBolus = this.getInsulinValText(food_wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(food_wizzard_bolus_num, use_days, 1)
            context.avgCorrWizzardBolus = this.getInsulinValText(corr_wizzard_bolus / use_days) + ins_unit2 + '/' + this.getNumText3(corr_wizzard_bolus_num, use_days, 1)
            context.avgWizzardOverrideAdd = this.getInsulinValText(wizzard_override_add / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_override_add_num, use_days, 2)
            context.avgWizzardOverrideSub = this.getInsulinValText(wizzard_override_sub / use_days) + ins_unit2 + '/' + this.getNumText3(wizzard_override_sub_num, use_days, 2)
        } else {
            context.chart6NoData = true;
        }

        // 自动模式相关的数据统计
        let autoModeTime = 0;
        let autoModeTimeSection = [];
        //let dayNum = data.basal.length;
        let dayNum = use_days;

        //
        let autoModeInject = [];
        //let autoModeBasalInjectTotal=0;
        //let autoModeBolusInjectTotal=0;
        let autoModeBasalInject = 0;
        let autoModeBolusInject = 0;

        for (let d = 0; d < data.basal.length; d++) {
            let autoModeBasalTotal = 0;
            let autoModeBolusTotal = 0;
            //
            for (let i = 0; i < data.basal[d].length; i++) {
                let basalType = data.basal[d][i][2];
                let basalRecord = data.basal[d][i];
                if ('BAAM' == basalType) {
                    //console.log('basalRecord:', data.basal[d][i])
                    autoModeTime += basalRecord[3];
                    if (autoModeTimeSection.length > 0) {
                        let lastRecord = autoModeTimeSection[autoModeTimeSection.length - 1];

                        if (basalRecord[1] > lastRecord[1]) {
                            autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]])
                        } else if (basalRecord[1] == lastRecord[1]) {
                            lastRecord[1] = basalRecord[1] + basalRecord[3];
                        }
                    } else {
                        autoModeTimeSection.push([basalRecord[1], basalRecord[1] + basalRecord[3]])
                    }
                    //autoModeTimeSection.push([basalRecord[1], basalRecord[1]+basalRecord[3]])
                    // 统计数据量
                    let autoModeData = basalRecord[7];
                    try {
                        if (autoModeData) {
                            autoModeData = JSON.parse(autoModeData);
                            let microBolusJson = autoModeData['autoModeJSON'];
                            microBolusJson.map(function(e, i) {
                                autoModeBasalTotal += e['auto_basal_delivery'];
                                autoModeBolusTotal += e['auto_food_delivery'] + e['auto_corr_delivery'];
                            })
                        }
                    } catch (e) {
                        console.log('autoModeData error:', e, basalRecord[7])
                    }
                }
            }
            autoModeInject.push([autoModeBasalTotal * 0.05, autoModeBolusTotal * 0.05]);
            autoModeBasalInject += autoModeBasalTotal * 0.05;
            autoModeBolusInject += autoModeBolusTotal * 0.05;
        }
        console.log('autoModeTime:', dayNum, autoModeTime, autoModeTimeSection)
        console.log('autoModeInject:', autoModeInject);
        // 自动输注统计的显示
        if (dayNum) {
            context.autoModeBasalPerDay = this.getInsulinValText(autoModeBasalInject / dayNum) + context.$t('ins_unit2');
            context.autoModeBolusPerDay = this.getInsulinValText(autoModeBolusInject / dayNum) + context.$t('ins_unit2');
        } else {
            context.autoModeBasalPerDay = '--';
            context.autoModeBolusPerDay = '--';
        }



        let autoModeSGTargetHigh = 180 / 18.0;
        let autoModeSGTargetLow = 70 / 18.0;
        let autoModeSG = [];
        let notAutoModeSG = [];
        let autoModeSGInTarget = [];
        let autoModeSGAboveTarget = [];
        let autoModeSGBelowTarget = [];
        for (let d = 0; d < data.sg.length; d++) {
            for (let i = 0; i < data.sg[d].length; i++) {
                let sgRecord = data.sg[d][i];
                let sgState = sgRecord[4];
                let sgValue = sgRecord[3];
                let sgTime = sgRecord[1];
                if ('CX' == sgState || 'C' == sgState || 'NC' == sgState) {
                    if (sgValue > 0.000001) {
                        let sgInAutoMode = false;
                        for (let s = 0; s < autoModeTimeSection.length; s++) {
                            if (sgTime >= autoModeTimeSection[s][0] && sgTime <= autoModeTimeSection[s][1]) {
                                sgInAutoMode = true;
                                break;
                            }
                        }
                        if (sgInAutoMode) {
                            autoModeSG.push(sgValue);
                            if (sgValue >= autoModeSGTargetHigh) {
                                autoModeSGAboveTarget.push(sgValue);
                            } else if (sgValue < autoModeSGTargetLow) {
                                autoModeSGBelowTarget.push(sgValue);
                            } else {
                                autoModeSGInTarget.push(sgValue);
                            }
                        } else {
                            notAutoModeSG.push(sgValue);
                        }
                    }
                }
            }
        }
        console.log('autoModeSG:', autoModeSG.length, autoModeSGAboveTarget.length,
            autoModeSGBelowTarget.length, autoModeSGInTarget.length, notAutoModeSG.length);
        let statResult = this.getAvgSD(autoModeSG);
        console.log('Auto mode SG statResult:', statResult);
        if (statResult.num) {
            context.autoModeSGAvgSD = this.getGlucoseValText2(context.isMg, statResult.avg) + ' ± ' + this.getGlucoseSDValText(context.isMg, statResult.sd);
            let highPercent = parseInt(((autoModeSGAboveTarget.length * 100.0) / autoModeSG.length).toFixed());
            let lowPercent = parseInt(((autoModeSGBelowTarget.length * 100.0) / autoModeSG.length).toFixed());
            let inRangePercent = 100 - highPercent - lowPercent;
            context.autoModeSGInTargetRange = inRangePercent + '%';
            context.autoModeSGAboveRange = highPercent + '%';
            context.autoModeSGBelowRange = lowPercent + '%';

            context.autoModeSGDistPie = {
                'legendData': ['high', 'target', 'low'],
                'selected': { 'low': true, 'target': true, 'high': true },
                'seriesData': [
                    { name: 'high', value: autoModeSGAboveTarget.length },
                    { name: 'target', value: autoModeSGInTarget.length },
                    { name: 'low', value: autoModeSGBelowTarget.length },
                ],
                'dataNum': autoModeSGAboveTarget.length + autoModeSGInTarget.length + autoModeSGBelowTarget.length
            }

        }

        if (dayNum) {
            context.timeInAutoMode = ((autoModeTime * 100.0) / (dayNum * 3600 * 24)).toFixed() + '%'
        } else {
            context.timeInAutoMode = '--';
        }


        return {
            'use_duration_day': use_duration_day,
            'use_duration_day_pre': use_duration_day_pre,
        };
    },

    getDashboardSgStat(context, data) {
        let sg_day_data = [];
        let sg_data = [];
        let use_days = 0;
        let sg_day = data.sg;
        let sgMax = 0;
        let sgMin = 100;
        let hypoNum = 0;
        let lowNum = 0;
        let targetNum = 0;
        let highNum = 0;
        let target_low = data.target_low;
        let target_high = data.target_high;

        let daySelectSpan = sg_day.length;

        sg_day.map(function(d, n) {
            sg_day_data.push([])
        })

        sg_day.map(function(d, n) {
            if (d.length > 0) {
                use_days += 1;
                d.map(function(e, i) {
                    if (e[4] == 'C' || ((e[4] == 'NC' || e[4] == 'CX') && e[3] > 0.00001)) {
                        let val = e[3];
                        val = (val > 22.2) ? 22.2 : val;
                        val = (val < 2.2) ? 2.2 : val;
                        sg_day_data[n].push(val)
                        sg_data.push(val)
                        if (val > sgMax) {
                            sgMax = val;
                        }
                        if (val < sgMin) {
                            sgMin = val;
                        }
                        if (val <= 3.1) {
                            hypoNum += 1;
                        } else if (val > 3.1 && val < target_low) {
                            lowNum += 1;
                        } else if (val >= target_low && val <= target_high) {
                            targetNum += 1;
                        } else if (val > target_high) {
                            highNum += 1;
                        }
                    }
                })
            }
        })

        //
        //sg_day_data.map(function(d,n){})
        //console.log('sg_day_data:', sg_day_data, sg_data, use_days);
        let result = this.getAvgSD(sg_data)
        result.use_days = use_days;
        if (result.num && result.use_days) {
            context.sgAvg = this.getGlucoseValText2(context.isMg, result.avg);
            context.sgSD = this.getGlucoseSDValText(context.isMg, result.sd);
            context.sgNum = this.getNumText2(result.num, 1);

            context.est_a1c = (((result.avg * 18) + 46.7) / 28.7).toFixed(1) + '%';
            if (result.num > daySelectSpan * 720 * 0.8) {
                context.a1c_available = true;
            }

            // aucu, aucl
            let aucu = 0;
            let aucl = 0;
            sg_data.map(function(e, i) {
                if (e > data.target_high) {
                    aucu += e - data.target_high
                }
                if (e < data.target_low) {
                    aucl += data.target_low - e;
                }
            })
            context.aucu = this.getGlucoseValText2(context.isMg, aucu / (720 * use_days));
            context.aucl = this.getGlucoseValText2(context.isMg, aucl / (720 * use_days));
            context.sgHighest = this.getGlucoseValText(context.isMg, sgMax);
            context.sgLowest = this.getGlucoseValText(context.isMg, sgMin);

            // sg 分布
            context.sgDistPie = {
                'legendData': ['high', 'target', 'low', 'hypo'],
                'selected': { 'hypo': true, 'low': true, 'target': true, 'high': true },
                'seriesData': [
                    { name: 'high', value: highNum },
                    { name: 'target', value: targetNum },
                    { name: 'low', value: lowNum },
                    { name: 'hypo', value: hypoNum }
                ],
                'dataNum': highNum + targetNum + lowNum + hypoNum
            }

            let hypoRangeLabel = '< ' + this.getGlucoseValText(context.isMg, 3.1)
            let lowRangeLabel = this.getGlucoseValText2(context.isMg, 3.1) + ' - ' + this.getGlucoseValText(context.isMg, target_low);
            let targetRangeLabel = this.getGlucoseValText2(context.isMg, target_low) + ' - ' + this.getGlucoseValText(context.isMg, target_high);
            let highRangeLabel = '> ' + this.getGlucoseValText(context.isMg, target_high)

            context.sgDistPieLabels = [hypoRangeLabel, lowRangeLabel, targetRangeLabel, highRangeLabel]

        } else {
            context.sgAvg = '--';
            context.sgSD = '--';
            context.sgNum = '--';
        }
    },

    //
    getDashboardSg(context, val) {
        //console.log(val);

        let that = this;
        let sg1 = new Array(144),
            sg2 = new Array(144),
            length1 = val.length,
            sgHalf = new Array(144);
        for (let i = 0; i < 144; i++) {
            sg1[i] = [];
            sg2[i] = [];
        }
        //将属于半个小时内的数据集合在一起
        for (let i = 0; i < length1; i++) {
            let length2 = val[i].length,
                st = context.ts[i][0];
            if (length2 > 0) {
                val[i].map(function(e, i) {
                    if ((e[4] === 'C' || e[4] === 'CX' || e[4] === 'NC') && e[3] > 0.0001 &&
                        e[1] >= st) {
                        let count = Math.floor(parseInt(e[1] - st) / 600);
                        if (count >= 144 || count < 0)
                            return;
                        e[3] = (e[3] > 22.2) ? 22.2 : e[3];
                        e[3] = (e[3] < 2.2) ? 2.2 : e[3];
                        sg1[count].push(e[3]);
                    }
                })
            }
        }

        //排序并找出对应位置的值
        sg1.map(function(e, i) {
            if (e.length > 0) {
                e.sort(that.compare);
                let length3 = e.length;
                let d1 = Math.floor(0.1 * length3);
                let d2 = Math.floor(0.25 * length3);
                let d3 = Math.floor(0.5 * length3);
                let d4 = Math.floor(0.75 * length3);
                let d5 = Math.floor(0.9 * length3);
                sg2[i].push(e[0]);
                sg2[i].push(e[d1]);
                sg2[i].push(e[d2]);
                sg2[i].push(e[d3]);
                sg2[i].push(e[d4]);
                sg2[i].push(e[d5]);
                sg2[i].push(e[length3 - 1]);
                sgHalf[i] = (context.isMg) ? Math.round(e[d3] * 18) : parseFloat(e[d3].toFixed(1));
            }
        });

        //console.log(sg1,sg2);
        //console.log(sg2);

        let YDataMin = new Array(144);
        let YData10P = new Array(144);
        let YDataQ1 = new Array(144);
        let YDataMed = new Array(144);
        let YDataQ3 = new Array(144);
        let YData90P = new Array(144);
        let YDataMax = new Array(144);
        let sel_time = new Date(2019, 0, 1).getTime();

        // 堆叠图需要的差值
        let sg3 = sg2.map(function(e, i) {
            if (e && e.length > 0) {
                let d0 = (context.isMg) ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
                let d1 = (context.isMg) ? Math.round((e[1] - e[0]) * 18) : parseFloat((e[1] - e[0]).toFixed(1));
                let d2 = (context.isMg) ? Math.round((e[2] - e[1]) * 18) : parseFloat((e[2] - e[1]).toFixed(1));
                let d3 = (context.isMg) ? Math.round((e[3] - e[2]) * 18) : parseFloat((e[3] - e[2]).toFixed(1));
                let d4 = (context.isMg) ? Math.round((e[4] - e[3]) * 18) : parseFloat((e[4] - e[3]).toFixed(1));
                let d5 = (context.isMg) ? Math.round((e[5] - e[4]) * 18) : parseFloat((e[5] - e[4]).toFixed(1));
                let d6 = (context.isMg) ? Math.round((e[6] - e[5]) * 18) : parseFloat((e[6] - e[5]).toFixed(1));

                let v0 = (context.isMg) ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
                let v1 = (context.isMg) ? Math.round((e[1]) * 18) : parseFloat((e[1]).toFixed(1));
                let v2 = (context.isMg) ? Math.round((e[2]) * 18) : parseFloat((e[2]).toFixed(1));
                let v3 = (context.isMg) ? Math.round((e[3]) * 18) : parseFloat((e[3]).toFixed(1));
                let v4 = (context.isMg) ? Math.round((e[4]) * 18) : parseFloat((e[4]).toFixed(1));
                let v5 = (context.isMg) ? Math.round((e[5]) * 18) : parseFloat((e[5]).toFixed(1));
                let v6 = (context.isMg) ? Math.round((e[6]) * 18) : parseFloat((e[6]).toFixed(1));


                YDataMin[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d0, v0];
                YData10P[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d1, v1];
                YDataQ1[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d2, v2];
                YDataMed[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d3, v3];
                YDataQ3[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d4, v4];
                YData90P[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d5, v5];
                YDataMax[i] = [sel_time + i * 10 * 60 * 1000 + 5 * 60 * 1000, d6, v6];

                return [d0, d1, d2, d3, d4, d5, d6]
                    //newSg1[0][i] = d0;
                    //newSg1[1][i] = d1;
                    //newSg1[2][i] = d2;
                    //newSg1[3][i] = d3;
            }
        });
        //console.log(sg3);

        context.YDataMin = YDataMin;
        context.YData10P = YData10P;
        context.YDataQ1 = YDataQ1;
        context.YDataMed = YDataMed;
        context.YDataQ3 = YDataQ3;
        context.YData90P = YData90P;
        context.YDataMax = YDataMax;
        //console.log(YDataMin);
    },

    //Segment
    getSegment(context, uid, param) {
        let that = this;
        context.$http.post('/api/v2.1/data/' + uid, param).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                let data = res.data.data;
                //console.log(data);
                if (data.sg) {
                    context.sg = data.sg;
                    that.getSegmentSg(context, data.sg);
                }
                if (data.bolus) {
                    that.getSegmentBolus(context, data.bolus, data.event);
                }
                if (data.device_setting) {
                    that.getSegmentBasal(context, data.device_setting.basal_pattern.seg);
                }
                if (data.device_setting) {
                    let t = that.formatterDate1(new Date(data.device_setting.update_time * 1000));
                    context.update_time = t + ', ' + data.device_setting.pdm_sn;
                    //console.log( context.update_time)
                }
                context.target_high = (context.isMg) ? parseInt(data.target_high * 18) : data.target_high.toFixed(1);
                context.target_low = (context.isMg) ? parseInt(data.target_low * 18) : data.target_low.toFixed(1);
                if (this.chart1_2) {
                    this.chartsDispose();
                }
                this.drawCharts();
            }
        }, function(err) {
            this.error = err.body.message
        });
    },
    getSegmentSg(context, val) {
        // console.log(val);
        let that = this;
        let sg1 = new Array(48),
            sg2 = new Array(48),
            length1 = val.length,
            sgHalf = new Array(48);
        for (let i = 0; i < 48; i++) {
            sg1[i] = [];
            sg2[i] = [];
        }
        //将属于半个小时内的数据集合在一起
        for (let i = 0; i < length1; i++) {
            let length2 = val[i].length,
                st = context.ts[i][0];
            if (length2 > 0) {
                val[i].map(function(e, i) {
                    if (e[4] === 'C' && e[1] >= st) {
                        let count = Math.floor(parseInt(e[1] - st) / 1800);
                        e[3] = (e[3] > 22.2) ? 22.2 : e[3];
                        e[3] = (e[3] < 2.2) ? 2.2 : e[3];
                        sg1[count].push(e[3]);
                    }
                })
            }
        }
        //排序并找出对应位置的值
        sg1.map(function(e, i) {
            if (e.length > 0) {
                e.sort(that.compare);
                let length3 = e.length;
                let d1 = Math.floor(0.1 * length3);
                let d2 = Math.floor(0.25 * length3);
                let d3 = Math.floor(0.5 * length3);
                let d4 = Math.floor(0.75 * length3);
                let d5 = Math.floor(0.9 * length3);
                sg2[i].push(e[d1]);
                sg2[i].push(e[d2]);
                sg2[i].push(e[d3]);
                sg2[i].push(e[d4]);
                sg2[i].push(e[d5]);
                sgHalf[i] = (context.isMg) ? Math.round(e[d3] * 18) : parseFloat(e[d3].toFixed(1));
            }
        });

        //console.log(sg1,sg2);
        //处理显示值
        let newSg1 = new Array(4);
        for (let i = 0; i < 4; i++) {
            newSg1[i] = [];
        }
        sg2.map(function(e, i) {
            if (e.length > 0) {
                let d0 = (context.isMg) ? Math.round(e[0] * 18) : parseFloat(e[0].toFixed(1));
                let d1 = (context.isMg) ? Math.round((e[1] - e[0]) * 18) : parseFloat((e[1] - e[0]).toFixed(1));
                let d2 = (context.isMg) ? Math.round((e[3] - e[1]) * 18) : parseFloat((e[3] - e[1]).toFixed(1));
                let d3 = (context.isMg) ? Math.round((e[4] - e[3]) * 18) : parseFloat((e[4] - e[3]).toFixed(1));
                newSg1[0][i] = d0;
                newSg1[1][i] = d1;
                newSg1[2][i] = d2;
                newSg1[3][i] = d3;
            }
        });
        context.sg1 = newSg1;
        context.sgHalf = sgHalf;
        // console.log(newSg1);
    },
    getSegmentBolus(context, val, val2) {
        //console.log(val2);
        let that = this;
        let bolus1 = new Array(48),
            bolus2 = new Array(48),
            length1 = val.length,
            length3 = val2.length,
            countArray = new Array(48),
            maxGroup = [];
        for (let i = 0; i < 48; i++) {
            bolus1[i] = [];
            bolus2[i] = new Array(5);
            countArray[i] = 0;
        }
        //统计bolus
        for (let i = 0; i < length1; i++) {
            let length2 = val[i].length,
                st = context.ts[i][0];
            if (length2 > 0) {
                val[i].map(function(e, i) {
                    if (e[2] === 'EBCCW' || e[2] === 'EBM' || e[2] === 'EBCAW') {
                        if (e[1] >= st) {
                            let k = Math.floor(parseInt(e[1] - st) / 1800);
                            let end = e[1] + e[7] * 60;
                            let half = st + (k + 1) * 1800;
                            let value = e[6];
                            //持续时间超过半小时则分段
                            if (end > half) {
                                value = ((half - e[1]) / (e[7] * 60)) * e[6];
                                if ((k + 1) < 48) {
                                    bolus1[k + 1].push(e[6] - value);
                                }
                            }
                            bolus1[k].push(value);
                            countArray[k]++;
                        }
                    } else if (e[2] === 'CBCCW' || e[2] === 'CBM' || e[2] === 'CBCAW') {
                        if (e[1] >= st) {
                            let k = Math.floor(parseInt(e[1] - st) / 1800);
                            let end = e[1] + e[7] * 60;
                            let half = st + (k + 1) * 1800;
                            let value = e[6];
                            if (end > half) {
                                value = ((half - e[1]) / (e[7] * 60)) * e[6];
                                if ((k + 1) < 48) {
                                    bolus1[k + 1].push(e[6] - value);
                                }
                            }
                            bolus1[k].push(value + e[4]);
                            countArray[k]++;
                        }
                    } else {
                        if (e[1] >= st) {
                            let k = Math.floor(parseInt(e[1] - st) / 1800);
                            bolus1[k].push(e[4]);
                            countArray[k]++;
                        }
                    }
                })
            }
        }
        //统计events
        for (let i = 0; i < length3; i++) {
            let length2 = val2[i].length,
                st = context.ts[i][0];
            if (length2 > 0) {
                val2[i].map(function(e, i) {
                    if (e[2] === 'INS' && e[1] >= st && e[3].value) {
                        let k = Math.floor(parseInt(e[1] - st) / 1800);
                        bolus1[k].push(e[3].value);
                        countArray[k]++;
                    }
                })
            }
        }

        //排序找需要的值
        bolus1.map(function(e, i) {
            if (e.length > 0) {
                e.sort(that.compare);
                let length3 = e.length;
                let d1 = Math.floor(0.1 * length3);
                let d2 = Math.floor(0.25 * length3);
                let d3 = Math.floor(0.5 * length3);
                let d4 = Math.floor(0.75 * length3);
                let d5 = Math.floor(0.9 * length3);
                bolus2[i][0] = e[d1].toFixed(1);
                bolus2[i][1] = e[d2].toFixed(1);
                bolus2[i][2] = e[d3].toFixed(1);
                bolus2[i][3] = e[d4].toFixed(1);
                bolus2[i][4] = e[d5].toFixed(1);
                maxGroup.push(parseFloat(e[d5].toFixed(1)));
            }
        });
        context.bolus1 = bolus2;
        // console.log(context.bolus1)
        let max = (maxGroup.length > 2) ? Math.max.apply(null, maxGroup) : 10;
        if (max < 10) { max = 10 } else if (max < 15) { max = 15 } else if (max < 20) { max = 20 } else if (max < 30) { max = 30 } else if (max < 50) { max = 50 }
        context.bolusMax = max;

        let bolCount = [],
            k = 0;
        countArray.map(function(e, i) {
            if (e !== 0) {
                bolCount[k] = [];
                bolCount[k][0] = i;
                bolCount[k][1] = e;
                k++;
            }
        });
        context.bolCount = bolCount;
        //console.log(bolus2,countArray)
    },
    compare(value1, value2) {
        return value1 - value2;
    },

    getSegmentBasal(context, val) {
        let st = context.ts[0][0],
            et = context.ts[0][1],
            basal = [],
            p = 0,
            length = val.length,
            value = [];
        for (let i = 0; i < length; i++) {
            let t1 = val[i][0].split(':');
            let t = st + parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60;
            basal[p] = [];
            basal[p][0] = new Date(t * 1000);
            basal[p][1] = val[i][1];
            if (i < length - 1) {
                basal[p][2] = val[i][0] + ' - ' + val[i + 1][0];
            } else {
                basal[p][2] = val[i][0] + ' - ' + '24:00';
            }

            value.push(val[i][1]);
            p++;
            if (i < length - 1) {
                t1 = val[i + 1][0].split(':');
                t = st + parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60;
            } else {
                t = et;
            }
            basal[p] = [];
            basal[p][0] = new Date(t * 1000);
            basal[p][1] = val[i][1];
            if (i < length - 1) {
                basal[p][2] = val[i][0] + ' - ' + val[i + 1][0];
            } else {
                basal[p][2] = val[i][0] + ' - ' + '24:00';
            }
            p++;

        }
        let max = (value.length > 0) ? Math.max.apply(null, value) : 5;
        if (max <= 2) { max = 2.5 } else if (max <= 4) { max = 4 } else if (max <= 5) { max = 5 } else { max = 10 }
        context.basal = basal;
        context.basalMax = max;
        //console.log(val,basal);
    },

    //chartSettings
    getSettingData(context, uid) {
        context.$http.get(SERVER_URL + '/v2.0/settings/' + uid).then(function(res) {
            let err = res.body.error;
            context.En = (localStorage.getItem('unit') === 'mg') ? true : false;
            if (err === 0) {
                let settings = res.data.settings;
                //console.log( res.data)
                if (context.En) {
                    settings.glucose_unit = 'mg/dL';
                    settings.blos_low_before_b = Math.round(settings.blos_low_before_b * 18);
                    settings.blos_low_before_b = (settings.blos_low_before_b < 60) ? 60 : settings.blos_low_before_b;
                    settings.blos_low_before_b = (settings.blos_low_before_b > 100) ? 100 : settings.blos_low_before_b;

                    settings.blos_high_before_b = Math.round(settings.blos_high_before_b * 18);
                    settings.blos_low_after_b = Math.round(settings.blos_low_after_b * 18);
                    settings.blos_low_after_b = (settings.blos_low_after_b < 60) ? 60 : settings.blos_low_after_b;
                    settings.blos_low_after_b = (settings.blos_low_after_b > 100) ? 100 : settings.blos_low_after_b;

                    settings.blos_high_after_b = Math.round(settings.blos_high_after_b * 18);
                    settings.blos_low_before_l = Math.round(settings.blos_low_before_l * 18);
                    settings.blos_low_before_l = (settings.blos_low_before_l < 60) ? 60 : settings.blos_low_before_l;
                    settings.blos_low_before_l = (settings.blos_low_before_l > 100) ? 100 : settings.blos_low_before_l;

                    settings.blos_high_before_l = Math.round(settings.blos_high_before_l * 18);
                    settings.blos_low_after_l = Math.round(settings.blos_low_after_l * 18);
                    settings.blos_low_after_l = (settings.blos_low_after_l < 60) ? 60 : settings.blos_low_after_l;
                    settings.blos_low_after_l = (settings.blos_low_after_l > 100) ? 100 : settings.blos_low_after_l;

                    settings.blos_high_after_l = Math.round(settings.blos_high_after_l * 18);
                    settings.blos_low_before_s = Math.round(settings.blos_low_before_s * 18);
                    settings.blos_low_before_s = (settings.blos_low_before_s < 60) ? 60 : settings.blos_low_before_s;
                    settings.blos_low_before_s = (settings.blos_low_before_s > 100) ? 100 : settings.blos_low_before_s;

                    settings.blos_high_before_s = Math.round(settings.blos_high_before_s * 18);
                    settings.blos_low_after_s = Math.round(settings.blos_low_after_s * 18);
                    settings.blos_low_after_s = (settings.blos_low_after_s < 60) ? 60 : settings.blos_low_after_s;
                    settings.blos_low_after_s = (settings.blos_low_after_s > 100) ? 100 : settings.blos_low_after_s;

                    settings.blos_high_after_s = Math.round(settings.blos_high_after_s * 18);
                    settings.blos_low_night = Math.round(settings.blos_low_night * 18);
                    settings.blos_low_night = (settings.blos_low_night < 60) ? 60 : settings.blos_low_night;
                    settings.blos_low_night = (settings.blos_low_night > 100) ? 100 : settings.blos_low_night;

                    settings.blos_high_night = Math.round(settings.blos_high_night * 18);
                    settings.blos_low = Math.round(settings.blos_low * 18);
                    settings.blos_low = (settings.blos_low < 60) ? 60 : settings.blos_low;

                    settings.blos_high = Math.round(settings.blos_high * 18);
                    settings.hypo = Math.round(settings.hypo * 18);
                } else {
                    settings.glucose_unit = 'mmol/L';
                    settings.blos_low_before_b = settings.blos_low_before_b.toFixed(1);
                    settings.blos_high_before_b = settings.blos_high_before_b.toFixed(1);
                    settings.blos_low_after_b = settings.blos_low_after_b.toFixed(1);
                    settings.blos_high_after_b = settings.blos_high_after_b.toFixed(1);
                    settings.blos_low_before_l = settings.blos_low_before_l.toFixed(1);
                    settings.blos_high_before_l = settings.blos_high_before_l.toFixed(1);
                    settings.blos_low_after_l = settings.blos_low_after_l.toFixed(1);
                    settings.blos_high_after_l = settings.blos_high_after_l.toFixed(1);
                    settings.blos_low_before_s = settings.blos_low_before_s.toFixed(1);
                    settings.blos_high_before_s = settings.blos_high_before_s.toFixed(1);
                    settings.blos_low_after_s = settings.blos_low_after_s.toFixed(1);
                    settings.blos_high_after_s = settings.blos_high_after_s.toFixed(1);
                    settings.blos_low_night = settings.blos_low_night.toFixed(1);
                    settings.blos_high_night = settings.blos_high_night.toFixed(1);
                    settings.blos_low = settings.blos_low.toFixed(1);
                    settings.blos_high = settings.blos_high.toFixed(1);
                    settings.hypo = settings.hypo.toFixed(1);
                }
                context.$store.commit('updateSettingData', settings);
                context.$store.commit('updateAlarm', settings.alarm_display);
            }
        }, function(err) {
            alert(err + "," + err.body.message);
        })
    },
    getSessions(context, uid) {
        //console.log('getSessions')
        let that = this;

        function addPreZero(pdm_sn_hex, num) {
            let pre = '';
            for (let i = 0; i < num; i++) {
                pre += '0';
            }
            return pre + pdm_sn_hex;
        }

        context.$http.get(SERVER_URL + '/v2.0/pdm/' + uid + '/sessions').then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {


                let sessions = res.body.sessions;
                for (let i = 0; i < sessions.length; i++) {
                    for (let j = 0; j < sessions[i].length; j++) {
                        for (let k = 0; k < 8; k++) {
                            if (k === 3 || k === 4 || k === 5) {
                                let time = new Date(sessions[i][j][k] * 1000);
                                sessions[i][j][k] = (context.isZh) ? that.formateDate(time) : that.formatterDate1(time);
                            } else if (k === 6) { // pdm sn
                                let pdm_sn = sessions[i][j][k];
                                pdm_sn = parseInt(pdm_sn);
                                //console.log('pdm_sn:', pdm_sn);
                                if ((100000000 <= pdm_sn && pdm_sn <= 101999999) ||
                                    (109000000 <= pdm_sn && pdm_sn <= 109999999) ||
                                    (112000000 <= pdm_sn && pdm_sn <= 112999999)) {
                                    //console.log('pdm_sn.1:');
                                } else {
                                    let pdm_sn_hex = pdm_sn.toString(16); //.toUpperCase()
                                    //console.log('pdm_sn.2:', pdm_sn, pdm_sn_hex);
                                    sessions[i][j][k] = addPreZero(pdm_sn_hex.toUpperCase(), 8 - pdm_sn_hex.length);
                                }
                            } else if (k === 1) { // ty jn sn
                                let ty_jn_sn = sessions[i][j][k];
                                ty_jn_sn = parseInt(ty_jn_sn);
                                //console.log('pdm_sn:', pdm_sn);
                                if ((102000000 <= ty_jn_sn && ty_jn_sn <= 103999999) ||
                                    (114000000 <= ty_jn_sn && ty_jn_sn <= 115999999) ||
                                    (118000000 <= ty_jn_sn && ty_jn_sn <= 119999999) ||
                                    (106000000 <= ty_jn_sn && ty_jn_sn <= 106999999)) {
                                    //console.log('pdm_sn.1:');
                                } else {
                                    let ty_jn_sn_hex = ty_jn_sn.toString(16); //.toUpperCase()
                                    //console.log('pdm_sn.2:', pdm_sn, pdm_sn_hex);
                                    sessions[i][j][k] = addPreZero(ty_jn_sn_hex.toUpperCase(), 8 - ty_jn_sn_hex.length);
                                }
                            }
                        }
                    }
                }
                context.Sessions = sessions;
                //
                let data = res.data.options;
                context.cgms = (data.cgms) ? data.cgms : [];
                context.pump = (data.pump) ? data.pump : [];

                if (context.Sessions[0].length) {
                    context.haveSensorData = true;
                } else {
                    context.haveSensorData = false;
                }
                if (context.Sessions[1].length) {
                    context.havePumpData = true;
                } else {
                    context.havePumpData = false;
                }
                console.log('havePumpData:', context.havePumpData, context.haveSensorData);

                if (data.option === 'daopapp') {
                    context.isA = true;
                    context.isB = false;
                    sessionStorage.setItem('dateViewA', 1);
                    sessionStorage.setItem('dateViewB', 0);
                } else {
                    context.isB = true;
                    context.isA = false;
                    sessionStorage.setItem('dateViewA', 0);
                    sessionStorage.setItem('dateViewB', 1);
                }

                //
                if (context.isB) {
                    //console.log('checkset')
                    //context.$nextTick(context.checkSet);
                    setTimeout(context.checkSet, 50);
                }
                // this.$store.commit('updateSessions',sessions);
            }
        }, function(err) {
            alert(err + "," + err.body.message);
        })
    },
    setData(context, uid, param) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/options/' + uid + '/data', param).then(function(res) {
            let err = res.body.error;
            console.log('save options:', err)
            if (err === 0) {
                //console.log('save options:', res.body.data)
                //if(context.isB){
                let tip = context.$t('saveTip');
                context.$message({
                    type: 'success',
                    message: tip
                });
                //}
            }
            if (err === 34) {
                let tip = context.$t('Time overlapped');
                context.$message.error(tip);
            }
        })
    },
    getSet(context, uid) {
        //console.log('getSet')
        context.$http.get(SERVER_URL + '/v2.0/options/' + uid + '/data').then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let data = res.data.data;
                console.log('options.data:', data);
                context.cgms = (data.cgms) ? data.cgms : [];
                context.pump = (data.pump) ? data.pump : [];

                if (data.option === 'daopapp') {
                    context.isA = true;
                    context.isB = false;
                    sessionStorage.setItem('dateViewA', 1);
                    sessionStorage.setItem('dateViewB', 0);
                    context.isRealtime = true;
                    context.isPDM = false;
                } else {
                    context.isB = true;
                    context.isA = false;
                    sessionStorage.setItem('dateViewA', 0);
                    sessionStorage.setItem('dateViewB', 1);
                    context.isRealtime = false;
                    context.isPDM = true;
                }
                /* if(data.option!=='daopapp'){
                   context.checkSet();
                 }*/
            }
        })
    },

    //events
    getEvents(context, uid, param) {
        let that = this;
        let ins_unit2 = context.$t('ins_unit2');
        context.$http.get(SERVER_URL + '/v2.0/events/' + uid, { params: param }).then(function(res) {
            let err = res.data.error;
            //console.log(res)
            if (err === 0) {
                let dataObj = res.data.data;
                context.defaultDate2 = (dataObj.st) ? that.formatterDate4(dataObj.st) : that.formatterDate4(new Date().setHours(0, 0, 0, 0) / 1000 - 86400 * 6);
                console.log('event:', dataObj.items)
                let isEn = (sessionStorage.getItem('language') !== 'zh') ? true : false;
                let events = dataObj.items.map(function(e, i) {
                    e[1] = (isEn) ? that.formatterDate1(new Date(e[1] * 1000)) : that.formateDate(new Date(e[1] * 1000));
                    if (e[3]) {
                        if (e[2] === 'BG') {
                            e[3].value = (context.isMg) ? e[3].value : (e[3].value / 18).toFixed(1);
                            e[3].value = e[3].value + ' ' + context.unit
                        }
                        if (e[2] === 'CARB') { e[3].value = e[3].value + ' g' }
                        if (e[2] === 'INS') { e[3].value = e[3].value + ' ' + ins_unit2 }
                        if (e[2] === 'EXR') {
                            e[3].value = e[3].value + ' min';
                            let exercise = ["Light", "Medium", "Heavy"];
                            e[3].value = e[3].value + ' ' + exercise[e[3].exerciseIntensity];
                        }
                        if (e[2] === 'AutoExercise') {
                            if (e[3].value) {
                                e[3].value = e[3].value + ' min';
                            } else {
                                e[3].value = e[3].duration + ' min';
                            }
                        }
                        if (e[2] === 'HBA1C') { e[3].value = e[3].value + ' %' }
                        if (e[2] === 'URINEK') {
                            let urinekType = ['Negative', 'Macro', '+', '++', '+++', '++++'];
                            e[3].value = urinekType[e[3].value - 1];
                        }
                        if (e[2] === 'OTR') {
                            e[3].value = '...';
                        }
                    }
                    e[2] = context.$t(e[2]);
                    e[4] = (e[4] === 'pdm') ? context.$t('pdm') : e[4];
                    return e;
                });
                context.$store.commit('updateEvents', events);
                this.pages = dataObj.pages;
                this.has_next = dataObj.has_next;
                this.has_prev = dataObj.has_prev;
            }
        })
    },
    newEvents(context, uid, param) {
        context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/new', { data: [param] }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('saveTip');
                context.$message({
                    type: 'success',
                    message: tip
                });
                context.getEvents();
                context.isA = false;
            } else {
                let tip = context.$t('createFailed');
                context.$message.error(tip);
            }
        })
    },
    deleteEvents(context, uid, param) {
        //console.log(param);
        context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/delete', { eids: param }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('deleteSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
                context.eids = [];
                context.getEvents();
            } else {
                let tip = context.$t('deleteFailed');
                context.$message.error(tip);
            }
        })
    },

    deleteData(context) {
        //console.log(param);
        context.$http.post(SERVER_URL + '/v2.0/data/delete').then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('deleteSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });

                //context.eids = [];
                //context.getEvents();
                //this.getSessions(context, context.uid)
                //console.log("context.Sessions");
                context.Sessions = [];
            } else {
                let tip = context.$t('deleteFailed');
                context.$message.error(tip);
            }
        })
    },

    editEvents(context, uid, eid, param) {
        context.$http.post(SERVER_URL + '/v2.0/events/' + uid + '/data/' + eid, { event: param }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('editSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
                context.isB = false;
                context.getEvents();
            } else {
                let tip = context.$t('editFailed');
                context.$message.error(tip);
            }
        })
    },

    //Records
    getRecords(context, uid) {
        let that = this;
        context.$http.get(SERVER_URL + '/v2.0/records/' + uid).then(function(res) {
            let err = res.data.error;
            if (err === 0) {
                let dataObj = res.data.data;
                //console.log(dataObj)
                dataObj.profile.diabetes_type = context.$t(dataObj.profile.diabetes_type);
                if (dataObj.profile.height) {
                    dataObj.profile.height = dataObj.profile.height + ' cm';
                }
                if (dataObj.profile.weight) {
                    dataObj.profile.weight = dataObj.profile.weight + ' kg';
                }
                if (dataObj.profile.birthday) {
                    let y = parseInt(dataObj.profile.birthday.split('-')[0]);
                    let y1 = new Date().getFullYear();
                    dataObj.profile.birthday = y1 - y;
                }
                if (dataObj.profile.diabetes_diagnosis_date) {
                    let t = dataObj.profile.diabetes_diagnosis_date.split('-');
                    let y1 = new Date().getFullYear();
                    let m1 = new Date().getMonth() + 1;
                    let y = y1 - parseInt(t[0]);
                    let m = m1 - parseInt(t[1]);
                    if (m < 0) {
                        y--;
                        m += 12;
                    }
                    let year = (y > 1) ? context.$t('Years') : context.$t('Year');
                    let month = (m > 1) ? context.$t('Months') : context.$t('Month');
                    let lang = localStorage.getItem('language');
                    dataObj.profile.diabetes_diagnosis_date = (lang === 'zh' || lang === 'hk') ? y + ' 年 ' + m + ' 月' : y + ' ' + year + ' ' + m + ' ' + month;
                }
                context.profile = dataObj.profile;
                let isEn = (sessionStorage.getItem('language') !== 'zh') ? true : false;
                context.complications = dataObj.complications.map(function(e, i) {
                    //e[1] = context.$t(e[1]);
                    e[2] = (isEn) ? that.formatterDate4(e[2]) : that.formatterDate3(e[2]);
                    return e;
                });
                context.prescription = dataObj.prescription;
                context.suggestions = dataObj.suggestions.map(function(e, i) {
                    e[1] = (isEn) ? that.formatterDate4(e[1]) : that.formatterDate3(e[1]);
                    return e;
                });

                sessionStorage.setItem('Rpro', JSON.stringify(context.profile));
                sessionStorage.setItem('Rcop', JSON.stringify(context.complications));
                sessionStorage.setItem('Rpre', JSON.stringify(context.prescription));
                sessionStorage.setItem('Rsug', JSON.stringify(context.suggestions));

                // console.log(dataObj);
            }
        });
    },
    newRecords(context, uid, param) {
        let that = this;
        //console.log(param)
        context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/new', { data: param }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                console.log(res)
                let tip = context.$t('createSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
                this.CreateVisible = false;
                that.getRecords(context, uid);
            } else {
                let tip = context.$t('createFailed');
                context.$message.error(tip);
            }
        }, function(err) {
            let tip = context.$t('createFailed');
            context.$message.error(tip);
        })
    },
    deleteRecords(context, uid, param) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/delete', { rids: param }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('deleteSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
                that.getRecords(context, uid);
            } else {
                let tip = context.$t('deleteFailed');
                context.$message.error(tip);
            }
        })
    },
    editRecords(context, uid, param) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/records/' + uid + '/data/edit', { data: param }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                context.EditVisible = false;
                let tip = context.$t('editSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
                that.getRecords(context, uid);
            } else {
                let tip = context.$t('editFailed');
                context.$message.error(tip);
            }
        })
    },

    //监护人connections列表
    getConnections(context, info) {
        let that = this;
        let now = new Date() / 1000;
        context.$http.get(SERVER_URL + '/v2.1/monitor/connections', { params: info }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let data = res.body.data;
                //console.log(data)
                let dataObj = data.items;
                context.connections = dataObj.map(function(e, i) {
                    let t1 = (now - e.sensor_status.updateTime);
                    let t2 = (now - e.pump_status.updateTime);
                    if (e.sensor_status.glucose) {
                        console.log('connection.glucose:', e.alias, e.sensor_status.glucose);
                        e.sensor_status.glucose = (e.sensor_status.glucose).toFixed(1);
                    } else {
                        e.sensor_status.glucose = '--';
                    }
                    if (e.pump_status.basalRate) {
                        e.pump_status.basalRate = (e.pump_status.basalRate).toFixed(1);
                    }
                    if (e.pump_status.iob) {
                        e.pump_status.iob = (e.pump_status.iob).toFixed(2);
                    }
                    if (t1 > 3600) {
                        e.sensor_status.glucose = '--';
                    }
                    if (t2 > 3600) {
                        e.pump_status.basalRate = '--';
                        e.pump_status.iob = '--';
                    }
                    e.alias = (e.alias) ? e.alias : e.real_name;
                    return e;
                });
                this.pages = (data.pages !== 0) ? data.pages : 1;
                this.has_next = data.has_next;
                this.has_prev = data.has_prev;
            }
            if (err === 14) {
                context.$router.push('/login');
            }
        })
    },

    //患者connection
    getPatientConnections(context) {
        context.$http.get(SERVER_URL + '/v2.0/relations/auth').then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let data = res.data.data;
                context.hcp = [];
                context.carer = [];
                context.hcpApply = [];
                context.carerApply = [];
                context.oauth2 = data.oauth2;
                data.hcp.map((e, i) => {
                    if (e.state === 'ACCEPT') {
                        context.hcp.push(e)
                    } else {
                        context.hcpApply.push(e)
                    }
                });
                data.carer.map((e, i) => {
                    if (e.state === 'ACCEPT') {
                        context.carer.push(e)
                    } else {
                        context.carerApply.push(e)
                    }
                });
                console.log('connection.data:', data);
                if (data.hcp.length === 0 && data.carer.length === 0) {
                    context.noMes = true;
                }
            }
            if (err === 14) {
                context.$router.push('/login');
            }
        })
    },
    deleteConnection(context, id) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/relations/auth/cancel', { uid: id }).then(function(res) {
            let err = res.body.error;
            if (err === 0) {
                let tip = context.$t('deleteSuccess');
                context.$message({
                    type: 'success',
                    message: tip
                });
            } else {
                let tip = context.$t('deleteFailed');
                context.$message.error(tip);
            }
            that.getPatientConnections(context);
        })
    },
    addConnection(context, id) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/relations/auth/permit', { uid: id }).then(function(res) {
            let err = res.body.error;
            console.log(res);
            if (err === 0) {
                let tip = context.$t('acceSu');
                context.$message({
                    type: 'success',
                    message: tip
                });
            } else {
                let tip = context.$t('acceEr');
                context.$message.error(tip);
            }
            that.getPatientConnections(context);
            that.getUnread1(context);
        })
    },
    rejectConnection(context, id) {
        let that = this;
        context.$http.post(SERVER_URL + '/v2.0/relations/auth/reject', { uid: id }).then(function(res) {
            let err = res.body.error;
            console.log(res);
            if (err === 0) {
                let tip = context.$t('rejeSu');
                context.$message({
                    type: 'success',
                    message: tip
                });
            } else {
                let tip = context.$t('rejeEr');
                context.$message.error(tip);
            }
            that.getPatientConnections(context);
            that.getUnread1(context);
        })
    },

    //时间格式化
    formateDate(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        let s = date.getSeconds();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        mi = mi < 10 ? ('0' + mi) : mi;
        return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
    },
    formatterDate1(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        let s = date.getSeconds();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        s = s < 10 ? ('0' + s) : s;
        return d + '-' + m + '-' + y + ' ' + h + ':' + mi + ':' + s;
    },
    formatterDate1a(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        let s = date.getSeconds();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
    },
    formatterDate1b(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        let s = date.getSeconds();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + m + '-' + d;
    },
    formatterDate1c(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        let s = date.getSeconds();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        s = s < 10 ? ('0' + s) : s;
        return y + '' + m + '' + d;
    },

    formatterDate2(val) {
        let time = new Date(val * 1000);
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        return d + '/' + m + '/' + y;
    },
    formatterDate3(val) {
        let time = new Date(val * 1000);
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    },
    formatterDate4(val) {
        let time = new Date(val * 1000);
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        return d + '-' + m + '-' + y;
    },
    formatterDate4_1(val) {
        let time = new Date(val * 1000);
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        //m = m<10 ? ('0'+m ): m;
        //d = d<10 ? ('0'+d) : d;
        return d + '-' + m;
    },
    formatterDate5(val) {
        let h = val.getHours();
        let mi = val.getMinutes();
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        return [h, mi];
    },
    formatterDate6(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
    },
    formatterDate7(context, val) {
        if (!val) {
            return '--';
        }
        let date = new Date(val * 1000);
        let now = new Date().getDate();
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        if (now === parseInt(d)) {
            return context.$t('Today') + ' ' + h + ':' + mi;
        } else if ((now - 1) === parseInt(d)) {
            return context.$t('Yesterday') + ' ' + h + ':' + mi;
        } else {
            return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
        }

    },
    formatterDate8(val) {
        let time = new Date(val * 1000);
        let m = time.getMonth() + 1;
        let d = time.getDate();
        m = m < 10 ? ('0' + m) : m;
        d = d < 10 ? ('0' + d) : d;
        return d + '/' + m;
    },
    formatterDate9(val) {
        let time = new Date(val * 1000);
        let y = time.getFullYear();
        let m = time.getMonth();
        let d = time.getDate();
        return [parseInt(y), parseInt(m), parseInt(d)];
    },
    formatterDate10(val) {
        let time = new Date(val * 1000);
        let h = time.getHours();
        let m = time.getMinutes();
        let s = time.getSeconds();
        return [parseInt(h), parseInt(m), parseInt(s)];
    },
    formatterDay(context, val) {
        let time = new Date(val * 1000);
        let week = new Array(context.$t('Sun'), context.$t('Mon'), context.$t('Tue'), context.$t('Wed'), context.$t('Thur'), context.$t('Fri'), context.$t('Sat'));
        let day = time.getDay();
        return week[day];
    },
    getTime(val) {
        let isEn = (localStorage.getItem('language') === 'zh' || localStorage.getItem('language') === 'hk') ? true : false;
        //console.log(isEn)
        if (val < 0) {
            return '--';
        } else {
            let d = parseInt(val * 2 / 1440);
            let h = parseInt(val * 2 % 1440 / 60);
            let mi = parseInt(val * 2 % 60);
            if (d === 0) {
                return (isEn) ? h + ' 小时 ' + mi + ' 分钟' : h + ' h ' + mi + ' min';
            } else {
                return (isEn) ? d + ' 天 ' + h + ' 小时 ' + mi + ' 分钟' : d + ' day ' + h + ' h ' + mi + ' min';
            }
        }
    },
    getTime2(val) {
        let h = parseInt(val / 60);
        let mi = val % 60;
        h = h < 10 ? ('0' + h) : h;
        mi = mi < 10 ? ('0' + mi) : mi;
        return [h, mi];
    },
    getTime3(val) {
        let isEn = (localStorage.getItem('language') === 'zh' || localStorage.getItem('language') === 'hk') ? true : false;
        if (val < 0) {
            return '--';
        } else {
            let d = parseInt(val / 1440);
            let h = parseInt(val % 1440 / 60);
            let mi = parseInt(val % 60);
            if (d === 0) {
                return (isEn) ? h + ' 小时 ' + mi + ' 分钟' : h + ' h ' + mi + ' min';
            } else {
                return (isEn) ? d + ' 天 ' + h + ' 小时 ' + mi + ' 分钟' : d + ' day ' + h + ' h ' + mi + ' min';
            }
        }
    },

    //密码
    modifyPassword(context, param) {
        context.$http.post(SERVER_URL + '/v2.0/password/modify', param).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                let tip = context.$t('saveTip');
                context.$message({
                    type: 'success',
                    message: tip
                });
                let user = sessionStorage.getItem('userType');
                if (user === 'P') { context.$router.push('/monitor'); }
                if (user === 'D') { context.$router.push('/PatientList'); }
                if (user === 'M') { context.$router.push('/carerConnection'); }
            } else {
                let tip = context.$t('oldErr');
                context.$message.error(tip);
            }
        })
    },
    getToken(context, param) {
        //console.log(param);
        context.$http.get(SERVER_URL + '/v2.0/password/reset/token', { params: { param: param } }).then(function(res) {
            let err = res.body.error;
            //console.log(res);
            if (err === 0) {
                context.passwordToken = res.data.token;
                context.isB = false;
                context.isC = true;
                sessionStorage.setItem('B', 0);
                sessionStorage.setItem('C', 1);
            } else {
                let tip = context.$t('verErrTip');
                context.$message.error(tip);
            }
        })
    },
    resetPassword(context, param) {
        context.$http.post(SERVER_URL + '/v2.0/password/reset', param).then(function(res) {
            let err = res.body.error;
            // console.log(res);
            if (err === 0) {
                this.isC = false;
                this.isD = true;
                sessionStorage.setItem('C', 0);
                sessionStorage.setItem('D', 1);
            } else {
                let tip = context.$t('modifyFailed');
                context.$message.error(tip);
            }
        })
    },
    init() {
        var height = window.innerHeight;
        var width = window.innerWidth;
        var body = document.getElementsByTagName('body')[0];
        body.style.height = height + 'px';
        body.style.width = width + 'px';
        console.log(body.style.width + 'X' + body.style.height);
    },
    getAuthHeader() {
        return {
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
    },
    checkAuth() {
        let token = sessionStorage.getItem('token');
        if (token) {
            this.authenticated = true;
        } else {
            this.authenticated = false;
        }
    },

    //点击patientList清除部分session
    clearSession() {
        let tz = parseInt(sessionStorage.getItem('tz'));
        let uid = parseInt(sessionStorage.getItem('uid'));
        let userType = sessionStorage.getItem('userType');
        let username = sessionStorage.getItem('username');
        let token = sessionStorage.getItem('token');
        let lang = sessionStorage.getItem('language');
        sessionStorage.clear();
        sessionStorage.setItem('tz', tz);
        sessionStorage.setItem('uid', uid);
        sessionStorage.setItem('userType', userType);
        sessionStorage.setItem('username', username);
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('language', lang);
    },

    //获取发送时间参数
    getTs(st, et) {
        let ts = [],
            k = 0;
        let days = parseInt((et - st) / 86400) + 1;
        for (let i = 0; i < days; i++) {
            ts[k] = [];
            ts[k][0] = st + i * 86400;
            ts[k][1] = st + (i + 1) * 86400;
            k++;
        }
        return ts;
    },
    getTs2(context, st, et) {
        let ts = [],
            days = (et - st) / 86400 + 1,
            k = 0;
        let No = this.chekcNoDate(context.weekmode);
        for (let i = 0; i < days; i++) {
            let day = new Date((st + i * 86400) * 1000).getDay();
            if (No.indexOf(day) === -1) {
                ts[k] = [];
                ts[k][0] = st + i * 86400;
                ts[k][1] = st + (i + 1) * 86400;
                k++;
            }
        }
        return ts;
    },
    chekcNoDate(weekmode) {
        let No = [],
            no = weekmode.split('');
        no.map(function(e, i) {
            if (e === 'n') {
                let d = i + 1;
                if (d > 6) {
                    d = 0;
                }
                No.push(d);
            }
        });
        return No;
    },

    //weekmode处理
    checkWeekMode(context) {
        /*初始化*/
        context.weekModeSp = [];
        context.weekM1 = false;
        context.weekM2 = false;
        let week = context.weekmode.split('');
        //console.log(week)
        week.map(function(e, i) {
            if (e === 'n') {
                context.weekModeSp[i] = true;
                if (i < 5) {
                    context.weekM1 = true;
                } else {
                    context.weekM2 = true;
                }
            } else {
                context.weekModeSp[i] = false;
            }
        });
        //console.log(context.weekModeSp,context.weekM1,context.weekM2)
    },

    open(url) {
        window.open(url, '_blank');
    },
    _open(url) {
        return function() {
            this.open(url);
        }
    },

    /*快速打印*/
    checkPrint(context, start, now) {
        let that = this;
        let report = JSON.parse(sessionStorage.getItem('Reports'));
        let length = report.length;
        document.onreadystatechange = function() {
            if (document.readyState === 'complete') {
                for (let i = start; i < length; i++) {
                    if (report[i] === 1) {
                        let key = 'qFirst' + now;
                        sessionStorage.setItem(key, 0);
                        let path = '/#/quickPrint' + i;
                        let open = window.open(path, '_blank');
                        if (open === null) {
                            context.$message.error('popup window intercepted');
                        }
                        break;
                    }
                }
            }
        }
    },

    _printPdf() {
        let that = this;
        return function() {
            that.print_page();
        }
    },
    print_page() {
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
            console.log('print_page.1');
            let hkey_root, hkey_path, hkey_key;
            hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
            try {
                let RegWsh = new ActiveXObject("WScript.Shell");
                RegWsh.RegWrite(hkey_path + "header", "");
                RegWsh.RegWrite(hkey_path + "footer", "");
            } catch (e) {}
        }
        console.log('print_page.2');
        window.print();
    },

    _getMonData1(context, info) {
        let that = this;
        return function() {
            that.getMonData1(context, info);
        }
    },


    /*登陆和语言选择, 正式用*/
    initLanguages(context) {
        context.hostname = window.location.hostname.split('.')[2];
        let href = window.location.href;
        let search = href.split('=')[1],
            info = [];

        /*正式版缓存判断在后，测试版则相反*/
        if (!search) {
            if (context.hostname === 'cn') {
                info = [1, 1];
            } else if (context.hostname === 'eu') {
                let countryIndex = localStorage.getItem('index'); //判断是否有语言缓存
                if (!countryIndex) {
                    info = [0, 0];
                } else {
                    let index = parseInt(countryIndex);
                    let index2 = parseInt(localStorage.getItem('languageIndex'));
                    info = [index, index2];
                }
            } else {
                info = [0, 0];
                // context.$store.commit('changLanguage',[0,0]);//对内网起作用，自动为localStorage设置languages字段；否则不选语言无该字段
            }
        } else {
            let index = 0;
            context.country.map(function(e, i) {
                if (e === search) {
                    index = i;
                }
            });
            if (search === 'DE') {
                index = 3;
            }
            info = [index, index];
        }

        info.push(1);
        context.$store.commit('changLanguage', info);
    },

    /*登陆和语言选择, 测试用，不跳转 */
    xx_initLanguages(context) {
        context.hostname = window.location.hostname.split('.')[2];
        let href = window.location.href;
        let search = href.split('=')[1],
            info = [];
        let countryIndex = localStorage.getItem('index'); //判断是否有语言缓存
        if (!countryIndex) {
            if (!search) {
                if (context.hostname === 'cn') {
                    info = [1, 1];
                } else if (context.hostname === 'eu') {
                    info = [0, 0];
                } else {
                    info = [0, 0];
                    // context.$store.commit('changLanguage',[0,0]);//对内网起作用，自动为localStorage设置languages字段；否则不选语言无该字段
                }
            } else {
                let index = 0;
                context.country.map(function(e, i) {
                    if (e === search) {
                        index = i;
                    }
                });
                if (search === 'DE') {
                    index = 3;
                }
                info = [index, index];
            }
        } else {
            let index = parseInt(countryIndex);
            let index2 = parseInt(localStorage.getItem('languageIndex'));
            info = [index, index2];
        }
        info.push(1);
        context.$store.commit('changLanguage', info);
    },

    changeServer(context, country, route) {
        //console.log(route);
        let index = 0;
        if (country !== 'DE') {
            context.country.map(function(e, i) {
                if (e === country) {
                    index = i;
                }
            });
        } else {
            index = 3;
        }
        let hostname = window.location.hostname.split('.')[2];
        let flag = 1;
        if (index === 1 && hostname !== 'cn') {
            window.location = 'https://easyview.medtrum.cn/#/' + route + '?country=' + country;
            flag = 0;
        }
        //为同步国家代号，同服务器也跳转
        else {
            window.location = 'https://easyview.medtrum.eu/#/' + route + '?country=' + country;
        }
        context.$store.commit('changLanguage', [index, index, flag]);
        //console.log(index);
    },

    getBrowserInfo() {
        let agent = navigator.userAgent.toLowerCase();
        console.log(agent);
        let regStr_ie = /msie [\d.]+;/gi;
        let regStr_ff = /firefox\/[\d.]+/gi
        let regStr_chrome = /chrome\/[\d.]+/gi;
        let regStr_saf = /safari\/[\d.]+/gi;
        let regStr_safVersion = /version\/[\d.]+/gi;
        let regStr_edge = /edge\/[\d.]+/gi;

        //IE
        if (agent.indexOf("msie") > 0) { return agent.match(regStr_ie); }

        // edge
        if (agent.indexOf("edge") > 0) { return agent.match(regStr_edge); }

        //firefox
        if (agent.indexOf("firefox") > 0) { return agent.match(regStr_ff); }
        //Chrome
        if (agent.indexOf("chrome") > 0) { return agent.match(regStr_chrome); }



        //Safari
        if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
            let bro = agent.match(regStr_saf)[0].split('/')[0];
            let ver = agent.match(regStr_safVersion)[0].split('/')[1];
            let user = bro + '/' + ver;
            return [user];
        }
    },
    checkBrowser(context) {
        let info = this.getBrowserInfo()[0].split('/');
        let browser = info[0];
        let version = info[1];
        console.log(info);
        sessionStorage.setItem('Browser', JSON.stringify(info));
        if (browser === 'chrome') {
            let flag = this.compareBrowser(version, '61.0');
            if (!flag) {
                context.$router.push('/error');
            }
        } else if (browser === 'edge') {
            let flag = this.compareBrowser(version, '16.0');
            if (!flag) {
                context.$router.push('/error');
            }
        } else if (browser === 'firefox') {
            let flag = this.compareBrowser(version, '55.0');
            if (!flag) {
                context.$router.push('/error');
            }
        } else if (browser === 'safari') {
            let flag = this.compareBrowser(version, '8.08');
            if (!flag) {
                context.$router.push('/error');
            }
        } else {
            context.$router.push('/error');
        }
    },
    compareBrowser(ver1, ver2) {
        let version1pre = parseFloat(ver1);
        let version2pre = parseFloat(ver2);
        let version1next = ver1.replace(version1pre + ".", "");
        let version2next = ver2.replace(version2pre + ".", "");
        if (version1pre > version2pre) {
            return true;
        } else if (version1pre < version2pre) {
            return false;
        } else {
            if (version1next >= version2next) {
                return true;
            } else {
                return false;
            }
        }
    },
    detectOS() {
        let sUserAgent = navigator.userAgent;
        let isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
        let isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
        if (isMac) return "Mac";
        if (isWin) {
            let isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
            if (isWin2K) return "Win2000";
            let isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
            if (isWinXP) return "WinXP";
            let isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
            if (isWin2003) return "Win2003";
            let isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
            if (isWinVista) return "WinVista";
            let isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
            if (isWin7) return "Windows 7";
            let isWin8 = sUserAgent.indexOf("Windows NT 6.2") > -1 || sUserAgent.indexOf("Windows 8") > -1;
            if (isWin8) return "Windows 8";
            let isWin8_1 = sUserAgent.indexOf("Windows NT 6.3") > -1 || sUserAgent.indexOf("Windows 8.1") > -1;
            if (isWin8_1) return "Windows 8.1";
            let isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
            if (isWin10) return "Windows 10";
        }
        return "other";
    },

    deviceSNFormat(device_sn) {

        function addPreZero(pdm_sn_hex, num) {
            let pre = '';
            for (let i = 0; i < num; i++) {
                pre += '0';
            }
            return pre + pdm_sn_hex;
        }

        let pdm_sn = parseInt(device_sn);
        console.log('deviceSNFormat:', device_sn, pdm_sn);
        //if (NaN == pdm_sn) {    // NaN 是不能用 == 判断的
        if (isNaN(pdm_sn)) {
            return device_sn;
        }

        //console.log('pdm_sn:', pdm_sn);
        if ((100000000 <= pdm_sn && pdm_sn <= 103999999) ||
            (106000000 <= pdm_sn && pdm_sn <= 108999999) ||
            (109000000 <= pdm_sn && pdm_sn <= 109999999) ||
            (112000000 <= pdm_sn && pdm_sn <= 112999999)) {
            //console.log('pdm_sn.1:');
            return pdm_sn;
        } else {
            let pdm_sn_hex = pdm_sn.toString(16); //.toUpperCase()
            let lackZeroDigit = 8 - pdm_sn_hex.length;
            pdm_sn_hex = addPreZero(pdm_sn_hex, lackZeroDigit);
            //console.log('pdm_sn.2:', pdm_sn, pdm_sn_hex);
            return pdm_sn_hex.toUpperCase();
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/js/auth.js